// Auto Generated, Don't Modify Manually
import * as decoders from 'decoders'
import { ArrayObjectDecoder } from './base'
import { optionalNullableDecoder } from './base'

export type TokenType = "Bearer"

export const TokenTypeDecoder: decoders.Decoder<TokenType> = decoders.constant("Bearer" as const)

export type AccessToken = string

export const AccessTokenDecoder: decoders.Decoder<AccessToken> = decoders.string

export type RefreshToken = string

export const RefreshTokenDecoder: decoders.Decoder<RefreshToken> = decoders.string

export type IDString = string

export const IDStringDecoder: decoders.Decoder<IDString> = decoders.either(decoders.number, decoders.string).transform(data => data.toString())

export type Stringable = string

export const StringableDecoder: decoders.Decoder<Stringable> = decoders.nullable(decoders.string).transform(str => str ?? '')

export type EnumValue = string | number

export const EnumValueDecoder: decoders.Decoder<EnumValue> = decoders.either(decoders.number, decoders.string).transform(data => data.toString())

export type EmailString = string

export const EmailStringDecoder: decoders.Decoder<EmailString> = decoders.string

export type SVGString = string

export const SVGStringDecoder: decoders.Decoder<SVGString> = decoders.string

export type URLString = string

export const URLStringDecoder: decoders.Decoder<URLString> = decoders.string

export type LanguageString = "ka" | "en"

export const LanguageStringDecoder: decoders.Decoder<LanguageString> = decoders.either(
  decoders.constant("ka" as const),
  decoders.constant("en" as const)
)

export interface MessageObject {
  readonly "message": string
}

export const MessageObjectDecoder: decoders.Decoder<MessageObject> = decoders.object({
  "message": decoders.string,
})

export interface SuccessResponse {
  readonly "success": boolean
}

export const SuccessResponseDecoder: decoders.Decoder<SuccessResponse> = decoders.object({
  "success": decoders.boolean,
})

export type MessageTypeEnum =
  | "MESSAGE_TYPE"
  | "RECOMMENDATION_TYPE"

export const MessageTypeEnumDecoder: decoders.Decoder<MessageTypeEnum> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 0: return "MESSAGE_TYPE"
      case 1: return "MESSAGE_TYPE"
      case 2: return "RECOMMENDATION_TYPE"
    }

    throw new Error(`Could not decode MessageTypeEnum from value: ${key}`)
  })
)

export function MessageTypeEnumEncoder (label: MessageTypeEnum): string | number {
  switch (label) {
    case "MESSAGE_TYPE": return 1
    case "RECOMMENDATION_TYPE": return 2
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const MessageTypeEnumValues = [
  "MESSAGE_TYPE",
  "RECOMMENDATION_TYPE",
] as const

export type BooleanEnum =
  | "true"
  | "false"

export const BooleanEnumDecoder: decoders.Decoder<BooleanEnum> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "true"
      case 0: return "false"
    }

    throw new Error(`Could not decode BooleanEnum from value: ${key}`)
  })
)

export function BooleanEnumEncoder (label: BooleanEnum): string | number {
  switch (label) {
    case "true": return 1
    case "false": return 0
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const BooleanEnumValues = [
  "true",
  "false",
] as const

export interface AuthObject {
  readonly "tokenType": TokenType
  readonly "expiresIn": number
  readonly "accessToken": AccessToken
  readonly "refreshToken": RefreshToken
}

export const AuthObjectDecoder: decoders.Decoder<AuthObject> = (
  decoders.object({
    attributes: decoders.object({
      "tokenType": TokenTypeDecoder,
      "expiresIn": decoders.number,
      "accessToken": AccessTokenDecoder,
      "refreshToken": RefreshTokenDecoder,
    }),
  })
  .transform(obj => {
    return {
      "tokenType": obj.attributes["tokenType"],
      "expiresIn": obj.attributes["expiresIn"],
      "accessToken": obj.attributes["accessToken"],
      "refreshToken": obj.attributes["refreshToken"],
    }
  })
)

export type GrantType = "internal" | "google_id_token" | "google_access_token" | "internal_refresh_token"

export const GrantTypeDecoder: decoders.Decoder<GrantType> = decoders.either(
  decoders.constant("internal" as const),
  decoders.constant("google_id_token" as const),
  decoders.constant("google_access_token" as const),
  decoders.constant("internal_refresh_token" as const)
)

export type StudentDegree =
  | "STUDENT_BACHELOR"
  | "STUDENT_MASTER"
  | "STUDENT_DOCTOR"
  | "STUDENT_PROFESSIONAL"
  | "STUDENT_PREPARATIONAL"
  | "STUDENT_FREE"
  | "STUDENT_PROFESSIONAL_3"
  | "STUDENT_PROFESSIONAL_4"
  | "STUDENT_PROFESSIONAL_5"
  | "STUDENT_FORCERTIFICATE"
  | "STUDENT_BACHELOR_MASTER"
  | "STUDENT_ONE_STAGE_HIGHER"
  | "STUDENT_ONE_STAGE_HIGHER_5_YEARS"
  | "STUDENT_ONE_STAGE_HIGHER_4_YEARS"
  | "STUDENT_ONE_STAGE_HIGHER_6_YEARS"

export const StudentDegreeDecoder: decoders.Decoder<StudentDegree> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "STUDENT_BACHELOR"
      case 2: return "STUDENT_MASTER"
      case 3: return "STUDENT_DOCTOR"
      case 4: return "STUDENT_PROFESSIONAL"
      case 5: return "STUDENT_PREPARATIONAL"
      case 6: return "STUDENT_FREE"
      case 7: return "STUDENT_PROFESSIONAL_3"
      case 8: return "STUDENT_PROFESSIONAL_4"
      case 9: return "STUDENT_PROFESSIONAL_5"
      case 10: return "STUDENT_FORCERTIFICATE"
      case 11: return "STUDENT_BACHELOR_MASTER"
      case 12: return "STUDENT_ONE_STAGE_HIGHER"
      case 13: return "STUDENT_ONE_STAGE_HIGHER_5_YEARS"
      case 14: return "STUDENT_ONE_STAGE_HIGHER_4_YEARS"
      case 15: return "STUDENT_ONE_STAGE_HIGHER_6_YEARS"
    }

    throw new Error(`Could not decode StudentDegree from value: ${key}`)
  })
)

export function StudentDegreeEncoder (label: StudentDegree): string | number {
  switch (label) {
    case "STUDENT_BACHELOR": return 1
    case "STUDENT_MASTER": return 2
    case "STUDENT_DOCTOR": return 3
    case "STUDENT_PROFESSIONAL": return 4
    case "STUDENT_PREPARATIONAL": return 5
    case "STUDENT_FREE": return 6
    case "STUDENT_PROFESSIONAL_3": return 7
    case "STUDENT_PROFESSIONAL_4": return 8
    case "STUDENT_PROFESSIONAL_5": return 9
    case "STUDENT_FORCERTIFICATE": return 10
    case "STUDENT_BACHELOR_MASTER": return 11
    case "STUDENT_ONE_STAGE_HIGHER": return 12
    case "STUDENT_ONE_STAGE_HIGHER_5_YEARS": return 13
    case "STUDENT_ONE_STAGE_HIGHER_4_YEARS": return 14
    case "STUDENT_ONE_STAGE_HIGHER_6_YEARS": return 15
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const StudentDegreeValues = [
  "STUDENT_BACHELOR",
  "STUDENT_MASTER",
  "STUDENT_DOCTOR",
  "STUDENT_PROFESSIONAL",
  "STUDENT_PREPARATIONAL",
  "STUDENT_FREE",
  "STUDENT_PROFESSIONAL_3",
  "STUDENT_PROFESSIONAL_4",
  "STUDENT_PROFESSIONAL_5",
  "STUDENT_FORCERTIFICATE",
  "STUDENT_BACHELOR_MASTER",
  "STUDENT_ONE_STAGE_HIGHER",
  "STUDENT_ONE_STAGE_HIGHER_5_YEARS",
  "STUDENT_ONE_STAGE_HIGHER_4_YEARS",
  "STUDENT_ONE_STAGE_HIGHER_6_YEARS",
] as const

export type LecturerDegree =
  | "LECTURER_PROFESSOR"
  | "LECTURER_ASSOC_PROFESSOR"
  | "LECTURER_ASSISTANT_PROFESSOR"
  | "LECTURER_INVITED_LECTURER"
  | "LECTURER_PROFESSOR_EMERITUS"
  | "LECTURER_RESP_PROFESSOR"
  | "LECTURER_ASSISTANT"
  | "LECTURER_COURSE_CURATOR"
  | "LECTURER_ACADEMIC_PERSONAL"
  | "LECTURER_TEACHER"

export const LecturerDegreeDecoder: decoders.Decoder<LecturerDegree> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "LECTURER_PROFESSOR"
      case 2: return "LECTURER_ASSOC_PROFESSOR"
      case 3: return "LECTURER_ASSISTANT_PROFESSOR"
      case 4: return "LECTURER_INVITED_LECTURER"
      case 5: return "LECTURER_PROFESSOR_EMERITUS"
      case 6: return "LECTURER_RESP_PROFESSOR"
      case 7: return "LECTURER_ASSISTANT"
      case 8: return "LECTURER_COURSE_CURATOR"
      case 9: return "LECTURER_ACADEMIC_PERSONAL"
      case 10: return "LECTURER_TEACHER"
    }

    throw new Error(`Could not decode LecturerDegree from value: ${key}`)
  })
)

export function LecturerDegreeEncoder (label: LecturerDegree): string | number {
  switch (label) {
    case "LECTURER_PROFESSOR": return 1
    case "LECTURER_ASSOC_PROFESSOR": return 2
    case "LECTURER_ASSISTANT_PROFESSOR": return 3
    case "LECTURER_INVITED_LECTURER": return 4
    case "LECTURER_PROFESSOR_EMERITUS": return 5
    case "LECTURER_RESP_PROFESSOR": return 6
    case "LECTURER_ASSISTANT": return 7
    case "LECTURER_COURSE_CURATOR": return 8
    case "LECTURER_ACADEMIC_PERSONAL": return 9
    case "LECTURER_TEACHER": return 10
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const LecturerDegreeValues = [
  "LECTURER_PROFESSOR",
  "LECTURER_ASSOC_PROFESSOR",
  "LECTURER_ASSISTANT_PROFESSOR",
  "LECTURER_INVITED_LECTURER",
  "LECTURER_PROFESSOR_EMERITUS",
  "LECTURER_RESP_PROFESSOR",
  "LECTURER_ASSISTANT",
  "LECTURER_COURSE_CURATOR",
  "LECTURER_ACADEMIC_PERSONAL",
  "LECTURER_TEACHER",
] as const

export type AdministratorDegree =
  | "ADMINISTRATOR_FACULTY_ADMINISTRATOR"
  | "ADMINISTRATOR_FACULTY_MODERATOR"
  | "ADMINISTRATOR_REGISTRAR"
  | "ADMINISTRATOR_MAIN_ADMINISTRATOR"
  | "SURVEY_ADMINISTRATOR"

export const AdministratorDegreeDecoder: decoders.Decoder<AdministratorDegree> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 3: return "ADMINISTRATOR_FACULTY_ADMINISTRATOR"
      case 4: return "ADMINISTRATOR_FACULTY_MODERATOR"
      case 55: return "ADMINISTRATOR_REGISTRAR"
      case 99: return "ADMINISTRATOR_MAIN_ADMINISTRATOR"
      case 111: return "SURVEY_ADMINISTRATOR"
    }

    throw new Error(`Could not decode AdministratorDegree from value: ${key}`)
  })
)

export function AdministratorDegreeEncoder (label: AdministratorDegree): string | number {
  switch (label) {
    case "ADMINISTRATOR_FACULTY_ADMINISTRATOR": return 3
    case "ADMINISTRATOR_FACULTY_MODERATOR": return 4
    case "ADMINISTRATOR_REGISTRAR": return 55
    case "ADMINISTRATOR_MAIN_ADMINISTRATOR": return 99
    case "SURVEY_ADMINISTRATOR": return 111
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const AdministratorDegreeValues = [
  "ADMINISTRATOR_FACULTY_ADMINISTRATOR",
  "ADMINISTRATOR_FACULTY_MODERATOR",
  "ADMINISTRATOR_REGISTRAR",
  "ADMINISTRATOR_MAIN_ADMINISTRATOR",
  "SURVEY_ADMINISTRATOR",
] as const

export type ResumeDocumentType =
  | "DIPLOMA"
  | "CERTIFICATE"

export const ResumeDocumentTypeDecoder: decoders.Decoder<ResumeDocumentType> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "DIPLOMA"
      case 2: return "CERTIFICATE"
    }

    throw new Error(`Could not decode ResumeDocumentType from value: ${key}`)
  })
)

export function ResumeDocumentTypeEncoder (label: ResumeDocumentType): string | number {
  switch (label) {
    case "DIPLOMA": return 1
    case "CERTIFICATE": return 2
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const ResumeDocumentTypeValues = [
  "DIPLOMA",
  "CERTIFICATE",
] as const

export type ResumeLanguageLevel =
  | "A1"
  | "A2"
  | "B1"
  | "B2"
  | "C1"
  | "C2"

export const ResumeLanguageLevelDecoder: decoders.Decoder<ResumeLanguageLevel> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "A1"
      case 2: return "A2"
      case 3: return "B1"
      case 4: return "B2"
      case 5: return "C1"
      case 6: return "C2"
    }

    throw new Error(`Could not decode ResumeLanguageLevel from value: ${key}`)
  })
)

export function ResumeLanguageLevelEncoder (label: ResumeLanguageLevel): string | number {
  switch (label) {
    case "A1": return 1
    case "A2": return 2
    case "B1": return 3
    case "B2": return 4
    case "C1": return 5
    case "C2": return 6
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const ResumeLanguageLevelValues = [
  "A1",
  "A2",
  "B1",
  "B2",
  "C1",
  "C2",
] as const

export type ChoiceStatusEnum =
  | "PASSED"
  | "CURRENT"
  | "FAILED"

export const ChoiceStatusEnumDecoder: decoders.Decoder<ChoiceStatusEnum> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "PASSED"
      case 2: return "CURRENT"
      case 3: return "FAILED"
    }

    throw new Error(`Could not decode ChoiceStatusEnum from value: ${key}`)
  })
)

export function ChoiceStatusEnumEncoder (label: ChoiceStatusEnum): string | number {
  switch (label) {
    case "PASSED": return 1
    case "CURRENT": return 2
    case "FAILED": return 3
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const ChoiceStatusEnumValues = [
  "PASSED",
  "CURRENT",
  "FAILED",
] as const

export type ChoiceTypeEnum =
  | "MANDATORY"
  | "MANDATORY_ELECTIVE"
  | "ELECTIVE"

export const ChoiceTypeEnumDecoder: decoders.Decoder<ChoiceTypeEnum> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "MANDATORY"
      case 2: return "MANDATORY_ELECTIVE"
      case 3: return "ELECTIVE"
    }

    throw new Error(`Could not decode ChoiceTypeEnum from value: ${key}`)
  })
)

export function ChoiceTypeEnumEncoder (label: ChoiceTypeEnum): string | number {
  switch (label) {
    case "MANDATORY": return 1
    case "MANDATORY_ELECTIVE": return 2
    case "ELECTIVE": return 3
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const ChoiceTypeEnumValues = [
  "MANDATORY",
  "MANDATORY_ELECTIVE",
  "ELECTIVE",
] as const

export type ChoiceAssignmentAction =
  | "ASSIGN_TO_PROGRAM"
  | "ASSIGN_TO_FREE_CREDITS"
  | "REMOVE_ASSIGNMENT"

export const ChoiceAssignmentActionDecoder: decoders.Decoder<ChoiceAssignmentAction> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case "assign_to_program": return "ASSIGN_TO_PROGRAM"
      case "assign_to_free_credits": return "ASSIGN_TO_FREE_CREDITS"
      case "remove_assignment": return "REMOVE_ASSIGNMENT"
    }

    throw new Error(`Could not decode ChoiceAssignmentAction from value: ${key}`)
  })
)

export function ChoiceAssignmentActionEncoder (label: ChoiceAssignmentAction): string | number {
  switch (label) {
    case "ASSIGN_TO_PROGRAM": return "assign_to_program"
    case "ASSIGN_TO_FREE_CREDITS": return "assign_to_free_credits"
    case "REMOVE_ASSIGNMENT": return "remove_assignment"
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const ChoiceAssignmentActionValues = [
  "ASSIGN_TO_PROGRAM",
  "ASSIGN_TO_FREE_CREDITS",
  "REMOVE_ASSIGNMENT",
] as const

export interface Program {
  readonly "id": IDString
  readonly "name": string
  readonly "code": string
  readonly "description": string
  readonly "minorDescription": string
  readonly "direction": string
  readonly "registrationRequirements": null | string
  readonly "totalCredits": number
  readonly "minorTotalCredits": number
  readonly "hasFreeCredits": boolean
  readonly "faculty"?: {
    readonly "id": IDString
    readonly "name": string
  }
}

export const ProgramDecoder: decoders.Decoder<Program> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "code": decoders.string,
      "description": decoders.string,
      "minorDescription": decoders.string,
      "direction": decoders.string,
      "registrationRequirements": decoders.nullable(decoders.string),
      "totalCredits": decoders.number,
      "minorTotalCredits": decoders.number,
      "hasFreeCredits": decoders.boolean,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "faculty": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder((
          decoders.object({
            "id": IDStringDecoder,
            attributes: decoders.object({
              "name": decoders.string,
            }),
          })
          .transform(obj => {
            return {
              "id": obj["id"],
              "name": obj.attributes["name"],
            }
          })
        ))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "code": obj.attributes["code"],
      "description": obj.attributes["description"],
      "minorDescription": obj.attributes["minorDescription"],
      "direction": obj.attributes["direction"],
      "registrationRequirements": obj.attributes["registrationRequirements"],
      "totalCredits": obj.attributes["totalCredits"],
      "minorTotalCredits": obj.attributes["minorTotalCredits"],
      "hasFreeCredits": obj.attributes["hasFreeCredits"],
      "faculty": obj?.relationships?.["faculty"]?.data,
    }
  })
)

export interface Faculty {
  readonly "id": IDString
  readonly "name": string
  readonly "programs"?: readonly Program[]
}

export const FacultyDecoder: decoders.Decoder<Faculty> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "programs": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(ProgramDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "programs": obj?.relationships?.["programs"]?.data,
    }
  })
)

export type AvailableCourseTabType =
  | "ALL"
  | "GENERAL"
  | "PROGRAM"
  | "FREE"
  | "OTHER_PROGRAMS"

export const AvailableCourseTabTypeDecoder: decoders.Decoder<AvailableCourseTabType> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case "courses_all": return "ALL"
      case "courses_general": return "GENERAL"
      case "program": return "PROGRAM"
      case "courses_free": return "FREE"
      case "other_programs": return "OTHER_PROGRAMS"
    }

    throw new Error(`Could not decode AvailableCourseTabType from value: ${key}`)
  })
)

export function AvailableCourseTabTypeEncoder (label: AvailableCourseTabType): string | number {
  switch (label) {
    case "ALL": return "courses_all"
    case "GENERAL": return "courses_general"
    case "PROGRAM": return "program"
    case "FREE": return "courses_free"
    case "OTHER_PROGRAMS": return "other_programs"
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const AvailableCourseTabTypeValues = [
  "ALL",
  "GENERAL",
  "PROGRAM",
  "FREE",
  "OTHER_PROGRAMS",
] as const

export type ResumeTab =
  | "personal"
  | "education"
  | "work"
  | "trainings"
  | "skills"
  | "additional"

export const ResumeTabDecoder: decoders.Decoder<ResumeTab> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case "TAB_PERSONAL": return "personal"
      case "TAB_EDUCATION": return "education"
      case "TAB_WORK": return "work"
      case "TAB_TRAININGS": return "trainings"
      case "TAB_SKILLS": return "skills"
      case "TAB_ADDITIONAL": return "additional"
    }

    throw new Error(`Could not decode ResumeTab from value: ${key}`)
  })
)

export function ResumeTabEncoder (label: ResumeTab): string | number {
  switch (label) {
    case "personal": return "TAB_PERSONAL"
    case "education": return "TAB_EDUCATION"
    case "work": return "TAB_WORK"
    case "trainings": return "TAB_TRAININGS"
    case "skills": return "TAB_SKILLS"
    case "additional": return "TAB_ADDITIONAL"
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const ResumeTabValues = [
  "personal",
  "education",
  "work",
  "trainings",
  "skills",
  "additional",
] as const

export interface MediaFile {
  readonly "id": IDString
  readonly "name": string
  readonly "title": string
  readonly "originalName": string
  readonly "mimeType": string
  readonly "size": number
  readonly "extension": string
  readonly "downloads": number
  readonly "downloadEndpoint": string
  readonly "isPublic": boolean
  readonly "createdAt": string
  readonly "author"?: User
}

export const MediaFileDecoder: decoders.Decoder<MediaFile> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "title": decoders.string,
      "originalName": decoders.string,
      "mimeType": decoders.string,
      "size": decoders.number,
      "extension": decoders.string,
      "downloads": decoders.number,
      "downloadEndpoint": decoders.string,
      "isPublic": decoders.boolean,
      "createdAt": decoders.string,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "author": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.lazy(() => UserDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "title": obj.attributes["title"],
      "originalName": obj.attributes["originalName"],
      "mimeType": obj.attributes["mimeType"],
      "size": obj.attributes["size"],
      "extension": obj.attributes["extension"],
      "downloads": obj.attributes["downloads"],
      "downloadEndpoint": obj.attributes["downloadEndpoint"],
      "isPublic": obj.attributes["isPublic"],
      "createdAt": obj.attributes["createdAt"],
      "author": obj?.relationships?.["author"]?.data,
    }
  })
)

export interface DownloadMediaFile {
  readonly "url": string
  readonly "expiresAt": null | string
  readonly "mediaFile": MediaFile
}

export const DownloadMediaFileDecoder: decoders.Decoder<DownloadMediaFile> = (
  decoders.object({
    attributes: decoders.object({
      "url": decoders.string,
      "expiresAt": decoders.nullable(decoders.string),
    }),
    relationships: decoders.object({
      "mediaFile": decoders.object({
        data: MediaFileDecoder
      }),
    }),
  })
  .transform(obj => {
    return {
      "url": obj.attributes["url"],
      "expiresAt": obj.attributes["expiresAt"],
      "mediaFile": obj.relationships["mediaFile"].data,
    }
  })
)

export interface GeneralSettings {
  readonly "locale": LanguageString
  readonly "showMail": boolean
}

export const GeneralSettingsDecoder: decoders.Decoder<GeneralSettings> = (
  decoders.object({
    attributes: decoders.object({
      "locale": LanguageStringDecoder,
      "showMail": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "locale": obj.attributes["locale"],
      "showMail": obj.attributes["showMail"],
    }
  })
)

export interface NotificationsData {
  readonly "mail": boolean
  readonly "sms": boolean
  readonly "push": boolean
}

export const NotificationsDataDecoder: decoders.Decoder<NotificationsData> = (
  decoders.object({
    attributes: decoders.object({
      "mail": decoders.boolean,
      "sms": decoders.boolean,
      "push": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "mail": obj.attributes["mail"],
      "sms": obj.attributes["sms"],
      "push": obj.attributes["push"],
    }
  })
)

export interface NotificationSettings {
  readonly "notifyOnMessageByEmail": boolean
  readonly "notifyOnMessageBySms": boolean
  readonly "notifyOnMessageByPush": boolean
  readonly "notifyOnLectureStartsByEmail": boolean
  readonly "notifyOnLectureStartsBySms": boolean
  readonly "notifyOnLectureStartsByPush": boolean
  readonly "notifyOnNewsAddByEmail": boolean
  readonly "notifyOnNewsAddByPush": boolean
  readonly "notifyOnNewsAddBySms": boolean
  readonly "notifyOnScoreSaveByEmail": boolean
  readonly "notifyOnScoreSaveBySms": boolean
  readonly "notifyOnScoreSaveByPush": boolean
  readonly "notifyOnMaterialAddByEmail": boolean
  readonly "notifyOnMaterialAddBySms": boolean
  readonly "notifyOnMaterialAddByPush": boolean
}

export const NotificationSettingsDecoder: decoders.Decoder<NotificationSettings> = (
  decoders.object({
    attributes: decoders.object({
      "notifyOnMessageByEmail": decoders.boolean,
      "notifyOnMessageBySms": decoders.boolean,
      "notifyOnMessageByPush": decoders.boolean,
      "notifyOnLectureStartsByEmail": decoders.boolean,
      "notifyOnLectureStartsBySms": decoders.boolean,
      "notifyOnLectureStartsByPush": decoders.boolean,
      "notifyOnNewsAddByEmail": decoders.boolean,
      "notifyOnNewsAddByPush": decoders.boolean,
      "notifyOnNewsAddBySms": decoders.boolean,
      "notifyOnScoreSaveByEmail": decoders.boolean,
      "notifyOnScoreSaveBySms": decoders.boolean,
      "notifyOnScoreSaveByPush": decoders.boolean,
      "notifyOnMaterialAddByEmail": decoders.boolean,
      "notifyOnMaterialAddBySms": decoders.boolean,
      "notifyOnMaterialAddByPush": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "notifyOnMessageByEmail": obj.attributes["notifyOnMessageByEmail"],
      "notifyOnMessageBySms": obj.attributes["notifyOnMessageBySms"],
      "notifyOnMessageByPush": obj.attributes["notifyOnMessageByPush"],
      "notifyOnLectureStartsByEmail": obj.attributes["notifyOnLectureStartsByEmail"],
      "notifyOnLectureStartsBySms": obj.attributes["notifyOnLectureStartsBySms"],
      "notifyOnLectureStartsByPush": obj.attributes["notifyOnLectureStartsByPush"],
      "notifyOnNewsAddByEmail": obj.attributes["notifyOnNewsAddByEmail"],
      "notifyOnNewsAddByPush": obj.attributes["notifyOnNewsAddByPush"],
      "notifyOnNewsAddBySms": obj.attributes["notifyOnNewsAddBySms"],
      "notifyOnScoreSaveByEmail": obj.attributes["notifyOnScoreSaveByEmail"],
      "notifyOnScoreSaveBySms": obj.attributes["notifyOnScoreSaveBySms"],
      "notifyOnScoreSaveByPush": obj.attributes["notifyOnScoreSaveByPush"],
      "notifyOnMaterialAddByEmail": obj.attributes["notifyOnMaterialAddByEmail"],
      "notifyOnMaterialAddBySms": obj.attributes["notifyOnMaterialAddBySms"],
      "notifyOnMaterialAddByPush": obj.attributes["notifyOnMaterialAddByPush"],
    }
  })
)

export interface NotificationsSaveRequest {
  readonly "notifyOnMessage": NotificationsData
  readonly "notifyOnLectureStarts": NotificationsData
  readonly "notifyOnScoreSave": NotificationsData
  readonly "notifyOnMaterialAdd": NotificationsData
}

export const NotificationsSaveRequestDecoder: decoders.Decoder<NotificationsSaveRequest> = decoders.object({
  "notifyOnMessage": NotificationsDataDecoder,
  "notifyOnLectureStarts": NotificationsDataDecoder,
  "notifyOnScoreSave": NotificationsDataDecoder,
  "notifyOnMaterialAdd": NotificationsDataDecoder,
})

export interface CourseMaterialsSaveRequest {
  readonly "semId": string
  readonly "title": string
  readonly "url"?: null | string
  readonly "fileUid"?: null | string
}

export const CourseMaterialsSaveRequestDecoder: decoders.Decoder<CourseMaterialsSaveRequest> = decoders.object({
  "semId": decoders.string,
  "title": decoders.string,
  "url": optionalNullableDecoder(decoders.nullable(decoders.string)),
  "fileUid": optionalNullableDecoder(decoders.nullable(decoders.string)),
})

export interface ExportFile {
  readonly "id": IDString
  readonly "downloadUrl": string
  readonly "name": string
  readonly "mimeType": string
  readonly "size": number
  readonly "extension": string
}

export const ExportFileDecoder: decoders.Decoder<ExportFile> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "downloadUrl": decoders.string,
      "name": decoders.string,
      "mimeType": decoders.string,
      "size": decoders.number,
      "extension": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "downloadUrl": obj.attributes["downloadUrl"],
      "name": obj.attributes["name"],
      "mimeType": obj.attributes["mimeType"],
      "size": obj.attributes["size"],
      "extension": obj.attributes["extension"],
    }
  })
)

export interface Permission {
  readonly "id": IDString
  readonly "entity": string
  readonly "entity_key": string
  readonly "entity_value": string
  readonly "action"?: string
}

export const PermissionDecoder: decoders.Decoder<Permission> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "entity": decoders.string,
      "entity_key": decoders.string,
      "entity_value": decoders.string,
      "action": optionalNullableDecoder(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "entity": obj.attributes["entity"],
      "entity_key": obj.attributes["entity_key"],
      "entity_value": obj.attributes["entity_value"],
      "action": obj.attributes["action"],
    }
  })
)

export interface AdministratorRole {
  readonly "id": number
  readonly "code": string
  readonly "name": string
}

export const AdministratorRoleDecoder: decoders.Decoder<AdministratorRole> = decoders.object({
  "id": decoders.number,
  "code": decoders.string,
  "name": decoders.string,
})

export type AdministratorRoleField = AdministratorRole | null | undefined

export const AdministratorRoleFieldDecoder: decoders.Decoder<AdministratorRoleField> = decoders.optional(decoders.nullable(AdministratorRoleDecoder))

export interface ProfileStatus {
  readonly "active": boolean
  readonly "message": null | string
}

export const ProfileStatusDecoder: decoders.Decoder<ProfileStatus> = (
  decoders.object({
    attributes: decoders.object({
      "active": decoders.boolean,
      "message": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "active": obj.attributes["active"],
      "message": obj.attributes["message"],
    }
  })
)

export interface UserProfileStudent {
  readonly "id": IDString
  readonly "type": "UserProfileStudent"
  readonly "degree": StudentDegree
  readonly "semester"?: number
  readonly "eduStatus"?: null | IDString
  readonly "chooseRegime"?: null | boolean
  readonly "profileStatus"?: ProfileStatus
  readonly "permissions"?: readonly Permission[]
}

export const UserProfileStudentDecoder: decoders.Decoder<UserProfileStudent> = (
  decoders.object({
    "id": IDStringDecoder,
    "type": decoders.constant("UserProfileStudent" as const),
    attributes: decoders.object({
      "degree": StudentDegreeDecoder,
      "semester": optionalNullableDecoder(decoders.number),
      "eduStatus": optionalNullableDecoder(decoders.nullable(IDStringDecoder)),
      "chooseRegime": optionalNullableDecoder(decoders.nullable(decoders.boolean)),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "profileStatus": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ProfileStatusDecoder)
      })),
      "permissions": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(PermissionDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "type": obj["type"],
      "degree": obj.attributes["degree"],
      "semester": obj.attributes["semester"],
      "eduStatus": obj.attributes["eduStatus"],
      "chooseRegime": obj.attributes["chooseRegime"],
      "profileStatus": obj?.relationships?.["profileStatus"]?.data,
      "permissions": obj?.relationships?.["permissions"]?.data,
    }
  })
)

export interface UserProfileLecturer {
  readonly "id": IDString
  readonly "type": "UserProfileLecturer"
  readonly "degree": LecturerDegree
  readonly "profileStatus"?: ProfileStatus
  readonly "permissions"?: readonly Permission[]
}

export const UserProfileLecturerDecoder: decoders.Decoder<UserProfileLecturer> = (
  decoders.object({
    "id": IDStringDecoder,
    "type": decoders.constant("UserProfileLecturer" as const),
    attributes: decoders.object({
      "degree": LecturerDegreeDecoder,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "profileStatus": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ProfileStatusDecoder)
      })),
      "permissions": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(PermissionDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "type": obj["type"],
      "degree": obj.attributes["degree"],
      "profileStatus": obj?.relationships?.["profileStatus"]?.data,
      "permissions": obj?.relationships?.["permissions"]?.data,
    }
  })
)

export interface UserProfileAdministrator {
  readonly "id": IDString
  readonly "type": "UserProfileAdministrator"
  readonly "degree": AdministratorDegree
  readonly "role": AdministratorRoleField
  readonly "profileStatus"?: ProfileStatus
  readonly "permissions"?: readonly Permission[]
}

export const UserProfileAdministratorDecoder: decoders.Decoder<UserProfileAdministrator> = (
  decoders.object({
    "id": IDStringDecoder,
    "type": decoders.constant("UserProfileAdministrator" as const),
    attributes: decoders.object({
      "degree": AdministratorDegreeDecoder,
      "role": AdministratorRoleFieldDecoder,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "profileStatus": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ProfileStatusDecoder)
      })),
      "permissions": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(PermissionDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "type": obj["type"],
      "degree": obj.attributes["degree"],
      "role": obj.attributes["role"],
      "profileStatus": obj?.relationships?.["profileStatus"]?.data,
      "permissions": obj?.relationships?.["permissions"]?.data,
    }
  })
)

export interface UserProfileStudentHistory {
  readonly "id": IDString
  readonly "type": "UserProfileStudentHistory"
  readonly "degree": StudentDegree
  readonly "semester"?: number
  readonly "eduStatus"?: null | IDString
  readonly "chooseRegime"?: null | boolean
  readonly "profileStatus"?: ProfileStatus
  readonly "permissions"?: readonly Permission[]
}

export const UserProfileStudentHistoryDecoder: decoders.Decoder<UserProfileStudentHistory> = (
  decoders.object({
    "id": IDStringDecoder,
    "type": decoders.constant("UserProfileStudentHistory" as const),
    attributes: decoders.object({
      "degree": StudentDegreeDecoder,
      "semester": optionalNullableDecoder(decoders.number),
      "eduStatus": optionalNullableDecoder(decoders.nullable(IDStringDecoder)),
      "chooseRegime": optionalNullableDecoder(decoders.nullable(decoders.boolean)),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "profileStatus": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ProfileStatusDecoder)
      })),
      "permissions": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(PermissionDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "type": obj["type"],
      "degree": obj.attributes["degree"],
      "semester": obj.attributes["semester"],
      "eduStatus": obj.attributes["eduStatus"],
      "chooseRegime": obj.attributes["chooseRegime"],
      "profileStatus": obj?.relationships?.["profileStatus"]?.data,
      "permissions": obj?.relationships?.["permissions"]?.data,
    }
  })
)

export type UserProfile = UserProfileAdministrator | UserProfileLecturer | UserProfileStudent | UserProfileStudentHistory

export const UserProfileDecoder: decoders.Decoder<UserProfile> = decoders.either(
  UserProfileAdministratorDecoder,
  UserProfileLecturerDecoder,
  UserProfileStudentDecoder,
  UserProfileStudentHistoryDecoder
)

export interface AuthUser {
  readonly "id": IDString
  readonly "uid": IDString
  readonly "firstName": string
  readonly "lastName": string
  readonly "fullName": string
  readonly "avatar": SVGString
  readonly "photoUrl": null | URLString
  readonly "personalNumber": string
  readonly "birthDate": null | string
  readonly "juridicalAddress": string
  readonly "actualAddress": string
  readonly "email": null | string
  readonly "emailPersonal": null | string
  readonly "gender": string
  readonly "mobileNumber": null | string
  readonly "mobileNumber2": null | string
  readonly "homeNumber": null | string
  readonly "profiles": readonly UserProfile[]
  readonly "emulatedBy"?: User
}

export const AuthUserDecoder: decoders.Decoder<AuthUser> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "uid": IDStringDecoder,
      "firstName": decoders.string,
      "lastName": decoders.string,
      "fullName": decoders.string,
      "avatar": SVGStringDecoder,
      "photoUrl": decoders.nullable(URLStringDecoder),
      "personalNumber": decoders.string,
      "birthDate": decoders.nullable(decoders.string),
      "juridicalAddress": decoders.string,
      "actualAddress": decoders.string,
      "email": decoders.nullable(decoders.string),
      "emailPersonal": decoders.nullable(decoders.string),
      "gender": decoders.string,
      "mobileNumber": decoders.nullable(decoders.string),
      "mobileNumber2": decoders.nullable(decoders.string),
      "homeNumber": decoders.nullable(decoders.string),
    }),
    relationships: decoders.object({
      "profiles": decoders.object({
        data: ArrayObjectDecoder(UserProfileDecoder)
      }),
      "emulatedBy": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.lazy(() => UserDecoder))
      })),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "uid": obj.attributes["uid"],
      "firstName": obj.attributes["firstName"],
      "lastName": obj.attributes["lastName"],
      "fullName": obj.attributes["fullName"],
      "avatar": obj.attributes["avatar"],
      "photoUrl": obj.attributes["photoUrl"],
      "personalNumber": obj.attributes["personalNumber"],
      "birthDate": obj.attributes["birthDate"],
      "juridicalAddress": obj.attributes["juridicalAddress"],
      "actualAddress": obj.attributes["actualAddress"],
      "email": obj.attributes["email"],
      "emailPersonal": obj.attributes["emailPersonal"],
      "gender": obj.attributes["gender"],
      "mobileNumber": obj.attributes["mobileNumber"],
      "mobileNumber2": obj.attributes["mobileNumber2"],
      "homeNumber": obj.attributes["homeNumber"],
      "profiles": obj.relationships["profiles"].data,
      "emulatedBy": obj?.relationships?.["emulatedBy"]?.data,
    }
  })
)

export interface Semester {
  readonly "id": IDString
  readonly "name": string
  readonly "isActive": boolean
  readonly "isLearning"?: boolean
  readonly "isFuture"?: boolean
}

export const SemesterDecoder: decoders.Decoder<Semester> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "isActive": decoders.boolean,
      "isLearning": optionalNullableDecoder(decoders.boolean),
      "isFuture": optionalNullableDecoder(decoders.boolean),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "isActive": obj.attributes["isActive"],
      "isLearning": obj.attributes["isLearning"],
      "isFuture": obj.attributes["isFuture"],
    }
  })
)

export interface ChooseCriteria {
  readonly "date_end": string
  readonly "date_start": string
  readonly "degree"?: readonly number[]
  readonly "fac_id"?: readonly number[]
  readonly "sem"?: readonly number[]
}

export const ChooseCriteriaDecoder: decoders.Decoder<ChooseCriteria> = decoders.object({
  "date_end": decoders.string,
  "date_start": decoders.string,
  "degree": optionalNullableDecoder(ArrayObjectDecoder(decoders.number)),
  "fac_id": optionalNullableDecoder(ArrayObjectDecoder(decoders.number)),
  "sem": optionalNullableDecoder(ArrayObjectDecoder(decoders.number)),
})

export type AllowLecturerEnum =
  | "ALLOWED"
  | "NOT_ALLOWED"
  | "PER_LECTURER"

export const AllowLecturerEnumDecoder: decoders.Decoder<AllowLecturerEnum> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "ALLOWED"
      case 2: return "NOT_ALLOWED"
      case 3: return "PER_LECTURER"
    }

    throw new Error(`Could not decode AllowLecturerEnum from value: ${key}`)
  })
)

export function AllowLecturerEnumEncoder (label: AllowLecturerEnum): string | number {
  switch (label) {
    case "ALLOWED": return 1
    case "NOT_ALLOWED": return 2
    case "PER_LECTURER": return 3
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const AllowLecturerEnumValues = [
  "ALLOWED",
  "NOT_ALLOWED",
  "PER_LECTURER",
] as const

export interface Regime {
  readonly "id": IDString
  readonly "name": string
  readonly "message": null | string
  readonly "chooseAllowed": boolean
  readonly "functionalIsLimited": boolean
  readonly "allowLecturerSurvey"?: AllowLecturerEnum
  readonly "allowLecturerScore"?: AllowLecturerEnum
}

export const RegimeDecoder: decoders.Decoder<Regime> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "message": decoders.nullable(decoders.string),
      "chooseAllowed": decoders.boolean,
      "functionalIsLimited": decoders.boolean,
      "allowLecturerSurvey": optionalNullableDecoder(AllowLecturerEnumDecoder),
      "allowLecturerScore": optionalNullableDecoder(AllowLecturerEnumDecoder),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "message": obj.attributes["message"],
      "chooseAllowed": obj.attributes["chooseAllowed"],
      "functionalIsLimited": obj.attributes["functionalIsLimited"],
      "allowLecturerSurvey": obj.attributes["allowLecturerSurvey"],
      "allowLecturerScore": obj.attributes["allowLecturerScore"],
    }
  })
)

export type UserTypeEnum =
  | "ADMINISTRATOR"
  | "LECTURER"
  | "STUDENT"

export const UserTypeEnumDecoder: decoders.Decoder<UserTypeEnum> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "ADMINISTRATOR"
      case 2: return "LECTURER"
      case 4: return "STUDENT"
    }

    throw new Error(`Could not decode UserTypeEnum from value: ${key}`)
  })
)

export function UserTypeEnumEncoder (label: UserTypeEnum): string | number {
  switch (label) {
    case "ADMINISTRATOR": return 1
    case "LECTURER": return 2
    case "STUDENT": return 4
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const UserTypeEnumValues = [
  "ADMINISTRATOR",
  "LECTURER",
  "STUDENT",
] as const

export interface AdministratorRegime {
  readonly "id": IDString
  readonly "name": string
  readonly "type": IDString
  readonly "showMessage": number
  readonly "allowLogin": IDString
  readonly "allowChoose": IDString
  readonly "schedule": IDString
  readonly "survey": IDString
  readonly "status": boolean
  readonly "message": null | string
  readonly "chooseAllowed": boolean
  readonly "limitFunctional": boolean
  readonly "chooseCriterias": readonly ChooseCriteria[]
  readonly "allowLecturerSurvey": IDString
  readonly "allowLecturerScore": IDString
}

export const AdministratorRegimeDecoder: decoders.Decoder<AdministratorRegime> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "type": IDStringDecoder,
      "showMessage": decoders.number,
      "allowLogin": IDStringDecoder,
      "allowChoose": IDStringDecoder,
      "schedule": IDStringDecoder,
      "survey": IDStringDecoder,
      "status": decoders.boolean,
      "message": decoders.nullable(decoders.string),
      "chooseAllowed": decoders.boolean,
      "limitFunctional": decoders.boolean,
      "chooseCriterias": ArrayObjectDecoder(ChooseCriteriaDecoder),
      "allowLecturerSurvey": IDStringDecoder,
      "allowLecturerScore": IDStringDecoder,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "type": obj.attributes["type"],
      "showMessage": obj.attributes["showMessage"],
      "allowLogin": obj.attributes["allowLogin"],
      "allowChoose": obj.attributes["allowChoose"],
      "schedule": obj.attributes["schedule"],
      "survey": obj.attributes["survey"],
      "status": obj.attributes["status"],
      "message": obj.attributes["message"],
      "chooseAllowed": obj.attributes["chooseAllowed"],
      "limitFunctional": obj.attributes["limitFunctional"],
      "chooseCriterias": obj.attributes["chooseCriterias"],
      "allowLecturerSurvey": obj.attributes["allowLecturerSurvey"],
      "allowLecturerScore": obj.attributes["allowLecturerScore"],
    }
  })
)

export interface RiskGroup {
  readonly "id": IDString
  readonly "type": number
  readonly "message": string
}

export const RiskGroupDecoder: decoders.Decoder<RiskGroup> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "type": decoders.number,
      "message": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "type": obj.attributes["type"],
      "message": obj.attributes["message"],
    }
  })
)

export interface MessageUnreadCount {
  readonly "count": number
}

export const MessageUnreadCountDecoder: decoders.Decoder<MessageUnreadCount> = (
  decoders.object({
    attributes: decoders.object({
      "count": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "count": obj.attributes["count"],
    }
  })
)

export interface SyllabusFile {
  readonly "title": string
  readonly "url": string
}

export const SyllabusFileDecoder: decoders.Decoder<SyllabusFile> = (
  decoders.object({
    attributes: decoders.object({
      "title": decoders.string,
      "url": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "title": obj.attributes["title"],
      "url": obj.attributes["url"],
    }
  })
)

export interface CourseSyllabusFile {
  readonly "id": IDString
  readonly "type": string
  readonly "createdAt": string
  readonly "downloads": number
  readonly "downloadEndpoint"?: string
  readonly "created_by"?: number
  readonly "extension": string
  readonly "iconClass": string
  readonly "isPublic": boolean
  readonly "mimeType": string
  readonly "name": string
  readonly "originalName": string
  readonly "size": number
  readonly "title": string
}

export const CourseSyllabusFileDecoder: decoders.Decoder<CourseSyllabusFile> = (
  decoders.object({
    "id": IDStringDecoder,
    "type": decoders.string,
    attributes: decoders.object({
      "createdAt": decoders.string,
      "downloads": decoders.number,
      "downloadEndpoint": optionalNullableDecoder(decoders.string),
      "created_by": optionalNullableDecoder(decoders.number),
      "extension": decoders.string,
      "iconClass": decoders.string,
      "isPublic": decoders.boolean,
      "mimeType": decoders.string,
      "name": decoders.string,
      "originalName": decoders.string,
      "size": decoders.number,
      "title": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "type": obj["type"],
      "createdAt": obj.attributes["createdAt"],
      "downloads": obj.attributes["downloads"],
      "downloadEndpoint": obj.attributes["downloadEndpoint"],
      "created_by": obj.attributes["created_by"],
      "extension": obj.attributes["extension"],
      "iconClass": obj.attributes["iconClass"],
      "isPublic": obj.attributes["isPublic"],
      "mimeType": obj.attributes["mimeType"],
      "name": obj.attributes["name"],
      "originalName": obj.attributes["originalName"],
      "size": obj.attributes["size"],
      "title": obj.attributes["title"],
    }
  })
)

export interface LecturerSyllabus {
  readonly "duration": null | string
  readonly "lecturers": string
  readonly "hours": string
  readonly "prerequisites": string
  readonly "methods": string
  readonly "mission": string
  readonly "topics": string
  readonly "outcomes": string
  readonly "evaluation": string
  readonly "resources": string
  readonly "otherResources": string
  readonly "schedule": string
  readonly "knowledge": boolean
  readonly "applying": boolean
  readonly "judgments": boolean
  readonly "communications": boolean
  readonly "learning": boolean
  readonly "values": boolean
  readonly "syllabusFile"?: CourseSyllabusFile
}

export const LecturerSyllabusDecoder: decoders.Decoder<LecturerSyllabus> = (
  decoders.object({
    attributes: decoders.object({
      "duration": decoders.nullable(decoders.string),
      "lecturers": decoders.string,
      "hours": decoders.string,
      "prerequisites": decoders.string,
      "methods": decoders.string,
      "mission": decoders.string,
      "topics": decoders.string,
      "outcomes": decoders.string,
      "evaluation": decoders.string,
      "resources": decoders.string,
      "otherResources": decoders.string,
      "schedule": decoders.string,
      "knowledge": decoders.boolean,
      "applying": decoders.boolean,
      "judgments": decoders.boolean,
      "communications": decoders.boolean,
      "learning": decoders.boolean,
      "values": decoders.boolean,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "syllabusFile": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(CourseSyllabusFileDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "duration": obj.attributes["duration"],
      "lecturers": obj.attributes["lecturers"],
      "hours": obj.attributes["hours"],
      "prerequisites": obj.attributes["prerequisites"],
      "methods": obj.attributes["methods"],
      "mission": obj.attributes["mission"],
      "topics": obj.attributes["topics"],
      "outcomes": obj.attributes["outcomes"],
      "evaluation": obj.attributes["evaluation"],
      "resources": obj.attributes["resources"],
      "otherResources": obj.attributes["otherResources"],
      "schedule": obj.attributes["schedule"],
      "knowledge": obj.attributes["knowledge"],
      "applying": obj.attributes["applying"],
      "judgments": obj.attributes["judgments"],
      "communications": obj.attributes["communications"],
      "learning": obj.attributes["learning"],
      "values": obj.attributes["values"],
      "syllabusFile": obj?.relationships?.["syllabusFile"]?.data,
    }
  })
)

export interface CourseChoiceType {
  readonly "type": ChoiceTypeEnum
}

export const CourseChoiceTypeDecoder: decoders.Decoder<CourseChoiceType> = (
  decoders.object({
    attributes: decoders.object({
      "type": ChoiceTypeEnumDecoder,
    }),
  })
  .transform(obj => {
    return {
      "type": obj.attributes["type"],
    }
  })
)

export interface FinalScore {
  readonly "finalScore": number
  readonly "credits": number
}

export const FinalScoreDecoder: decoders.Decoder<FinalScore> = (
  decoders.object({
    attributes: decoders.object({
      "finalScore": decoders.number,
      "credits": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "finalScore": obj.attributes["finalScore"],
      "credits": obj.attributes["credits"],
    }
  })
)

export interface Course {
  readonly "id": IDString
  readonly "name": string
  readonly "fullName": string
  readonly "degree": StudentDegree
  readonly "groupName": string
  readonly "code": string
  readonly "programCode": string
  readonly "credits": number
  readonly "isEnabledForChoose": boolean
  readonly "isGeneral": boolean
  readonly "syllabus"?: LecturerSyllabus
  readonly "faculty"?: Faculty
  readonly "courseChoiceType"?: CourseChoiceType
}

export const CourseDecoder: decoders.Decoder<Course> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "fullName": decoders.string,
      "degree": StudentDegreeDecoder,
      "groupName": decoders.string,
      "code": decoders.string,
      "programCode": decoders.string,
      "credits": decoders.number,
      "isEnabledForChoose": decoders.boolean,
      "isGeneral": decoders.boolean,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "syllabus": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(LecturerSyllabusDecoder)
      })),
      "faculty": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(FacultyDecoder)
      })),
      "courseChoiceType": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(CourseChoiceTypeDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "fullName": obj.attributes["fullName"],
      "degree": obj.attributes["degree"],
      "groupName": obj.attributes["groupName"],
      "code": obj.attributes["code"],
      "programCode": obj.attributes["programCode"],
      "credits": obj.attributes["credits"],
      "isEnabledForChoose": obj.attributes["isEnabledForChoose"],
      "isGeneral": obj.attributes["isGeneral"],
      "syllabus": obj?.relationships?.["syllabus"]?.data,
      "faculty": obj?.relationships?.["faculty"]?.data,
      "courseChoiceType": obj?.relationships?.["courseChoiceType"]?.data,
    }
  })
)

export interface CourseScore {
  readonly "criteria": string
  readonly "score": null | number
}

export const CourseScoreDecoder: decoders.Decoder<CourseScore> = (
  decoders.object({
    attributes: decoders.object({
      "criteria": decoders.string,
      "score": decoders.nullable(decoders.number),
    }),
  })
  .transform(obj => {
    return {
      "criteria": obj.attributes["criteria"],
      "score": obj.attributes["score"],
    }
  })
)

export interface ChoiceStatus {
  readonly "canChoose": boolean
  readonly "canRemoveChoice": boolean
  readonly "canRechoose": boolean
  readonly "canRemoveRechoose": boolean
  readonly "isScheduleInConflict": boolean
  readonly "isChosen": boolean
  readonly "chooseError": null | string
  readonly "removeChoiceError": null | string
  readonly "rechooseError": null | string
  readonly "scheduleConflictMessage": null | string
}

export const ChoiceStatusDecoder: decoders.Decoder<ChoiceStatus> = (
  decoders.object({
    attributes: decoders.object({
      "canChoose": decoders.boolean,
      "canRemoveChoice": decoders.boolean,
      "canRechoose": decoders.boolean,
      "canRemoveRechoose": decoders.boolean,
      "isScheduleInConflict": decoders.boolean,
      "isChosen": decoders.boolean,
      "chooseError": decoders.nullable(decoders.string),
      "removeChoiceError": decoders.nullable(decoders.string),
      "rechooseError": decoders.nullable(decoders.string),
      "scheduleConflictMessage": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "canChoose": obj.attributes["canChoose"],
      "canRemoveChoice": obj.attributes["canRemoveChoice"],
      "canRechoose": obj.attributes["canRechoose"],
      "canRemoveRechoose": obj.attributes["canRemoveRechoose"],
      "isScheduleInConflict": obj.attributes["isScheduleInConflict"],
      "isChosen": obj.attributes["isChosen"],
      "chooseError": obj.attributes["chooseError"],
      "removeChoiceError": obj.attributes["removeChoiceError"],
      "rechooseError": obj.attributes["rechooseError"],
      "scheduleConflictMessage": obj.attributes["scheduleConflictMessage"],
    }
  })
)

export interface ManageSyllabus {
  readonly "canEdit": boolean
}

export const ManageSyllabusDecoder: decoders.Decoder<ManageSyllabus> = (
  decoders.object({
    attributes: decoders.object({
      "canEdit": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "canEdit": obj.attributes["canEdit"],
    }
  })
)

export interface CoursePaperCriteria {
  readonly "id": IDString
  readonly "name": string
  readonly "acr": string
  readonly "maxPossible": number
  readonly "type": number
}

export const CoursePaperCriteriaDecoder: decoders.Decoder<CoursePaperCriteria> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "acr": decoders.string,
      "maxPossible": decoders.number,
      "type": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "acr": obj.attributes["acr"],
      "maxPossible": obj.attributes["maxPossible"],
      "type": obj.attributes["type"],
    }
  })
)

export interface PaperCriteria {
  readonly "id": IDString
  readonly "fullName": string
  readonly "acr": string
  readonly "max": number
  readonly "min": number
  readonly "canEdit": boolean
  readonly "type": number
  readonly "deadline"?: null | string
}

export const PaperCriteriaDecoder: decoders.Decoder<PaperCriteria> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "fullName": decoders.string,
      "acr": decoders.string,
      "max": decoders.number,
      "min": decoders.number,
      "canEdit": decoders.boolean,
      "type": decoders.number,
      "deadline": optionalNullableDecoder(decoders.nullable(decoders.string)),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "fullName": obj.attributes["fullName"],
      "acr": obj.attributes["acr"],
      "max": obj.attributes["max"],
      "min": obj.attributes["min"],
      "canEdit": obj.attributes["canEdit"],
      "type": obj.attributes["type"],
      "deadline": obj.attributes["deadline"],
    }
  })
)

export interface SavePaperCriteria {
  readonly "criteriaId": string
  readonly "min": number
  readonly "max": number
}

export const SavePaperCriteriaDecoder: decoders.Decoder<SavePaperCriteria> = decoders.object({
  "criteriaId": decoders.string,
  "min": decoders.number,
  "max": decoders.number,
})

export interface ScoreEvaluation {
  readonly "competencyId": {
    readonly "criterias": {
      readonly "criteriaId": {
        readonly "score": string
        readonly "feedback": string
      }
    }
  }
}

export const ScoreEvaluationDecoder: decoders.Decoder<ScoreEvaluation> = (
  decoders.object({
    attributes: decoders.object({
      "competencyId": (
        decoders.object({
          attributes: decoders.object({
            "criterias": (
              decoders.object({
                attributes: decoders.object({
                  "criteriaId": (
                    decoders.object({
                      attributes: decoders.object({
                        "score": decoders.string,
                        "feedback": decoders.string,
                      }),
                    })
                    .transform(obj => {
                      return {
                        "score": obj.attributes["score"],
                        "feedback": obj.attributes["feedback"],
                      }
                    })
                  ),
                }),
              })
              .transform(obj => {
                return {
                  "criteriaId": obj.attributes["criteriaId"],
                }
              })
            ),
          }),
        })
        .transform(obj => {
          return {
            "criterias": obj.attributes["criterias"],
          }
        })
      ),
    }),
  })
  .transform(obj => {
    return {
      "competencyId": obj.attributes["competencyId"],
    }
  })
)

export interface Paper {
  readonly "id": IDString
  readonly "name": string
  readonly "active": boolean
  readonly "intermediateScoreLimit": number
  readonly "criterions"?: readonly PaperCriteria[]
  readonly "manage"?: ManageSyllabus
}

export const PaperDecoder: decoders.Decoder<Paper> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "active": decoders.boolean,
      "intermediateScoreLimit": decoders.number,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "criterions": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(PaperCriteriaDecoder))
      })),
      "manage": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ManageSyllabusDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "active": obj.attributes["active"],
      "intermediateScoreLimit": obj.attributes["intermediateScoreLimit"],
      "criterions": obj?.relationships?.["criterions"]?.data,
      "manage": obj?.relationships?.["manage"]?.data,
    }
  })
)

export interface Group {
  readonly "id": IDString
  readonly "name": string
  readonly "maxQuota": number
  readonly "lecturers"?: readonly User[]
  readonly "course"?: Course
  readonly "choiceStatus"?: ChoiceStatus
  readonly "paper"?: Paper
  readonly "choiceCount"?: {
    readonly "count": number
  }
}

export const GroupDecoder: decoders.Decoder<Group> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "maxQuota": decoders.number,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "lecturers": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(decoders.lazy(() => UserDecoder)))
      })),
      "course": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(CourseDecoder)
      })),
      "choiceStatus": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ChoiceStatusDecoder)
      })),
      "paper": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(PaperDecoder)
      })),
      "choiceCount": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder((
          decoders.object({
            attributes: decoders.object({
              "count": decoders.number,
            }),
          })
          .transform(obj => {
            return {
              "count": obj.attributes["count"],
            }
          })
        ))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "maxQuota": obj.attributes["maxQuota"],
      "lecturers": obj?.relationships?.["lecturers"]?.data,
      "course": obj?.relationships?.["course"]?.data,
      "choiceStatus": obj?.relationships?.["choiceStatus"]?.data,
      "paper": obj?.relationships?.["paper"]?.data,
      "choiceCount": obj?.relationships?.["choiceCount"]?.data,
    }
  })
)

export interface GroupSchedule {
  readonly "id": null | IDString
  readonly "day": string
  readonly "date": string
  readonly "startTime": string
  readonly "endTime": string
  readonly "locationName": null | string
  readonly "info": null | string
  readonly "lectureType": null | string
  readonly "lectureFormat": null | string
  readonly "scheduleConflictMessage": null | string
  readonly "lecturers"?: readonly User[]
}

export const GroupScheduleDecoder: decoders.Decoder<GroupSchedule> = (
  decoders.object({
    "id": decoders.nullable(IDStringDecoder),
    attributes: decoders.object({
      "day": decoders.string,
      "date": decoders.string,
      "startTime": decoders.string,
      "endTime": decoders.string,
      "locationName": decoders.nullable(decoders.string),
      "info": decoders.nullable(decoders.string),
      "lectureType": decoders.nullable(decoders.string),
      "lectureFormat": decoders.nullable(decoders.string),
      "scheduleConflictMessage": decoders.nullable(decoders.string),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "lecturers": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(decoders.lazy(() => UserDecoder)))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "day": obj.attributes["day"],
      "date": obj.attributes["date"],
      "startTime": obj.attributes["startTime"],
      "endTime": obj.attributes["endTime"],
      "locationName": obj.attributes["locationName"],
      "info": obj.attributes["info"],
      "lectureType": obj.attributes["lectureType"],
      "lectureFormat": obj.attributes["lectureFormat"],
      "scheduleConflictMessage": obj.attributes["scheduleConflictMessage"],
      "lecturers": obj?.relationships?.["lecturers"]?.data,
    }
  })
)

export interface ChoiceAssignmentStatus {
  readonly "programId": null | IDString
  readonly "programName": null | string
  readonly "action": ChoiceAssignmentAction
}

export const ChoiceAssignmentStatusDecoder: decoders.Decoder<ChoiceAssignmentStatus> = (
  decoders.object({
    attributes: decoders.object({
      "programId": decoders.nullable(IDStringDecoder),
      "programName": decoders.nullable(decoders.string),
      "action": ChoiceAssignmentActionDecoder,
    }),
  })
  .transform(obj => {
    return {
      "programId": obj.attributes["programId"],
      "programName": obj.attributes["programName"],
      "action": obj.attributes["action"],
    }
  })
)

export interface Choice {
  readonly "id": IDString
  readonly "credits": number
  readonly "score": number
  readonly "isLatChoice": boolean
  readonly "latScore": string
  readonly "courseName": string
  readonly "courseCode": string
  readonly "courseCredits": number
  readonly "isGeneral": boolean
  readonly "creditType": string
  readonly "status": ChoiceStatusEnum
  readonly "course"?: Course
  readonly "group"?: Group
  readonly "scores"?: readonly CourseScore[]
  readonly "courseChoiceType"?: CourseChoiceType
  readonly "assignmentStatuses"?: readonly ChoiceAssignmentStatus[]
}

export const ChoiceDecoder: decoders.Decoder<Choice> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "credits": decoders.number,
      "score": decoders.number,
      "isLatChoice": decoders.boolean,
      "latScore": decoders.string,
      "courseName": decoders.string,
      "courseCode": decoders.string,
      "courseCredits": decoders.number,
      "isGeneral": decoders.boolean,
      "creditType": decoders.string,
      "status": ChoiceStatusEnumDecoder,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "course": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(CourseDecoder)
      })),
      "group": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(GroupDecoder)
      })),
      "scores": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(CourseScoreDecoder))
      })),
      "courseChoiceType": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(CourseChoiceTypeDecoder)
      })),
      "assignmentStatuses": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(ChoiceAssignmentStatusDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "credits": obj.attributes["credits"],
      "score": obj.attributes["score"],
      "isLatChoice": obj.attributes["isLatChoice"],
      "latScore": obj.attributes["latScore"],
      "courseName": obj.attributes["courseName"],
      "courseCode": obj.attributes["courseCode"],
      "courseCredits": obj.attributes["courseCredits"],
      "isGeneral": obj.attributes["isGeneral"],
      "creditType": obj.attributes["creditType"],
      "status": obj.attributes["status"],
      "course": obj?.relationships?.["course"]?.data,
      "group": obj?.relationships?.["group"]?.data,
      "scores": obj?.relationships?.["scores"]?.data,
      "courseChoiceType": obj?.relationships?.["courseChoiceType"]?.data,
      "assignmentStatuses": obj?.relationships?.["assignmentStatuses"]?.data,
    }
  })
)

export interface LibraryBook {
  readonly "id": IDString
  readonly "barcode": string
  readonly "author": string
  readonly "title": string
  readonly "place": string
  readonly "takenAt": string
  readonly "returnedAt": string
  readonly "isOverdue": boolean
}

export const LibraryBookDecoder: decoders.Decoder<LibraryBook> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "barcode": decoders.string,
      "author": decoders.string,
      "title": decoders.string,
      "place": decoders.string,
      "takenAt": decoders.string,
      "returnedAt": decoders.string,
      "isOverdue": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "barcode": obj.attributes["barcode"],
      "author": obj.attributes["author"],
      "title": obj.attributes["title"],
      "place": obj.attributes["place"],
      "takenAt": obj.attributes["takenAt"],
      "returnedAt": obj.attributes["returnedAt"],
      "isOverdue": obj.attributes["isOverdue"],
    }
  })
)

export interface LibraryBooksTaken {
  readonly "overdue": number
  readonly "total": number
}

export const LibraryBooksTakenDecoder: decoders.Decoder<LibraryBooksTaken> = (
  decoders.object({
    attributes: decoders.object({
      "overdue": decoders.number,
      "total": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "overdue": obj.attributes["overdue"],
      "total": obj.attributes["total"],
    }
  })
)

export interface BillingContractObligation {
  readonly "amount": string
  readonly "distributedAmount": string
  readonly "distributedPenalty": string
  readonly "totalAmount": string
  readonly "date": string
}

export const BillingContractObligationDecoder: decoders.Decoder<BillingContractObligation> = (
  decoders.object({
    attributes: decoders.object({
      "amount": decoders.string,
      "distributedAmount": decoders.string,
      "distributedPenalty": decoders.string,
      "totalAmount": decoders.string,
      "date": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "amount": obj.attributes["amount"],
      "distributedAmount": obj.attributes["distributedAmount"],
      "distributedPenalty": obj.attributes["distributedPenalty"],
      "totalAmount": obj.attributes["totalAmount"],
      "date": obj.attributes["date"],
    }
  })
)

export interface BillingContract {
  readonly "name": string
  readonly "type": string
  readonly "obligations": readonly BillingContractObligation[]
}

export const BillingContractDecoder: decoders.Decoder<BillingContract> = (
  decoders.object({
    attributes: decoders.object({
      "name": decoders.string,
      "type": decoders.string,
    }),
    relationships: decoders.object({
      "obligations": decoders.object({
        data: ArrayObjectDecoder(BillingContractObligationDecoder)
      }),
    }),
  })
  .transform(obj => {
    return {
      "name": obj.attributes["name"],
      "type": obj.attributes["type"],
      "obligations": obj.relationships["obligations"].data,
    }
  })
)

export interface BillingSchedule {
  readonly "semesterName": string
  readonly "contracts": readonly BillingContract[]
}

export const BillingScheduleDecoder: decoders.Decoder<BillingSchedule> = (
  decoders.object({
    attributes: decoders.object({
      "semesterName": decoders.string,
    }),
    relationships: decoders.object({
      "contracts": decoders.object({
        data: ArrayObjectDecoder(BillingContractDecoder)
      }),
    }),
  })
  .transform(obj => {
    return {
      "semesterName": obj.attributes["semesterName"],
      "contracts": obj.relationships["contracts"].data,
    }
  })
)

export interface BillingDeposit {
  readonly "facultyName": string
  readonly "amount": string
  readonly "date": string
}

export const BillingDepositDecoder: decoders.Decoder<BillingDeposit> = (
  decoders.object({
    attributes: decoders.object({
      "facultyName": decoders.string,
      "amount": decoders.string,
      "date": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "facultyName": obj.attributes["facultyName"],
      "amount": obj.attributes["amount"],
      "date": obj.attributes["date"],
    }
  })
)

export interface BillingBalance {
  readonly "balance": number
  readonly "updatedAt": null | string
}

export const BillingBalanceDecoder: decoders.Decoder<BillingBalance> = (
  decoders.object({
    attributes: decoders.object({
      "balance": decoders.number,
      "updatedAt": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "balance": obj.attributes["balance"],
      "updatedAt": obj.attributes["updatedAt"],
    }
  })
)

export interface PaymentInstruction {
  readonly "html": string
}

export const PaymentInstructionDecoder: decoders.Decoder<PaymentInstruction> = (
  decoders.object({
    attributes: decoders.object({
      "html": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "html": obj.attributes["html"],
    }
  })
)

export interface Pagination {
  readonly "total": number
  readonly "count": number
  readonly "perPage": number
  readonly "currentPage": number
  readonly "totalPages": number
  readonly "links": {
    readonly "next": null | string
    readonly "previous": null | string
  }
}

export const PaginationDecoder: decoders.Decoder<Pagination> = decoders.object({
  "total": decoders.number,
  "count": decoders.number,
  "perPage": decoders.number,
  "currentPage": decoders.number,
  "totalPages": decoders.number,
  "links": decoders.object({
    "next": decoders.nullable(decoders.string),
    "previous": decoders.nullable(decoders.string),
  }),
})

export interface AuthLog {
  readonly "id": IDString
  readonly "ip": string
  readonly "userAgent": string
  readonly "createdAt": string
}

export const AuthLogDecoder: decoders.Decoder<AuthLog> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "ip": decoders.string,
      "userAgent": decoders.string,
      "createdAt": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "ip": obj.attributes["ip"],
      "userAgent": obj.attributes["userAgent"],
      "createdAt": obj.attributes["createdAt"],
    }
  })
)

export interface StudentScore {
  readonly "criteriaId": number
  readonly "score": null | number
}

export const StudentScoreDecoder: decoders.Decoder<StudentScore> = (
  decoders.object({
    attributes: decoders.object({
      "criteriaId": decoders.number,
      "score": decoders.nullable(decoders.number),
    }),
  })
  .transform(obj => {
    return {
      "criteriaId": obj.attributes["criteriaId"],
      "score": obj.attributes["score"],
    }
  })
)

export interface PortfolioMentorManage {
  readonly "canChoose"?: boolean
  readonly "canEmulate"?: boolean
}

export const PortfolioMentorManageDecoder: decoders.Decoder<PortfolioMentorManage> = (
  decoders.object({
    attributes: decoders.object({
      "canChoose": optionalNullableDecoder(decoders.boolean),
      "canEmulate": optionalNullableDecoder(decoders.boolean),
    }),
  })
  .transform(obj => {
    return {
      "canChoose": obj.attributes["canChoose"],
      "canEmulate": obj.attributes["canEmulate"],
    }
  })
)

export interface ManageSection {
  readonly "canSubmitWork": boolean
}

export const ManageSectionDecoder: decoders.Decoder<ManageSection> = (
  decoders.object({
    attributes: decoders.object({
      "canSubmitWork": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "canSubmitWork": obj.attributes["canSubmitWork"],
    }
  })
)

export interface ManageWork {
  readonly "canEditWork": boolean
  readonly "canSaveAsDraft": boolean
}

export const ManageWorkDecoder: decoders.Decoder<ManageWork> = (
  decoders.object({
    attributes: decoders.object({
      "canEditWork": decoders.boolean,
      "canSaveAsDraft": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "canEditWork": obj.attributes["canEditWork"],
      "canSaveAsDraft": obj.attributes["canSaveAsDraft"],
    }
  })
)

export interface MentorWorkManage {
  readonly "canRejectWork": boolean
  readonly "canSubmitScore": boolean
}

export const MentorWorkManageDecoder: decoders.Decoder<MentorWorkManage> = (
  decoders.object({
    attributes: decoders.object({
      "canRejectWork": decoders.boolean,
      "canSubmitScore": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "canRejectWork": obj.attributes["canRejectWork"],
      "canSubmitScore": obj.attributes["canSubmitScore"],
    }
  })
)

export interface ProfileForMessageView {
  readonly "type": string
  readonly "id": IDString
  readonly "degree": StudentDegree
  readonly "semester": number
}

export const ProfileForMessageViewDecoder: decoders.Decoder<ProfileForMessageView> = (
  decoders.object({
    "type": decoders.string,
    "id": IDStringDecoder,
    attributes: decoders.object({
      "degree": StudentDegreeDecoder,
      "semester": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "type": obj["type"],
      "id": obj["id"],
      "degree": obj.attributes["degree"],
      "semester": obj.attributes["semester"],
    }
  })
)

export interface User {
  readonly "id": IDString
  readonly "uid": string
  readonly "email": null | string
  readonly "emailPersonal"?: null | string
  readonly "gender": null | string
  readonly "firstName": string
  readonly "lastName": string
  readonly "fullName": string
  readonly "avatar": string
  readonly "photoUrl": null | string
  readonly "mobileNumber": null | string
  readonly "mobileNumber2": null | string
  readonly "homeNumber": null | string
  readonly "profiles"?: readonly UserProfile[]
  readonly "group"?: Group
  readonly "scores"?: readonly StudentScore[]
  readonly "profileForMessageView"?: ProfileForMessageView
  readonly "manage"?: PortfolioMentorManage
}

export const UserDecoder: decoders.Decoder<User> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "uid": decoders.string,
      "email": decoders.nullable(decoders.string),
      "emailPersonal": optionalNullableDecoder(decoders.nullable(decoders.string)),
      "gender": decoders.nullable(decoders.string),
      "firstName": decoders.string,
      "lastName": decoders.string,
      "fullName": decoders.string,
      "avatar": decoders.string,
      "photoUrl": decoders.nullable(decoders.string),
      "mobileNumber": decoders.nullable(decoders.string),
      "mobileNumber2": decoders.nullable(decoders.string),
      "homeNumber": decoders.nullable(decoders.string),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "profiles": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(UserProfileDecoder))
      })),
      "group": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(GroupDecoder)
      })),
      "scores": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(StudentScoreDecoder))
      })),
      "profileForMessageView": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ProfileForMessageViewDecoder)
      })),
      "manage": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(PortfolioMentorManageDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "uid": obj.attributes["uid"],
      "email": obj.attributes["email"],
      "emailPersonal": obj.attributes["emailPersonal"],
      "gender": obj.attributes["gender"],
      "firstName": obj.attributes["firstName"],
      "lastName": obj.attributes["lastName"],
      "fullName": obj.attributes["fullName"],
      "avatar": obj.attributes["avatar"],
      "photoUrl": obj.attributes["photoUrl"],
      "mobileNumber": obj.attributes["mobileNumber"],
      "mobileNumber2": obj.attributes["mobileNumber2"],
      "homeNumber": obj.attributes["homeNumber"],
      "profiles": obj?.relationships?.["profiles"]?.data,
      "group": obj?.relationships?.["group"]?.data,
      "scores": obj?.relationships?.["scores"]?.data,
      "profileForMessageView": obj?.relationships?.["profileForMessageView"]?.data,
      "manage": obj?.relationships?.["manage"]?.data,
    }
  })
)

export interface AdministratorUser {
  readonly "id": IDString
  readonly "uid": string
  readonly "email": null | string
  readonly "personalNumber": string
  readonly "firstName": string
  readonly "lastName": string
  readonly "fullName": string
  readonly "avatar": string
  readonly "photoUrl": null | string
  readonly "mobileNumber": null | string
  readonly "mobileNumber2": null | string
  readonly "homeNumber": null | string
  readonly "gender": null | string
  readonly "manage"?: {
    readonly "canEmulate": boolean
  }
  readonly "profiles"?: readonly UserProfile[]
}

export const AdministratorUserDecoder: decoders.Decoder<AdministratorUser> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "uid": decoders.string,
      "email": decoders.nullable(decoders.string),
      "personalNumber": decoders.string,
      "firstName": decoders.string,
      "lastName": decoders.string,
      "fullName": decoders.string,
      "avatar": decoders.string,
      "photoUrl": decoders.nullable(decoders.string),
      "mobileNumber": decoders.nullable(decoders.string),
      "mobileNumber2": decoders.nullable(decoders.string),
      "homeNumber": decoders.nullable(decoders.string),
      "gender": decoders.nullable(decoders.string),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "manage": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder((
          decoders.object({
            attributes: decoders.object({
              "canEmulate": decoders.boolean,
            }),
          })
          .transform(obj => {
            return {
              "canEmulate": obj.attributes["canEmulate"],
            }
          })
        ))
      })),
      "profiles": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(UserProfileDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "uid": obj.attributes["uid"],
      "email": obj.attributes["email"],
      "personalNumber": obj.attributes["personalNumber"],
      "firstName": obj.attributes["firstName"],
      "lastName": obj.attributes["lastName"],
      "fullName": obj.attributes["fullName"],
      "avatar": obj.attributes["avatar"],
      "photoUrl": obj.attributes["photoUrl"],
      "mobileNumber": obj.attributes["mobileNumber"],
      "mobileNumber2": obj.attributes["mobileNumber2"],
      "homeNumber": obj.attributes["homeNumber"],
      "gender": obj.attributes["gender"],
      "manage": obj?.relationships?.["manage"]?.data,
      "profiles": obj?.relationships?.["profiles"]?.data,
    }
  })
)

export type JSONRecord = Record<string, unknown>

export const JSONRecordDecoder: decoders.Decoder<JSONRecord> = decoders.unknown.transform(v => v as Record<string, unknown>)

export interface AdministratorChoiceStudent {
  readonly "uid": string
  readonly "id": number
  readonly "fullName": string
  readonly "profileId": number
}

export const AdministratorChoiceStudentDecoder: decoders.Decoder<AdministratorChoiceStudent> = decoders.object({
  "uid": decoders.string,
  "id": decoders.number,
  "fullName": decoders.string,
  "profileId": decoders.number,
})

export interface AdministratorChoiceStudentFaculty {
  readonly "id": number
  readonly "name": string
}

export const AdministratorChoiceStudentFacultyDecoder: decoders.Decoder<AdministratorChoiceStudentFaculty> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
})

export interface AdministratorChoiceStudentProgram {
  readonly "id": number
  readonly "name": string
  readonly "code": string
}

export const AdministratorChoiceStudentProgramDecoder: decoders.Decoder<AdministratorChoiceStudentProgram> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
  "code": decoders.string,
})

export interface AdministratorChoiceStudentDetail {
  readonly "uid": string
  readonly "id": number
  readonly "profileId": number
  readonly "fullName": string
  readonly "eduStatus"?: number
  readonly "faculty": null | AdministratorChoiceStudentFaculty
  readonly "program": null | AdministratorChoiceStudentProgram
  readonly "preferredMajorProgram"?: null | AdministratorChoiceStudentProgram
  readonly "preferredMinorFaculty"?: null | AdministratorChoiceStudentFaculty
  readonly "preferredMinorProgram"?: null | AdministratorChoiceStudentProgram
  readonly "degree": number
  readonly "userSem": number
}

export const AdministratorChoiceStudentDetailDecoder: decoders.Decoder<AdministratorChoiceStudentDetail> = decoders.object({
  "uid": decoders.string,
  "id": decoders.number,
  "profileId": decoders.number,
  "fullName": decoders.string,
  "eduStatus": optionalNullableDecoder(decoders.number),
  "faculty": decoders.nullable(AdministratorChoiceStudentFacultyDecoder),
  "program": decoders.nullable(AdministratorChoiceStudentProgramDecoder),
  "preferredMajorProgram": optionalNullableDecoder(decoders.nullable(AdministratorChoiceStudentProgramDecoder)),
  "preferredMinorFaculty": optionalNullableDecoder(decoders.nullable(AdministratorChoiceStudentFacultyDecoder)),
  "preferredMinorProgram": optionalNullableDecoder(decoders.nullable(AdministratorChoiceStudentProgramDecoder)),
  "degree": decoders.number,
  "userSem": decoders.number,
})

export interface AdministratorChoiceSemesterRef {
  readonly "id": number
  readonly "name": string
}

export const AdministratorChoiceSemesterRefDecoder: decoders.Decoder<AdministratorChoiceSemesterRef> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
})

export interface AdministratorChoiceCatalogSemesterRef {
  readonly "id": number
  readonly "name": string
  readonly "source": string
}

export const AdministratorChoiceCatalogSemesterRefDecoder: decoders.Decoder<AdministratorChoiceCatalogSemesterRef> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
  "source": decoders.string,
})

export interface AdministratorChoiceGroupRef {
  readonly "id": number
  readonly "name": string
  readonly "number"?: null | number
}

export const AdministratorChoiceGroupRefDecoder: decoders.Decoder<AdministratorChoiceGroupRef> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
  "number": optionalNullableDecoder(decoders.nullable(decoders.number)),
})

export interface AdministratorChoiceTeacherRef {
  readonly "id": number
  readonly "fullName": string
}

export const AdministratorChoiceTeacherRefDecoder: decoders.Decoder<AdministratorChoiceTeacherRef> = decoders.object({
  "id": decoders.number,
  "fullName": decoders.string,
})

export interface AdministratorChoiceCapabilities {
  readonly "update": boolean
  readonly "delete": boolean
  readonly "viewGroup": boolean
  readonly "discard": boolean
  readonly "undiscard": boolean
}

export const AdministratorChoiceCapabilitiesDecoder: decoders.Decoder<AdministratorChoiceCapabilities> = decoders.object({
  "update": decoders.boolean,
  "delete": decoders.boolean,
  "viewGroup": decoders.boolean,
  "discard": decoders.boolean,
  "undiscard": decoders.boolean,
})

export interface AdministratorChoiceRow {
  readonly "uid": string
  readonly "semId": number
  readonly "courseId"?: number
  readonly "courseName": string
  readonly "courseNameEn"?: string
  readonly "courseCode": string
  readonly "couGeneral"?: number
  readonly "faculty"?: null | AdministratorChoiceStudentFaculty
  readonly "courseCredits": number
  readonly "credits": number
  readonly "score": number
  readonly "status": number
  readonly "creditType": number
  readonly "discarded"?: boolean
  readonly "isDiscarded"?: boolean
  readonly "rowClass"?: string
  readonly "group"?: null | AdministratorChoiceGroupRef
  readonly "teachers"?: readonly AdministratorChoiceTeacherRef[]
  readonly "capabilities"?: AdministratorChoiceCapabilities
  readonly "editableFields"?: readonly string[]
}

export const AdministratorChoiceRowDecoder: decoders.Decoder<AdministratorChoiceRow> = decoders.object({
  "uid": decoders.string,
  "semId": decoders.number,
  "courseId": optionalNullableDecoder(decoders.number),
  "courseName": decoders.string,
  "courseNameEn": optionalNullableDecoder(decoders.string),
  "courseCode": decoders.string,
  "couGeneral": optionalNullableDecoder(decoders.number),
  "faculty": optionalNullableDecoder(decoders.nullable(AdministratorChoiceStudentFacultyDecoder)),
  "courseCredits": decoders.number,
  "credits": decoders.number,
  "score": decoders.number,
  "status": decoders.number,
  "creditType": decoders.number,
  "discarded": optionalNullableDecoder(decoders.boolean),
  "isDiscarded": optionalNullableDecoder(decoders.boolean),
  "rowClass": optionalNullableDecoder(decoders.string),
  "group": optionalNullableDecoder(decoders.nullable(AdministratorChoiceGroupRefDecoder)),
  "teachers": optionalNullableDecoder(ArrayObjectDecoder(AdministratorChoiceTeacherRefDecoder)),
  "capabilities": optionalNullableDecoder(AdministratorChoiceCapabilitiesDecoder),
  "editableFields": optionalNullableDecoder(ArrayObjectDecoder(decoders.string)),
})

export interface AdministratorChoicePassedSemesterGroup {
  readonly "semester": AdministratorChoiceSemesterRef
  readonly "choices": readonly AdministratorChoiceRow[]
}

export const AdministratorChoicePassedSemesterGroupDecoder: decoders.Decoder<AdministratorChoicePassedSemesterGroup> = decoders.object({
  "semester": AdministratorChoiceSemesterRefDecoder,
  "choices": ArrayObjectDecoder(AdministratorChoiceRowDecoder),
})

export interface AdministratorChoicesMeta {
  readonly "readonly"?: boolean
  readonly "targetSemesterId"?: number
  readonly "targetTable"?: string
  readonly "deferredActions": readonly string[]
}

export const AdministratorChoicesMetaDecoder: decoders.Decoder<AdministratorChoicesMeta> = decoders.object({
  "readonly": optionalNullableDecoder(decoders.boolean),
  "targetSemesterId": optionalNullableDecoder(decoders.number),
  "targetTable": optionalNullableDecoder(decoders.string),
  "deferredActions": ArrayObjectDecoder(decoders.string),
})

export interface AdministratorChoiceSemesterListItem {
  readonly "id": number
  readonly "name": string
  readonly "isActive": boolean
  readonly "isFuture": boolean
}

export const AdministratorChoiceSemesterListItemDecoder: decoders.Decoder<AdministratorChoiceSemesterListItem> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
  "isActive": decoders.boolean,
  "isFuture": decoders.boolean,
})

export interface AdministratorStudentChoicesPage {
  readonly "student": AdministratorChoiceStudentDetail
  readonly "activeSemester": AdministratorChoiceSemesterRef
  readonly "currentChoices": readonly AdministratorChoiceRow[]
  readonly "passedChoicesBySemester": readonly AdministratorChoicePassedSemesterGroup[]
  readonly "meta": AdministratorChoicesMeta
  readonly "targetSemester"?: AdministratorChoiceSemesterRef
  readonly "targetSemesterChoices"?: readonly AdministratorChoiceRow[]
  readonly "semesters"?: readonly AdministratorChoiceSemesterListItem[]
}

export const AdministratorStudentChoicesPageDecoder: decoders.Decoder<AdministratorStudentChoicesPage> = (
  decoders.object({
    attributes: decoders.object({
      "student": AdministratorChoiceStudentDetailDecoder,
      "activeSemester": AdministratorChoiceSemesterRefDecoder,
      "currentChoices": ArrayObjectDecoder(AdministratorChoiceRowDecoder),
      "passedChoicesBySemester": ArrayObjectDecoder(AdministratorChoicePassedSemesterGroupDecoder),
      "meta": AdministratorChoicesMetaDecoder,
      "targetSemester": optionalNullableDecoder(AdministratorChoiceSemesterRefDecoder),
      "targetSemesterChoices": optionalNullableDecoder(ArrayObjectDecoder(AdministratorChoiceRowDecoder)),
      "semesters": optionalNullableDecoder(ArrayObjectDecoder(AdministratorChoiceSemesterListItemDecoder)),
    }),
  })
  .transform(obj => {
    return {
      "student": obj.attributes["student"],
      "activeSemester": obj.attributes["activeSemester"],
      "currentChoices": obj.attributes["currentChoices"],
      "passedChoicesBySemester": obj.attributes["passedChoicesBySemester"],
      "meta": obj.attributes["meta"],
      "targetSemester": obj.attributes["targetSemester"],
      "targetSemesterChoices": obj.attributes["targetSemesterChoices"],
      "semesters": obj.attributes["semesters"],
    }
  })
)

export interface AdministratorChoiceRowResource {
  readonly "uid": string
  readonly "sem_id": number
  readonly "course_id"?: number
  readonly "course_name": string
  readonly "course_name_en"?: string
  readonly "course_code": string
  readonly "course_credits": number
  readonly "credits": number
  readonly "score": number
  readonly "status": number
  readonly "credit_type": number
  readonly "discarded"?: boolean
}

export const AdministratorChoiceRowResourceDecoder: decoders.Decoder<AdministratorChoiceRowResource> = (
  decoders.object({
    attributes: decoders.object({
      "uid": decoders.string,
      "sem_id": decoders.number,
      "course_id": optionalNullableDecoder(decoders.number),
      "course_name": decoders.string,
      "course_name_en": optionalNullableDecoder(decoders.string),
      "course_code": decoders.string,
      "course_credits": decoders.number,
      "credits": decoders.number,
      "score": decoders.number,
      "status": decoders.number,
      "credit_type": decoders.number,
      "discarded": optionalNullableDecoder(decoders.boolean),
    }),
  })
  .transform(obj => {
    return {
      "uid": obj.attributes["uid"],
      "sem_id": obj.attributes["sem_id"],
      "course_id": obj.attributes["course_id"],
      "course_name": obj.attributes["course_name"],
      "course_name_en": obj.attributes["course_name_en"],
      "course_code": obj.attributes["course_code"],
      "course_credits": obj.attributes["course_credits"],
      "credits": obj.attributes["credits"],
      "score": obj.attributes["score"],
      "status": obj.attributes["status"],
      "credit_type": obj.attributes["credit_type"],
      "discarded": obj.attributes["discarded"],
    }
  })
)

export interface AdministratorChoiceHistoryResource {
  readonly "choice": AdministratorChoiceRow
  readonly "meta": {
    readonly "created": boolean
    readonly "targetSemesterId": number
    readonly "table": string
  }
}

export const AdministratorChoiceHistoryResourceDecoder: decoders.Decoder<AdministratorChoiceHistoryResource> = (
  decoders.object({
    attributes: decoders.object({
      "choice": AdministratorChoiceRowDecoder,
      "meta": decoders.object({
        "created": decoders.boolean,
        "targetSemesterId": decoders.number,
        "table": decoders.string,
      }),
    }),
  })
  .transform(obj => {
    return {
      "choice": obj.attributes["choice"],
      "meta": obj.attributes["meta"],
    }
  })
)

export interface AdministratorChoiceCreateResource {
  readonly "choice": AdministratorChoiceRow
  readonly "meta": {
    readonly "created": boolean
    readonly "targetSemesterId": number
  }
}

export const AdministratorChoiceCreateResourceDecoder: decoders.Decoder<AdministratorChoiceCreateResource> = (
  decoders.object({
    attributes: decoders.object({
      "choice": AdministratorChoiceRowDecoder,
      "meta": decoders.object({
        "created": decoders.boolean,
        "targetSemesterId": decoders.number,
      }),
    }),
  })
  .transform(obj => {
    return {
      "choice": obj.attributes["choice"],
      "meta": obj.attributes["meta"],
    }
  })
)

export interface AdministratorChoiceNotice {
  readonly "message": string
}

export const AdministratorChoiceNoticeDecoder: decoders.Decoder<AdministratorChoiceNotice> = decoders.object({
  "message": decoders.string,
})

export interface AdministratorChoiceCreateResponse {
  readonly "data": AdministratorChoiceCreateResource
  readonly "notices"?: readonly AdministratorChoiceNotice[]
}

export const AdministratorChoiceCreateResponseDecoder: decoders.Decoder<AdministratorChoiceCreateResponse> = decoders.object({
  "data": AdministratorChoiceCreateResourceDecoder,
  "notices": optionalNullableDecoder(ArrayObjectDecoder(AdministratorChoiceNoticeDecoder)),
})

export interface AdministratorChoiceUpdateResource {
  readonly "updated": boolean
  readonly "choice": AdministratorChoiceRow
  readonly "meta": {
    readonly "targetSemesterId": number
    readonly "table": string
    readonly "editableFields"?: readonly string[]
    readonly "codeRowsUpdated"?: boolean
  }
}

export const AdministratorChoiceUpdateResourceDecoder: decoders.Decoder<AdministratorChoiceUpdateResource> = (
  decoders.object({
    attributes: decoders.object({
      "updated": decoders.boolean,
      "choice": AdministratorChoiceRowDecoder,
      "meta": decoders.object({
        "targetSemesterId": decoders.number,
        "table": decoders.string,
        "editableFields": optionalNullableDecoder(ArrayObjectDecoder(decoders.string)),
        "codeRowsUpdated": optionalNullableDecoder(decoders.boolean),
      }),
    }),
  })
  .transform(obj => {
    return {
      "updated": obj.attributes["updated"],
      "choice": obj.attributes["choice"],
      "meta": obj.attributes["meta"],
    }
  })
)

export interface AdministratorChoiceCourseOption {
  readonly "id": number
  readonly "courseName": string
  readonly "courseNameEn": string
  readonly "courseCode": string
  readonly "credits": number
  readonly "creditType": number
  readonly "facultyId": number
  readonly "facultyName": string
  readonly "semesterId": number
  readonly "isGeneral": boolean
}

export const AdministratorChoiceCourseOptionDecoder: decoders.Decoder<AdministratorChoiceCourseOption> = decoders.object({
  "id": decoders.number,
  "courseName": decoders.string,
  "courseNameEn": decoders.string,
  "courseCode": decoders.string,
  "credits": decoders.number,
  "creditType": decoders.number,
  "facultyId": decoders.number,
  "facultyName": decoders.string,
  "semesterId": decoders.number,
  "isGeneral": decoders.boolean,
})

export interface AdministratorStudentChoiceCoursesPage {
  readonly "student": AdministratorChoiceStudentDetail
  readonly "targetSemester": AdministratorChoiceSemesterRef
  readonly "catalogSemester"?: AdministratorChoiceCatalogSemesterRef
  readonly "courses": readonly AdministratorChoiceCourseOption[]
}

export const AdministratorStudentChoiceCoursesPageDecoder: decoders.Decoder<AdministratorStudentChoiceCoursesPage> = (
  decoders.object({
    attributes: decoders.object({
      "student": AdministratorChoiceStudentDetailDecoder,
      "targetSemester": AdministratorChoiceSemesterRefDecoder,
      "catalogSemester": optionalNullableDecoder(AdministratorChoiceCatalogSemesterRefDecoder),
      "courses": ArrayObjectDecoder(AdministratorChoiceCourseOptionDecoder),
    }),
  })
  .transform(obj => {
    return {
      "student": obj.attributes["student"],
      "targetSemester": obj.attributes["targetSemester"],
      "catalogSemester": obj.attributes["catalogSemester"],
      "courses": obj.attributes["courses"],
    }
  })
)

export interface AdministratorChoiceDeleteResult {
  readonly "deleted": boolean
  readonly "choiceUid": string
  readonly "targetSemesterId": number
  readonly "table": string
}

export const AdministratorChoiceDeleteResultDecoder: decoders.Decoder<AdministratorChoiceDeleteResult> = (
  decoders.object({
    attributes: decoders.object({
      "deleted": decoders.boolean,
      "choiceUid": decoders.string,
      "targetSemesterId": decoders.number,
      "table": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "deleted": obj.attributes["deleted"],
      "choiceUid": obj.attributes["choiceUid"],
      "targetSemesterId": obj.attributes["targetSemesterId"],
      "table": obj.attributes["table"],
    }
  })
)

export interface AdministratorChoiceDiscardResult {
  readonly "updated": boolean
  readonly "discarded": boolean
  readonly "choiceUid": string
  readonly "targetSemesterId": number
  readonly "table": string
}

export const AdministratorChoiceDiscardResultDecoder: decoders.Decoder<AdministratorChoiceDiscardResult> = (
  decoders.object({
    attributes: decoders.object({
      "updated": decoders.boolean,
      "discarded": decoders.boolean,
      "choiceUid": decoders.string,
      "targetSemesterId": decoders.number,
      "table": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "updated": obj.attributes["updated"],
      "discarded": obj.attributes["discarded"],
      "choiceUid": obj.attributes["choiceUid"],
      "targetSemesterId": obj.attributes["targetSemesterId"],
      "table": obj.attributes["table"],
    }
  })
)

export interface AdministratorChoiceProgramAssignmentResult {
  readonly "updated": boolean
  readonly "choice": AdministratorChoiceRow
  readonly "meta": {
    readonly "targetSemesterId": number
    readonly "table": string
    readonly "creditsProgId": number
  }
}

export const AdministratorChoiceProgramAssignmentResultDecoder: decoders.Decoder<AdministratorChoiceProgramAssignmentResult> = (
  decoders.object({
    attributes: decoders.object({
      "updated": decoders.boolean,
      "choice": AdministratorChoiceRowDecoder,
      "meta": decoders.object({
        "targetSemesterId": decoders.number,
        "table": decoders.string,
        "creditsProgId": decoders.number,
      }),
    }),
  })
  .transform(obj => {
    return {
      "updated": obj.attributes["updated"],
      "choice": obj.attributes["choice"],
      "meta": obj.attributes["meta"],
    }
  })
)

export interface AdministratorChoiceProgramAssignmentResetResult {
  readonly "updated": boolean
  readonly "meta": {
    readonly "scope": string
    readonly "tables": readonly string[]
    readonly "resetToCreditsProgId": number
  }
}

export const AdministratorChoiceProgramAssignmentResetResultDecoder: decoders.Decoder<AdministratorChoiceProgramAssignmentResetResult> = (
  decoders.object({
    attributes: decoders.object({
      "updated": decoders.boolean,
      "meta": decoders.object({
        "scope": decoders.string,
        "tables": ArrayObjectDecoder(decoders.string),
        "resetToCreditsProgId": decoders.number,
      }),
    }),
  })
  .transform(obj => {
    return {
      "updated": obj.attributes["updated"],
      "meta": obj.attributes["meta"],
    }
  })
)

export type AdministratorChoiceBucket = "major" | "minor" | "general" | "free" | "other" | "passive"

export const AdministratorChoiceBucketDecoder: decoders.Decoder<AdministratorChoiceBucket> = decoders.either(
  decoders.constant("major" as const),
  decoders.constant("minor" as const),
  decoders.constant("general" as const),
  decoders.constant("free" as const),
  decoders.constant("other" as const),
  decoders.constant("passive" as const)
)

export interface AdministratorChoiceHistory3Row {
  readonly "uid": string
  readonly "table": string
  readonly "bucket": AdministratorChoiceBucket
  readonly "semId": number
  readonly "semester": AdministratorChoiceSemesterRef
  readonly "courseName": string
  readonly "courseNameEn": string
  readonly "courseCode": string
  readonly "courseCredits": number
  readonly "credits": number
  readonly "score": number
  readonly "scoreDisplay": number | string
  readonly "status": number
  readonly "statusClass": string
  readonly "creditType": number
  readonly "couGeneral": number
  readonly "creditsProgId": number
  readonly "isDiscarded": boolean
}

export const AdministratorChoiceHistory3RowDecoder: decoders.Decoder<AdministratorChoiceHistory3Row> = decoders.object({
  "uid": decoders.string,
  "table": decoders.string,
  "bucket": AdministratorChoiceBucketDecoder,
  "semId": decoders.number,
  "semester": AdministratorChoiceSemesterRefDecoder,
  "courseName": decoders.string,
  "courseNameEn": decoders.string,
  "courseCode": decoders.string,
  "courseCredits": decoders.number,
  "credits": decoders.number,
  "score": decoders.number,
  "scoreDisplay": decoders.either(
    decoders.number,
    decoders.string
  ),
  "status": decoders.number,
  "statusClass": decoders.string,
  "creditType": decoders.number,
  "couGeneral": decoders.number,
  "creditsProgId": decoders.number,
  "isDiscarded": decoders.boolean,
})

export interface AdministratorChoiceHistoryGroup {
  readonly "key": AdministratorChoiceBucket
  readonly "title": string
  readonly "courseCreditsTotal": number
  readonly "gainedCreditsTotal": number
  readonly "items": readonly AdministratorChoiceHistory3Row[]
}

export const AdministratorChoiceHistoryGroupDecoder: decoders.Decoder<AdministratorChoiceHistoryGroup> = decoders.object({
  "key": AdministratorChoiceBucketDecoder,
  "title": decoders.string,
  "courseCreditsTotal": decoders.number,
  "gainedCreditsTotal": decoders.number,
  "items": ArrayObjectDecoder(AdministratorChoiceHistory3RowDecoder),
})

export interface AdministratorChoiceHistorySummary {
  readonly "courseCreditsTotal": number
  readonly "gainedCreditsTotal": number
  readonly "rowsCount": number
}

export const AdministratorChoiceHistorySummaryDecoder: decoders.Decoder<AdministratorChoiceHistorySummary> = decoders.object({
  "courseCreditsTotal": decoders.number,
  "gainedCreditsTotal": decoders.number,
  "rowsCount": decoders.number,
})

export interface AdministratorStudentChoiceHistory3Page {
  readonly "student": AdministratorChoiceStudentDetail
  readonly "groups": readonly AdministratorChoiceHistoryGroup[]
  readonly "summary": AdministratorChoiceHistorySummary
  readonly "meta": {
    readonly "readOnly"?: boolean
    readonly "source": readonly string[]
    readonly "discardedRowsIncluded"?: boolean
    readonly "allowsDuplicateChoiceUidsAcrossGroups"?: boolean
    readonly "bucketOrder"?: readonly AdministratorChoiceBucket[]
    readonly "deferredActions"?: readonly string[]
  }
}

export const AdministratorStudentChoiceHistory3PageDecoder: decoders.Decoder<AdministratorStudentChoiceHistory3Page> = (
  decoders.object({
    attributes: decoders.object({
      "student": AdministratorChoiceStudentDetailDecoder,
      "groups": ArrayObjectDecoder(AdministratorChoiceHistoryGroupDecoder),
      "summary": AdministratorChoiceHistorySummaryDecoder,
      "meta": decoders.object({
        "readOnly": optionalNullableDecoder(decoders.boolean),
        "source": ArrayObjectDecoder(decoders.string),
        "discardedRowsIncluded": optionalNullableDecoder(decoders.boolean),
        "allowsDuplicateChoiceUidsAcrossGroups": optionalNullableDecoder(decoders.boolean),
        "bucketOrder": optionalNullableDecoder(ArrayObjectDecoder(AdministratorChoiceBucketDecoder)),
        "deferredActions": optionalNullableDecoder(ArrayObjectDecoder(decoders.string)),
      }),
    }),
  })
  .transform(obj => {
    return {
      "student": obj.attributes["student"],
      "groups": obj.attributes["groups"],
      "summary": obj.attributes["summary"],
      "meta": obj.attributes["meta"],
    }
  })
)

export interface UserState {
  readonly "billingId": null | string
  readonly "billingBalance": null | number
  readonly "libraryBalance": null | number
  readonly "newsUnread": null | number
  readonly "messagesUnread": null | number
  readonly "notificationsUnread": null | number
  readonly "rechoose": boolean
  readonly "surveyExists": boolean
  readonly "portfolioExists"?: boolean
  readonly "regime": Regime
  readonly "riskGroups": readonly RiskGroup[]
}

export const UserStateDecoder: decoders.Decoder<UserState> = (
  decoders.object({
    attributes: decoders.object({
      "billingId": decoders.nullable(decoders.string),
      "billingBalance": decoders.nullable(decoders.number),
      "libraryBalance": decoders.nullable(decoders.number),
      "newsUnread": decoders.nullable(decoders.number),
      "messagesUnread": decoders.nullable(decoders.number),
      "notificationsUnread": decoders.nullable(decoders.number),
      "rechoose": decoders.boolean,
      "surveyExists": decoders.boolean,
      "portfolioExists": optionalNullableDecoder(decoders.boolean),
    }),
    relationships: decoders.object({
      "regime": decoders.object({
        data: RegimeDecoder
      }),
      "riskGroups": decoders.object({
        data: ArrayObjectDecoder(RiskGroupDecoder)
      }),
    }),
  })
  .transform(obj => {
    return {
      "billingId": obj.attributes["billingId"],
      "billingBalance": obj.attributes["billingBalance"],
      "libraryBalance": obj.attributes["libraryBalance"],
      "newsUnread": obj.attributes["newsUnread"],
      "messagesUnread": obj.attributes["messagesUnread"],
      "notificationsUnread": obj.attributes["notificationsUnread"],
      "rechoose": obj.attributes["rechoose"],
      "surveyExists": obj.attributes["surveyExists"],
      "portfolioExists": obj.attributes["portfolioExists"],
      "regime": obj.relationships["regime"].data,
      "riskGroups": obj.relationships["riskGroups"].data,
    }
  })
)

export interface Message {
  readonly "id": IDString
  readonly "subject": string
  readonly "messageType": MessageTypeEnum
  readonly "body": string
  readonly "seen": boolean
  readonly "semId": IDString
  readonly "sentAt": string
  readonly "senderProfileId": null | IDString
  readonly "readAt": null | string
  readonly "sender"?: User
  readonly "receiver"?: User
}

export const MessageDecoder: decoders.Decoder<Message> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "subject": decoders.string,
      "messageType": MessageTypeEnumDecoder,
      "body": decoders.string,
      "seen": decoders.boolean,
      "semId": IDStringDecoder,
      "sentAt": decoders.string,
      "senderProfileId": decoders.nullable(IDStringDecoder),
      "readAt": decoders.nullable(decoders.string),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "sender": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(UserDecoder)
      })),
      "receiver": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(UserDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "subject": obj.attributes["subject"],
      "messageType": obj.attributes["messageType"],
      "body": obj.attributes["body"],
      "seen": obj.attributes["seen"],
      "semId": obj.attributes["semId"],
      "sentAt": obj.attributes["sentAt"],
      "senderProfileId": obj.attributes["senderProfileId"],
      "readAt": obj.attributes["readAt"],
      "sender": obj?.relationships?.["sender"]?.data,
      "receiver": obj?.relationships?.["receiver"]?.data,
    }
  })
)

export interface Hour {
  readonly "id": IDString
  readonly "startTime": string
  readonly "endTime": string
  readonly "times": string
}

export const HourDecoder: decoders.Decoder<Hour> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "startTime": decoders.string,
      "endTime": decoders.string,
      "times": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "startTime": obj.attributes["startTime"],
      "endTime": obj.attributes["endTime"],
      "times": obj.attributes["times"],
    }
  })
)

export interface DuplicateSchedule {
  readonly "id": IDString
  readonly "locationName": null | string
  readonly "info": null | string
  readonly "lectureTypeName": string
  readonly "lectureFormatName": string
}

export const DuplicateScheduleDecoder: decoders.Decoder<DuplicateSchedule> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "locationName": decoders.nullable(decoders.string),
      "info": decoders.nullable(decoders.string),
      "lectureTypeName": decoders.string,
      "lectureFormatName": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "locationName": obj.attributes["locationName"],
      "info": obj.attributes["info"],
      "lectureTypeName": obj.attributes["lectureTypeName"],
      "lectureFormatName": obj.attributes["lectureFormatName"],
    }
  })
)

export interface Schedule {
  readonly "id": IDString
  readonly "locationName": null | string
  readonly "info": null | string
  readonly "lectureTypeName": string
  readonly "lectureFormatName": string
  readonly "hour": Hour
  readonly "course": Course
  readonly "group": Group
  readonly "lecturers"?: readonly User[]
  readonly "duplicate"?: DuplicateSchedule
}

export const ScheduleDecoder: decoders.Decoder<Schedule> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "locationName": decoders.nullable(decoders.string),
      "info": decoders.nullable(decoders.string),
      "lectureTypeName": decoders.string,
      "lectureFormatName": decoders.string,
    }),
    relationships: decoders.object({
      "hour": decoders.object({
        data: HourDecoder
      }),
      "course": decoders.object({
        data: CourseDecoder
      }),
      "group": decoders.object({
        data: GroupDecoder
      }),
      "lecturers": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(UserDecoder))
      })),
      "duplicate": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(DuplicateScheduleDecoder)
      })),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "locationName": obj.attributes["locationName"],
      "info": obj.attributes["info"],
      "lectureTypeName": obj.attributes["lectureTypeName"],
      "lectureFormatName": obj.attributes["lectureFormatName"],
      "hour": obj.relationships["hour"].data,
      "course": obj.relationships["course"].data,
      "group": obj.relationships["group"].data,
      "lecturers": obj?.relationships?.["lecturers"]?.data,
      "duplicate": obj?.relationships?.["duplicate"]?.data,
    }
  })
)

export interface ScheduleDay {
  readonly "number": number
  readonly "name": string
  readonly "date": string
  readonly "schedules": readonly Schedule[]
}

export const ScheduleDayDecoder: decoders.Decoder<ScheduleDay> = (
  decoders.object({
    attributes: decoders.object({
      "number": decoders.number,
      "name": decoders.string,
      "date": decoders.string,
    }),
    relationships: decoders.object({
      "schedules": decoders.object({
        data: ArrayObjectDecoder(ScheduleDecoder)
      }),
    }),
  })
  .transform(obj => {
    return {
      "number": obj.attributes["number"],
      "name": obj.attributes["name"],
      "date": obj.attributes["date"],
      "schedules": obj.relationships["schedules"].data,
    }
  })
)

export interface CardSemester {
  readonly "name": string
  readonly "choices"?: readonly Choice[]
}

export const CardSemesterDecoder: decoders.Decoder<CardSemester> = (
  decoders.object({
    attributes: decoders.object({
      "name": decoders.string,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "choices": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(ChoiceDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "name": obj.attributes["name"],
      "choices": obj?.relationships?.["choices"]?.data,
    }
  })
)

export interface CardScoringSystem {
  readonly "name": string
  readonly "range": null | string
  readonly "description": string
}

export const CardScoringSystemDecoder: decoders.Decoder<CardScoringSystem> = (
  decoders.object({
    attributes: decoders.object({
      "name": decoders.string,
      "range": decoders.nullable(decoders.string),
      "description": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "name": obj.attributes["name"],
      "range": obj.attributes["range"],
      "description": obj.attributes["description"],
    }
  })
)

export interface Card {
  readonly "studentName": string
  readonly "personalNumber": string
  readonly "birthDate": string
  readonly "unidocNumber": string
  readonly "facultyName": string
  readonly "majorHasFreeCredits": boolean
  readonly "majorProgramName": null | string
  readonly "majorProgramDirection": null | string
  readonly "minorProgramName": null | string
  readonly "minorProgramDirection": null | string
  readonly "averagePoint": null | number
  readonly "semesters"?: readonly CardSemester[]
  readonly "bachelorScoringSystem"?: readonly CardScoringSystem[]
  readonly "doctorScoringSystem"?: readonly CardScoringSystem[]
}

export const CardDecoder: decoders.Decoder<Card> = (
  decoders.object({
    attributes: decoders.object({
      "studentName": decoders.string,
      "personalNumber": decoders.string,
      "birthDate": decoders.string,
      "unidocNumber": decoders.string,
      "facultyName": decoders.string,
      "majorHasFreeCredits": decoders.boolean,
      "majorProgramName": decoders.nullable(decoders.string),
      "majorProgramDirection": decoders.nullable(decoders.string),
      "minorProgramName": decoders.nullable(decoders.string),
      "minorProgramDirection": decoders.nullable(decoders.string),
      "averagePoint": decoders.nullable(decoders.number),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "semesters": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(CardSemesterDecoder))
      })),
      "bachelorScoringSystem": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(CardScoringSystemDecoder))
      })),
      "doctorScoringSystem": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(CardScoringSystemDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "studentName": obj.attributes["studentName"],
      "personalNumber": obj.attributes["personalNumber"],
      "birthDate": obj.attributes["birthDate"],
      "unidocNumber": obj.attributes["unidocNumber"],
      "facultyName": obj.attributes["facultyName"],
      "majorHasFreeCredits": obj.attributes["majorHasFreeCredits"],
      "majorProgramName": obj.attributes["majorProgramName"],
      "majorProgramDirection": obj.attributes["majorProgramDirection"],
      "minorProgramName": obj.attributes["minorProgramName"],
      "minorProgramDirection": obj.attributes["minorProgramDirection"],
      "averagePoint": obj.attributes["averagePoint"],
      "semesters": obj?.relationships?.["semesters"]?.data,
      "bachelorScoringSystem": obj?.relationships?.["bachelorScoringSystem"]?.data,
      "doctorScoringSystem": obj?.relationships?.["doctorScoringSystem"]?.data,
    }
  })
)

export interface CalendarItem {
  readonly "id": null | IDString
  readonly "title": string
  readonly "startDate": string
  readonly "eventType": "event" | "holiday" | "schedule"
}

export const CalendarItemDecoder: decoders.Decoder<CalendarItem> = (
  decoders.object({
    "id": decoders.nullable(IDStringDecoder),
    attributes: decoders.object({
      "title": decoders.string,
      "startDate": decoders.string,
      "eventType": decoders.either(
        decoders.constant("event" as const),
        decoders.constant("holiday" as const),
        decoders.constant("schedule" as const)
      ),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "title": obj.attributes["title"],
      "startDate": obj.attributes["startDate"],
      "eventType": obj.attributes["eventType"],
    }
  })
)

export interface StatementFile {
  readonly "id": IDString
  readonly "mediaFile": MediaFile
}

export const StatementFileDecoder: decoders.Decoder<StatementFile> = (
  decoders.object({
    "id": IDStringDecoder,
    relationships: decoders.object({
      "mediaFile": decoders.object({
        data: MediaFileDecoder
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "mediaFile": obj.relationships["mediaFile"].data,
    }
  })
)

export type StatementStatusEnum =
  | "STATUS_PENDING"
  | "STATUS_DECLINED"
  | "STATUS_ACCEPTED"
  | "STATUS_PARTIAL"

export const StatementStatusEnumDecoder: decoders.Decoder<StatementStatusEnum> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "STATUS_PENDING"
      case 2: return "STATUS_DECLINED"
      case 3: return "STATUS_ACCEPTED"
      case 4: return "STATUS_PARTIAL"
    }

    throw new Error(`Could not decode StatementStatusEnum from value: ${key}`)
  })
)

export function StatementStatusEnumEncoder (label: StatementStatusEnum): string | number {
  switch (label) {
    case "STATUS_PENDING": return 1
    case "STATUS_DECLINED": return 2
    case "STATUS_ACCEPTED": return 3
    case "STATUS_PARTIAL": return 4
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const StatementStatusEnumValues = [
  "STATUS_PENDING",
  "STATUS_DECLINED",
  "STATUS_ACCEPTED",
  "STATUS_PARTIAL",
] as const

export interface Statement {
  readonly "id": IDString
  readonly "number": string
  readonly "title": string
  readonly "comment": string
  readonly "status": StatementStatusEnum
  readonly "statusText": string
  readonly "createdAt": string
  readonly "body": string
  readonly "files"?: readonly StatementFile[]
}

export const StatementDecoder: decoders.Decoder<Statement> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "number": decoders.string,
      "title": decoders.string,
      "comment": decoders.string,
      "status": StatementStatusEnumDecoder,
      "statusText": decoders.string,
      "createdAt": decoders.string,
      "body": decoders.string,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "files": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(StatementFileDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "number": obj.attributes["number"],
      "title": obj.attributes["title"],
      "comment": obj.attributes["comment"],
      "status": obj.attributes["status"],
      "statusText": obj.attributes["statusText"],
      "createdAt": obj.attributes["createdAt"],
      "body": obj.attributes["body"],
      "files": obj?.relationships?.["files"]?.data,
    }
  })
)

export interface StatementTemplate {
  readonly "id": IDString
  readonly "title": string
}

export const StatementTemplateDecoder: decoders.Decoder<StatementTemplate> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "title": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "title": obj.attributes["title"],
    }
  })
)

export interface StatementTemplateView {
  readonly "helpText": string
  readonly "html": string
  readonly "studentFacultyId": number
  readonly "targetUser": string
  readonly "targetUserTitle": string
  readonly "userAddress": null | string
  readonly "userDegree": string
  readonly "userFaculty": string
  readonly "userFacultySchool": null | string
  readonly "userFullName": string
  readonly "userMail": string
  readonly "userMajorProgram": string
  readonly "userPersNum": string
  readonly "userPhone": null | string
  readonly "userProgram": string
  readonly "userSemester": number
  readonly "userSign": string
  readonly "isTypeMobility": boolean
}

export const StatementTemplateViewDecoder: decoders.Decoder<StatementTemplateView> = (
  decoders.object({
    attributes: decoders.object({
      "helpText": decoders.string,
      "html": decoders.string,
      "studentFacultyId": decoders.number,
      "targetUser": decoders.string,
      "targetUserTitle": decoders.string,
      "userAddress": decoders.nullable(decoders.string),
      "userDegree": decoders.string,
      "userFaculty": decoders.string,
      "userFacultySchool": decoders.nullable(decoders.string),
      "userFullName": decoders.string,
      "userMail": decoders.string,
      "userMajorProgram": decoders.string,
      "userPersNum": decoders.string,
      "userPhone": decoders.nullable(decoders.string),
      "userProgram": decoders.string,
      "userSemester": decoders.number,
      "userSign": decoders.string,
      "isTypeMobility": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "helpText": obj.attributes["helpText"],
      "html": obj.attributes["html"],
      "studentFacultyId": obj.attributes["studentFacultyId"],
      "targetUser": obj.attributes["targetUser"],
      "targetUserTitle": obj.attributes["targetUserTitle"],
      "userAddress": obj.attributes["userAddress"],
      "userDegree": obj.attributes["userDegree"],
      "userFaculty": obj.attributes["userFaculty"],
      "userFacultySchool": obj.attributes["userFacultySchool"],
      "userFullName": obj.attributes["userFullName"],
      "userMail": obj.attributes["userMail"],
      "userMajorProgram": obj.attributes["userMajorProgram"],
      "userPersNum": obj.attributes["userPersNum"],
      "userPhone": obj.attributes["userPhone"],
      "userProgram": obj.attributes["userProgram"],
      "userSemester": obj.attributes["userSemester"],
      "userSign": obj.attributes["userSign"],
      "isTypeMobility": obj.attributes["isTypeMobility"],
    }
  })
)

export interface StatementTemplateRequest {
  readonly "id"?: IDString
  readonly "phone"?: string
  readonly "address"?: string
  readonly "year"?: string
  readonly "year2"?: string
  readonly "semester"?: string
  readonly "semester2"?: string
  readonly "place"?: string
  readonly "text"?: string
  readonly "semesterId"?: IDString
  readonly "facultyId"?: IDString
  readonly "programId"?: IDString
}

export const StatementTemplateRequestDecoder: decoders.Decoder<StatementTemplateRequest> = decoders.object({
  "id": optionalNullableDecoder(IDStringDecoder),
  "phone": optionalNullableDecoder(decoders.string),
  "address": optionalNullableDecoder(decoders.string),
  "year": optionalNullableDecoder(decoders.string),
  "year2": optionalNullableDecoder(decoders.string),
  "semester": optionalNullableDecoder(decoders.string),
  "semester2": optionalNullableDecoder(decoders.string),
  "place": optionalNullableDecoder(decoders.string),
  "text": optionalNullableDecoder(decoders.string),
  "semesterId": optionalNullableDecoder(IDStringDecoder),
  "facultyId": optionalNullableDecoder(IDStringDecoder),
  "programId": optionalNullableDecoder(IDStringDecoder),
})

export interface AdministratorStatementStudent {
  readonly "id": number
  readonly "profileId": number
  readonly "fullName": string
  readonly "persNum": string
  readonly "mail": null | string
}

export const AdministratorStatementStudentDecoder: decoders.Decoder<AdministratorStatementStudent> = decoders.object({
  "id": decoders.number,
  "profileId": decoders.number,
  "fullName": decoders.string,
  "persNum": decoders.string,
  "mail": decoders.nullable(decoders.string),
})

export interface AdministratorStatementCommenter {
  readonly "id": number
  readonly "fullName": string
}

export const AdministratorStatementCommenterDecoder: decoders.Decoder<AdministratorStatementCommenter> = decoders.object({
  "id": decoders.number,
  "fullName": decoders.string,
})

export interface AdministratorStatement {
  readonly "id": IDString
  readonly "semId": number
  readonly "number": string
  readonly "title": string
  readonly "status": number
  readonly "statusText": null | string
  readonly "comment": null | string
  readonly "commentDate": null | string
  readonly "commenter": null | AdministratorStatementCommenter
  readonly "createdAt": string
  readonly "student": AdministratorStatementStudent
  readonly "body"?: string
  readonly "files"?: readonly StatementFile[]
}

export const AdministratorStatementDecoder: decoders.Decoder<AdministratorStatement> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "semId": decoders.number,
      "number": decoders.string,
      "title": decoders.string,
      "status": decoders.number,
      "statusText": decoders.nullable(decoders.string),
      "comment": decoders.nullable(decoders.string),
      "commentDate": decoders.nullable(decoders.string),
      "commenter": decoders.nullable(AdministratorStatementCommenterDecoder),
      "createdAt": decoders.string,
      "student": AdministratorStatementStudentDecoder,
      "body": optionalNullableDecoder(decoders.string),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "files": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(StatementFileDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "semId": obj.attributes["semId"],
      "number": obj.attributes["number"],
      "title": obj.attributes["title"],
      "status": obj.attributes["status"],
      "statusText": obj.attributes["statusText"],
      "comment": obj.attributes["comment"],
      "commentDate": obj.attributes["commentDate"],
      "commenter": obj.attributes["commenter"],
      "createdAt": obj.attributes["createdAt"],
      "student": obj.attributes["student"],
      "body": obj.attributes["body"],
      "files": obj?.relationships?.["files"]?.data,
    }
  })
)

export interface AdministratorStatementTemplate {
  readonly "id": IDString
  readonly "title": string
  readonly "titleEn": null | string
  readonly "status": number
}

export const AdministratorStatementTemplateDecoder: decoders.Decoder<AdministratorStatementTemplate> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "title": decoders.string,
      "titleEn": decoders.nullable(decoders.string),
      "status": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "title": obj.attributes["title"],
      "titleEn": obj.attributes["titleEn"],
      "status": obj.attributes["status"],
    }
  })
)

export interface AdministratorListsStatementTemplate {
  readonly "id": number
  readonly "name": string
  readonly "status": number
}

export const AdministratorListsStatementTemplateDecoder: decoders.Decoder<AdministratorListsStatementTemplate> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
  "status": decoders.number,
})

export interface Rating {
  readonly "averagePoint": null | number
}

export const RatingDecoder: decoders.Decoder<Rating> = (
  decoders.object({
    attributes: decoders.object({
      "averagePoint": decoders.nullable(decoders.number),
    }),
  })
  .transform(obj => {
    return {
      "averagePoint": obj.attributes["averagePoint"],
    }
  })
)

export interface CourseSyllabus {
  readonly "duration": null | string
  readonly "lecturers": string
  readonly "hours": string
  readonly "prerequisites": string
  readonly "methods": string
  readonly "mission": string
  readonly "topics": string
  readonly "outcomes": string
  readonly "evaluation": string
  readonly "resources": string
  readonly "otherResources": string
  readonly "schedule": string
  readonly "knowledge": boolean
  readonly "applying": boolean
  readonly "judgments": boolean
  readonly "communications": boolean
  readonly "learning": boolean
  readonly "values": boolean
  readonly "course"?: Course
  readonly "manage"?: ManageSyllabus
  readonly "syllabusFile"?: CourseSyllabusFile
}

export const CourseSyllabusDecoder: decoders.Decoder<CourseSyllabus> = (
  decoders.object({
    attributes: decoders.object({
      "duration": decoders.nullable(decoders.string),
      "lecturers": decoders.string,
      "hours": decoders.string,
      "prerequisites": decoders.string,
      "methods": decoders.string,
      "mission": decoders.string,
      "topics": decoders.string,
      "outcomes": decoders.string,
      "evaluation": decoders.string,
      "resources": decoders.string,
      "otherResources": decoders.string,
      "schedule": decoders.string,
      "knowledge": decoders.boolean,
      "applying": decoders.boolean,
      "judgments": decoders.boolean,
      "communications": decoders.boolean,
      "learning": decoders.boolean,
      "values": decoders.boolean,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "course": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(CourseDecoder)
      })),
      "manage": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ManageSyllabusDecoder)
      })),
      "syllabusFile": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(CourseSyllabusFileDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "duration": obj.attributes["duration"],
      "lecturers": obj.attributes["lecturers"],
      "hours": obj.attributes["hours"],
      "prerequisites": obj.attributes["prerequisites"],
      "methods": obj.attributes["methods"],
      "mission": obj.attributes["mission"],
      "topics": obj.attributes["topics"],
      "outcomes": obj.attributes["outcomes"],
      "evaluation": obj.attributes["evaluation"],
      "resources": obj.attributes["resources"],
      "otherResources": obj.attributes["otherResources"],
      "schedule": obj.attributes["schedule"],
      "knowledge": obj.attributes["knowledge"],
      "applying": obj.attributes["applying"],
      "judgments": obj.attributes["judgments"],
      "communications": obj.attributes["communications"],
      "learning": obj.attributes["learning"],
      "values": obj.attributes["values"],
      "course": obj?.relationships?.["course"]?.data,
      "manage": obj?.relationships?.["manage"]?.data,
      "syllabusFile": obj?.relationships?.["syllabusFile"]?.data,
    }
  })
)

export interface CourseFile {
  readonly "id": IDString
  readonly "url": null | string
  readonly "name": null | string
  readonly "isViewableInWeb": boolean
  readonly "user"?: User
  readonly "manage"?: {
    readonly "canEdit": boolean
  }
  readonly "mediaFile"?: MediaFile
}

export const CourseFileDecoder: decoders.Decoder<CourseFile> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "url": decoders.nullable(decoders.string),
      "name": decoders.nullable(decoders.string),
      "isViewableInWeb": decoders.boolean,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "user": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(UserDecoder)
      })),
      "manage": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder((
          decoders.object({
            attributes: decoders.object({
              "canEdit": decoders.boolean,
            }),
          })
          .transform(obj => {
            return {
              "canEdit": obj.attributes["canEdit"],
            }
          })
        ))
      })),
      "mediaFile": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(MediaFileDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "url": obj.attributes["url"],
      "name": obj.attributes["name"],
      "isViewableInWeb": obj.attributes["isViewableInWeb"],
      "user": obj?.relationships?.["user"]?.data,
      "manage": obj?.relationships?.["manage"]?.data,
      "mediaFile": obj?.relationships?.["mediaFile"]?.data,
    }
  })
)

export interface CoursePost {
  readonly "id": IDString
  readonly "body": string
  readonly "number": string
  readonly "commentsCount": number
  readonly "isCommentingEnabled": boolean
  readonly "isVisibleToAll": boolean
  readonly "createdAt": string
  readonly "groups": readonly Group[]
  readonly "author"?: User
}

export const CoursePostDecoder: decoders.Decoder<CoursePost> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "body": decoders.string,
      "number": decoders.string,
      "commentsCount": decoders.number,
      "isCommentingEnabled": decoders.boolean,
      "isVisibleToAll": decoders.boolean,
      "createdAt": decoders.string,
    }),
    relationships: decoders.object({
      "groups": decoders.object({
        data: ArrayObjectDecoder(GroupDecoder)
      }),
      "author": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(UserDecoder)
      })),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "body": obj.attributes["body"],
      "number": obj.attributes["number"],
      "commentsCount": obj.attributes["commentsCount"],
      "isCommentingEnabled": obj.attributes["isCommentingEnabled"],
      "isVisibleToAll": obj.attributes["isVisibleToAll"],
      "createdAt": obj.attributes["createdAt"],
      "groups": obj.relationships["groups"].data,
      "author": obj?.relationships?.["author"]?.data,
    }
  })
)

export interface CoursePostSaveRequest {
  readonly "semId": number
  readonly "visibility": number
  readonly "commenting": number
  readonly "body": string
  readonly "groups"?: readonly number[]
}

export const CoursePostSaveRequestDecoder: decoders.Decoder<CoursePostSaveRequest> = (
  decoders.object({
    "semId": decoders.number,
    "visibility": decoders.number,
    "commenting": decoders.number,
    "body": decoders.string,
    relationships: optionalNullableDecoder(decoders.object({
      "groups": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(decoders.number))
      })),
    })),
  })
  .transform(obj => {
    return {
      "semId": obj["semId"],
      "visibility": obj["visibility"],
      "commenting": obj["commenting"],
      "body": obj["body"],
      "groups": obj?.relationships?.["groups"]?.data,
    }
  })
)

export interface NewsFile {
  readonly "id": IDString
  readonly "mediaFile": MediaFile
}

export const NewsFileDecoder: decoders.Decoder<NewsFile> = (
  decoders.object({
    "id": IDStringDecoder,
    relationships: decoders.object({
      "mediaFile": decoders.object({
        data: MediaFileDecoder
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "mediaFile": obj.relationships["mediaFile"].data,
    }
  })
)

export interface UserViewStatus {
  readonly "isViewed": boolean
}

export const UserViewStatusDecoder: decoders.Decoder<UserViewStatus> = (
  decoders.object({
    attributes: decoders.object({
      "isViewed": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "isViewed": obj.attributes["isViewed"],
    }
  })
)

export interface NotificationData {
  readonly "courseId": string
}

export const NotificationDataDecoder: decoders.Decoder<NotificationData> = decoders.object({
  "courseId": decoders.string,
})

export interface NewsUnreadCount {
  readonly "total": number
  readonly "unread": number
}

export const NewsUnreadCountDecoder: decoders.Decoder<NewsUnreadCount> = (
  decoders.object({
    attributes: decoders.object({
      "total": decoders.number,
      "unread": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "total": obj.attributes["total"],
      "unread": obj.attributes["unread"],
    }
  })
)

export interface News {
  readonly "id": IDString
  readonly "title": string
  readonly "titleColor": string
  readonly "text": string
  readonly "createdAt": string
  readonly "userViewStatus": UserViewStatus
  readonly "files"?: readonly NewsFile[]
}

export const NewsDecoder: decoders.Decoder<News> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "title": decoders.string,
      "titleColor": decoders.string,
      "text": decoders.string,
      "createdAt": decoders.string,
    }),
    relationships: decoders.object({
      "userViewStatus": decoders.object({
        data: UserViewStatusDecoder
      }),
      "files": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(NewsFileDecoder))
      })),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "title": obj.attributes["title"],
      "titleColor": obj.attributes["titleColor"],
      "text": obj.attributes["text"],
      "createdAt": obj.attributes["createdAt"],
      "userViewStatus": obj.relationships["userViewStatus"].data,
      "files": obj?.relationships?.["files"]?.data,
    }
  })
)

export type PortfolioWorkTypes =
  | "1"
  | "2"
  | "3"
  | "4"

export const PortfolioWorkTypesDecoder: decoders.Decoder<PortfolioWorkTypes> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "1"
      case 2: return "2"
      case 3: return "3"
      case 4: return "4"
    }

    throw new Error(`Could not decode PortfolioWorkTypes from value: ${key}`)
  })
)

export function PortfolioWorkTypesEncoder (label: PortfolioWorkTypes): string | number {
  switch (label) {
    case "1": return 1
    case "2": return 2
    case "3": return 3
    case "4": return 4
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const PortfolioWorkTypesValues = [
  "1",
  "2",
  "3",
  "4",
] as const

export interface WorkScore {
  readonly "score": number
  readonly "feedback"?: null | string
}

export const WorkScoreDecoder: decoders.Decoder<WorkScore> = (
  decoders.object({
    attributes: decoders.object({
      "score": decoders.number,
      "feedback": optionalNullableDecoder(decoders.nullable(decoders.string)),
    }),
  })
  .transform(obj => {
    return {
      "score": obj.attributes["score"],
      "feedback": obj.attributes["feedback"],
    }
  })
)

export interface PortfolioCompetenciesCriteria {
  readonly "id": IDString
  readonly "name": string
  readonly "description": string
  readonly "min": number
  readonly "max": number
  readonly "text": null | string
  readonly "score"?: WorkScore
}

export const PortfolioCompetenciesCriteriaDecoder: decoders.Decoder<PortfolioCompetenciesCriteria> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "description": decoders.string,
      "min": decoders.number,
      "max": decoders.number,
      "text": decoders.nullable(decoders.string),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "score": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(WorkScoreDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "description": obj.attributes["description"],
      "min": obj.attributes["min"],
      "max": obj.attributes["max"],
      "text": obj.attributes["text"],
      "score": obj?.relationships?.["score"]?.data,
    }
  })
)

export interface PortfolioCompetencyProgressScore {
  readonly "score": number
}

export const PortfolioCompetencyProgressScoreDecoder: decoders.Decoder<PortfolioCompetencyProgressScore> = (
  decoders.object({
    attributes: decoders.object({
      "score": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "score": obj.attributes["score"],
    }
  })
)

export interface SemesterProgress {
  readonly "score": number
  readonly "semester": number
}

export const SemesterProgressDecoder: decoders.Decoder<SemesterProgress> = decoders.object({
  "score": decoders.number,
  "semester": decoders.number,
})

export interface HistoryProgress {
  readonly "semesters": readonly SemesterProgress[]
  readonly "total": number
}

export const HistoryProgressDecoder: decoders.Decoder<HistoryProgress> = (
  decoders.object({
    attributes: decoders.object({
      "semesters": ArrayObjectDecoder(SemesterProgressDecoder),
      "total": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "semesters": obj.attributes["semesters"],
      "total": obj.attributes["total"],
    }
  })
)

export interface PortfolioCompetency {
  readonly "id": IDString
  readonly "name": string
  readonly "description": string
  readonly "maxScore": null | number
  readonly "minScore": null | number
  readonly "criterias"?: readonly PortfolioCompetenciesCriteria[]
  readonly "progress"?: PortfolioCompetencyProgressScore
  readonly "historyProgress"?: HistoryProgress
}

export const PortfolioCompetencyDecoder: decoders.Decoder<PortfolioCompetency> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "description": decoders.string,
      "maxScore": decoders.nullable(decoders.number),
      "minScore": decoders.nullable(decoders.number),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "criterias": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(PortfolioCompetenciesCriteriaDecoder))
      })),
      "progress": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(PortfolioCompetencyProgressScoreDecoder)
      })),
      "historyProgress": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(HistoryProgressDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "description": obj.attributes["description"],
      "maxScore": obj.attributes["maxScore"],
      "minScore": obj.attributes["minScore"],
      "criterias": obj?.relationships?.["criterias"]?.data,
      "progress": obj?.relationships?.["progress"]?.data,
      "historyProgress": obj?.relationships?.["historyProgress"]?.data,
    }
  })
)

export interface SectionTotalProgress {
  readonly "score": number
}

export const SectionTotalProgressDecoder: decoders.Decoder<SectionTotalProgress> = (
  decoders.object({
    attributes: decoders.object({
      "score": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "score": obj.attributes["score"],
    }
  })
)

export interface SectionWorkProgress {
  readonly "allowed": number
  readonly "submitted": number
}

export const SectionWorkProgressDecoder: decoders.Decoder<SectionWorkProgress> = (
  decoders.object({
    attributes: decoders.object({
      "allowed": decoders.number,
      "submitted": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "allowed": obj.attributes["allowed"],
      "submitted": obj.attributes["submitted"],
    }
  })
)

export interface LecturerSectionWorkProgress {
  readonly "evaluated": number
  readonly "pending": number
  readonly "rejected": number
  readonly "total": number
}

export const LecturerSectionWorkProgressDecoder: decoders.Decoder<LecturerSectionWorkProgress> = (
  decoders.object({
    attributes: decoders.object({
      "evaluated": decoders.number,
      "pending": decoders.number,
      "rejected": decoders.number,
      "total": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "evaluated": obj.attributes["evaluated"],
      "pending": obj.attributes["pending"],
      "rejected": obj.attributes["rejected"],
      "total": obj.attributes["total"],
    }
  })
)

export interface Section {
  readonly "id": IDString
  readonly "name": string
  readonly "workType": PortfolioWorkTypes
  readonly "workTitle": string
  readonly "maxScore": number
  readonly "minScore": number
  readonly "wordLimits"?: {
    readonly "min": number
    readonly "max": number
  }
  readonly "manage"?: ManageSection
  readonly "totalProgress"?: SectionTotalProgress
  readonly "sectionWorkProgress"?: SectionWorkProgress
  readonly "workProgress"?: LecturerSectionWorkProgress
  readonly "competencies"?: readonly PortfolioCompetency[]
}

export const SectionDecoder: decoders.Decoder<Section> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "workType": PortfolioWorkTypesDecoder,
      "workTitle": decoders.string,
      "maxScore": decoders.number,
      "minScore": decoders.number,
      "wordLimits": optionalNullableDecoder(decoders.object({
        "min": decoders.number,
        "max": decoders.number,
      })),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "manage": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ManageSectionDecoder)
      })),
      "totalProgress": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(SectionTotalProgressDecoder)
      })),
      "sectionWorkProgress": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(SectionWorkProgressDecoder)
      })),
      "workProgress": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(LecturerSectionWorkProgressDecoder)
      })),
      "competencies": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(PortfolioCompetencyDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "workType": obj.attributes["workType"],
      "workTitle": obj.attributes["workTitle"],
      "maxScore": obj.attributes["maxScore"],
      "minScore": obj.attributes["minScore"],
      "wordLimits": obj.attributes["wordLimits"],
      "manage": obj?.relationships?.["manage"]?.data,
      "totalProgress": obj?.relationships?.["totalProgress"]?.data,
      "sectionWorkProgress": obj?.relationships?.["sectionWorkProgress"]?.data,
      "workProgress": obj?.relationships?.["workProgress"]?.data,
      "competencies": obj?.relationships?.["competencies"]?.data,
    }
  })
)

export type PortfolioWorkStatus =
  | "STATUS_PENDING"
  | "STATUS_EVALUATED"
  | "STATUS_REJECTED"
  | "STATUS_DRAFT"

export const PortfolioWorkStatusDecoder: decoders.Decoder<PortfolioWorkStatus> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 0: return "STATUS_PENDING"
      case 1: return "STATUS_EVALUATED"
      case 2: return "STATUS_REJECTED"
      case 3: return "STATUS_DRAFT"
    }

    throw new Error(`Could not decode PortfolioWorkStatus from value: ${key}`)
  })
)

export function PortfolioWorkStatusEncoder (label: PortfolioWorkStatus): string | number {
  switch (label) {
    case "STATUS_PENDING": return 0
    case "STATUS_EVALUATED": return 1
    case "STATUS_REJECTED": return 2
    case "STATUS_DRAFT": return 3
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const PortfolioWorkStatusValues = [
  "STATUS_PENDING",
  "STATUS_EVALUATED",
  "STATUS_REJECTED",
  "STATUS_DRAFT",
] as const

export interface StudentPortfolioUserWork {
  readonly "id": IDString
  readonly "sectionId"?: number
  readonly "status": PortfolioWorkStatus
  readonly "semester": number
  readonly "comment": null | string
  readonly "text": null | string
  readonly "createdAt": string
  readonly "student"?: User
  readonly "mentor"?: User
  readonly "competencies"?: readonly PortfolioCompetency[]
  readonly "manage"?: ManageWork
  readonly "mediaFiles"?: readonly MediaFile[]
}

export const StudentPortfolioUserWorkDecoder: decoders.Decoder<StudentPortfolioUserWork> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "sectionId": optionalNullableDecoder(decoders.number),
      "status": PortfolioWorkStatusDecoder,
      "semester": decoders.number,
      "comment": decoders.nullable(decoders.string),
      "text": decoders.nullable(decoders.string),
      "createdAt": decoders.string,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "student": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(UserDecoder)
      })),
      "mentor": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(UserDecoder)
      })),
      "competencies": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(PortfolioCompetencyDecoder))
      })),
      "manage": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ManageWorkDecoder)
      })),
      "mediaFiles": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(MediaFileDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "sectionId": obj.attributes["sectionId"],
      "status": obj.attributes["status"],
      "semester": obj.attributes["semester"],
      "comment": obj.attributes["comment"],
      "text": obj.attributes["text"],
      "createdAt": obj.attributes["createdAt"],
      "student": obj?.relationships?.["student"]?.data,
      "mentor": obj?.relationships?.["mentor"]?.data,
      "competencies": obj?.relationships?.["competencies"]?.data,
      "manage": obj?.relationships?.["manage"]?.data,
      "mediaFiles": obj?.relationships?.["mediaFiles"]?.data,
    }
  })
)

export interface LecturerPortfolioUserWork {
  readonly "id": IDString
  readonly "text": null | string
  readonly "status": PortfolioWorkStatus
  readonly "comment": null | string
  readonly "createdAt": string
  readonly "student"?: User
  readonly "mentor"?: User
  readonly "competencies"?: readonly PortfolioCompetency[]
  readonly "manage"?: MentorWorkManage
  readonly "mediaFiles"?: readonly MediaFile[]
}

export const LecturerPortfolioUserWorkDecoder: decoders.Decoder<LecturerPortfolioUserWork> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "text": decoders.nullable(decoders.string),
      "status": PortfolioWorkStatusDecoder,
      "comment": decoders.nullable(decoders.string),
      "createdAt": decoders.string,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "student": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(UserDecoder)
      })),
      "mentor": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(UserDecoder)
      })),
      "competencies": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(PortfolioCompetencyDecoder))
      })),
      "manage": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(MentorWorkManageDecoder)
      })),
      "mediaFiles": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(MediaFileDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "text": obj.attributes["text"],
      "status": obj.attributes["status"],
      "comment": obj.attributes["comment"],
      "createdAt": obj.attributes["createdAt"],
      "student": obj?.relationships?.["student"]?.data,
      "mentor": obj?.relationships?.["mentor"]?.data,
      "competencies": obj?.relationships?.["competencies"]?.data,
      "manage": obj?.relationships?.["manage"]?.data,
      "mediaFiles": obj?.relationships?.["mediaFiles"]?.data,
    }
  })
)

export type NotificationType = "ScoreSaveNotification" | "MaterialAddNotification" | "LectureStartsNotification" | "NewsAddNotification"

export const NotificationTypeDecoder: decoders.Decoder<NotificationType> = decoders.either(
  decoders.constant("ScoreSaveNotification" as const),
  decoders.constant("MaterialAddNotification" as const),
  decoders.constant("LectureStartsNotification" as const),
  decoders.constant("NewsAddNotification" as const)
)

export interface Notification {
  readonly "id": IDString
  readonly "type": NotificationType
  readonly "title": string
  readonly "text": string
  readonly "createdAt": string
  readonly "readAt": null | string
  readonly "data": {
    readonly "courseId"?: IDString
    readonly "newsId"?: IDString
  }
}

export const NotificationDecoder: decoders.Decoder<Notification> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "type": NotificationTypeDecoder,
      "title": decoders.string,
      "text": decoders.string,
      "createdAt": decoders.string,
      "readAt": decoders.nullable(decoders.string),
      "data": decoders.object({
        "courseId": optionalNullableDecoder(IDStringDecoder),
        "newsId": optionalNullableDecoder(IDStringDecoder),
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "type": obj.attributes["type"],
      "title": obj.attributes["title"],
      "text": obj.attributes["text"],
      "createdAt": obj.attributes["createdAt"],
      "readAt": obj.attributes["readAt"],
      "data": obj.attributes["data"],
    }
  })
)

export interface Faq {
  readonly "id": IDString
  readonly "question": string
  readonly "answer": string
}

export const FaqDecoder: decoders.Decoder<Faq> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "question": decoders.string,
      "answer": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "question": obj.attributes["question"],
      "answer": obj.attributes["answer"],
    }
  })
)

export interface RegProg {
  readonly "id": IDString
  readonly "program": Program
}

export const RegProgDecoder: decoders.Decoder<RegProg> = (
  decoders.object({
    "id": IDStringDecoder,
    relationships: decoders.object({
      "program": decoders.object({
        data: ProgramDecoder
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "program": obj.relationships["program"].data,
    }
  })
)

export interface FacultySchool {
  readonly "id": IDString
  readonly "name": string
}

export const FacultySchoolDecoder: decoders.Decoder<FacultySchool> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
    }
  })
)

export interface StudentProgramState {
  readonly "id": IDString
  readonly "customProgramId": IDString
  readonly "minorFacultyId": IDString
  readonly "minorProgramId": IDString
  readonly "canChooseMajor": boolean
  readonly "canChooseMinor": boolean
  readonly "faculty": Faculty
  readonly "facultySchool"?: FacultySchool
  readonly "customProgram"?: Program
}

export const StudentProgramStateDecoder: decoders.Decoder<StudentProgramState> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "customProgramId": IDStringDecoder,
      "minorFacultyId": IDStringDecoder,
      "minorProgramId": IDStringDecoder,
      "canChooseMajor": decoders.boolean,
      "canChooseMinor": decoders.boolean,
    }),
    relationships: decoders.object({
      "faculty": decoders.object({
        data: FacultyDecoder
      }),
      "facultySchool": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(FacultySchoolDecoder)
      })),
      "customProgram": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ProgramDecoder)
      })),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "customProgramId": obj.attributes["customProgramId"],
      "minorFacultyId": obj.attributes["minorFacultyId"],
      "minorProgramId": obj.attributes["minorProgramId"],
      "canChooseMajor": obj.attributes["canChooseMajor"],
      "canChooseMinor": obj.attributes["canChooseMinor"],
      "faculty": obj.relationships["faculty"].data,
      "facultySchool": obj?.relationships?.["facultySchool"]?.data,
      "customProgram": obj?.relationships?.["customProgram"]?.data,
    }
  })
)

export interface LecturerUser {
  readonly "id": IDString
  readonly "uid": string
  readonly "email": null | string
  readonly "firstName": string
  readonly "lastName": string
  readonly "fullName": string
  readonly "avatar": string
  readonly "photoUrl": null | string
  readonly "gender": null | string
  readonly "profileId": number
  readonly "groups"?: readonly Group[]
  readonly "group"?: Group
  readonly "scores"?: readonly StudentScore[]
  readonly "finalScore"?: FinalScore
  readonly "profilePrograms"?: StudentProgramState
}

export const LecturerUserDecoder: decoders.Decoder<LecturerUser> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "uid": decoders.string,
      "email": decoders.nullable(decoders.string),
      "firstName": decoders.string,
      "lastName": decoders.string,
      "fullName": decoders.string,
      "avatar": decoders.string,
      "photoUrl": decoders.nullable(decoders.string),
      "gender": decoders.nullable(decoders.string),
      "profileId": decoders.number,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "groups": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(GroupDecoder))
      })),
      "group": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(GroupDecoder)
      })),
      "scores": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(StudentScoreDecoder))
      })),
      "finalScore": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(FinalScoreDecoder)
      })),
      "profilePrograms": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(StudentProgramStateDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "uid": obj.attributes["uid"],
      "email": obj.attributes["email"],
      "firstName": obj.attributes["firstName"],
      "lastName": obj.attributes["lastName"],
      "fullName": obj.attributes["fullName"],
      "avatar": obj.attributes["avatar"],
      "photoUrl": obj.attributes["photoUrl"],
      "gender": obj.attributes["gender"],
      "profileId": obj.attributes["profileId"],
      "groups": obj?.relationships?.["groups"]?.data,
      "group": obj?.relationships?.["group"]?.data,
      "scores": obj?.relationships?.["scores"]?.data,
      "finalScore": obj?.relationships?.["finalScore"]?.data,
      "profilePrograms": obj?.relationships?.["profilePrograms"]?.data,
    }
  })
)

export interface Recommendation {
  readonly "id": IDString
  readonly "text": string
  readonly "textFragment": string
  readonly "createdAt": string
  readonly "author": User
}

export const RecommendationDecoder: decoders.Decoder<Recommendation> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "text": decoders.string,
      "textFragment": decoders.string,
      "createdAt": decoders.string,
    }),
    relationships: decoders.object({
      "author": decoders.object({
        data: UserDecoder
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "text": obj.attributes["text"],
      "textFragment": obj.attributes["textFragment"],
      "createdAt": obj.attributes["createdAt"],
      "author": obj.relationships["author"].data,
    }
  })
)

export interface RecommendationLecturerSide {
  readonly "id": IDString
  readonly "text": string
  readonly "textFragment": string
  readonly "createdAt": string
}

export const RecommendationLecturerSideDecoder: decoders.Decoder<RecommendationLecturerSide> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "text": decoders.string,
      "textFragment": decoders.string,
      "createdAt": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "text": obj.attributes["text"],
      "textFragment": obj.attributes["textFragment"],
      "createdAt": obj.attributes["createdAt"],
    }
  })
)

export interface RecommendationStudentInfo {
  readonly "id": IDString
  readonly "fullName": string
  readonly "profilePrograms": StudentProgramState
}

export const RecommendationStudentInfoDecoder: decoders.Decoder<RecommendationStudentInfo> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "fullName": decoders.string,
    }),
    relationships: decoders.object({
      "profilePrograms": decoders.object({
        data: StudentProgramStateDecoder
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "fullName": obj.attributes["fullName"],
      "profilePrograms": obj.relationships["profilePrograms"].data,
    }
  })
)

export interface CoursePostComment {
  readonly "id": IDString
  readonly "body": string
  readonly "parentId": null | IDString
  readonly "isParent": boolean
  readonly "isPostAuthor": boolean
  readonly "createdAt": string
  readonly "children"?: readonly CoursePostComment[]
  readonly "author"?: User
  readonly "authorGroup"?: Group
}

export const CoursePostCommentDecoder: decoders.Decoder<CoursePostComment> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "body": decoders.string,
      "parentId": decoders.nullable(IDStringDecoder),
      "isParent": decoders.boolean,
      "isPostAuthor": decoders.boolean,
      "createdAt": decoders.string,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "children": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(decoders.lazy(() => CoursePostCommentDecoder)))
      })),
      "author": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(UserDecoder)
      })),
      "authorGroup": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(GroupDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "body": obj.attributes["body"],
      "parentId": obj.attributes["parentId"],
      "isParent": obj.attributes["isParent"],
      "isPostAuthor": obj.attributes["isPostAuthor"],
      "createdAt": obj.attributes["createdAt"],
      "children": obj?.relationships?.["children"]?.data,
      "author": obj?.relationships?.["author"]?.data,
      "authorGroup": obj?.relationships?.["authorGroup"]?.data,
    }
  })
)

export interface Resume {
  readonly "id": IDString
  readonly "personalTabVisible": boolean
  readonly "educationTabVisible": boolean
  readonly "workTabVisible": boolean
  readonly "trainingsTabVisible": boolean
  readonly "skillsTabVisible": boolean
  readonly "additionalTabVisible": boolean
  readonly "summaryTabVisible": boolean
}

export const ResumeDecoder: decoders.Decoder<Resume> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "personalTabVisible": decoders.boolean,
      "educationTabVisible": decoders.boolean,
      "workTabVisible": decoders.boolean,
      "trainingsTabVisible": decoders.boolean,
      "skillsTabVisible": decoders.boolean,
      "additionalTabVisible": decoders.boolean,
      "summaryTabVisible": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "personalTabVisible": obj.attributes["personalTabVisible"],
      "educationTabVisible": obj.attributes["educationTabVisible"],
      "workTabVisible": obj.attributes["workTabVisible"],
      "trainingsTabVisible": obj.attributes["trainingsTabVisible"],
      "skillsTabVisible": obj.attributes["skillsTabVisible"],
      "additionalTabVisible": obj.attributes["additionalTabVisible"],
      "summaryTabVisible": obj.attributes["summaryTabVisible"],
    }
  })
)

export interface resumePhoto {
  readonly "id": IDString
  readonly "expiresAt": null | string
  readonly "url": null | string
  readonly "mediaFile": MediaFile
}

export const resumePhotoDecoder: decoders.Decoder<resumePhoto> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "expiresAt": decoders.nullable(decoders.string),
      "url": decoders.nullable(decoders.string),
    }),
    relationships: decoders.object({
      "mediaFile": decoders.object({
        data: MediaFileDecoder
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "expiresAt": obj.attributes["expiresAt"],
      "url": obj.attributes["url"],
      "mediaFile": obj.relationships["mediaFile"].data,
    }
  })
)

export interface ResumePersonal {
  readonly "id": IDString
  readonly "address": string
  readonly "homePhone": string
  readonly "mobilePhone": string
  readonly "photoTitle": string
  readonly "photoUrl": string
  readonly "resumePhoto"?: resumePhoto
}

export const ResumePersonalDecoder: decoders.Decoder<ResumePersonal> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "address": decoders.string,
      "homePhone": decoders.string,
      "mobilePhone": decoders.string,
      "photoTitle": decoders.string,
      "photoUrl": decoders.string,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "resumePhoto": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(resumePhotoDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "address": obj.attributes["address"],
      "homePhone": obj.attributes["homePhone"],
      "mobilePhone": obj.attributes["mobilePhone"],
      "photoTitle": obj.attributes["photoTitle"],
      "photoUrl": obj.attributes["photoUrl"],
      "resumePhoto": obj?.relationships?.["resumePhoto"]?.data,
    }
  })
)

export interface ResumeWork {
  readonly "id": IDString
  readonly "companyName": string
  readonly "position": string
  readonly "isCurrent": boolean
  readonly "startDate": string
  readonly "endDate": null | string
  readonly "commitment": string
  readonly "companyAddress": string
  readonly "companySector": string
}

export const ResumeWorkDecoder: decoders.Decoder<ResumeWork> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "companyName": decoders.string,
      "position": decoders.string,
      "isCurrent": decoders.boolean,
      "startDate": decoders.string,
      "endDate": decoders.nullable(decoders.string),
      "commitment": decoders.string,
      "companyAddress": decoders.string,
      "companySector": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "companyName": obj.attributes["companyName"],
      "position": obj.attributes["position"],
      "isCurrent": obj.attributes["isCurrent"],
      "startDate": obj.attributes["startDate"],
      "endDate": obj.attributes["endDate"],
      "commitment": obj.attributes["commitment"],
      "companyAddress": obj.attributes["companyAddress"],
      "companySector": obj.attributes["companySector"],
    }
  })
)

export interface ResumeDocument {
  readonly "id": null | IDString
  readonly "name": Stringable
  readonly "url": Stringable
  readonly "type": null | ResumeDocumentType
}

export const ResumeDocumentDecoder: decoders.Decoder<ResumeDocument> = (
  decoders.object({
    "id": decoders.nullable(IDStringDecoder),
    attributes: decoders.object({
      "name": StringableDecoder,
      "url": StringableDecoder,
      "type": decoders.nullable(ResumeDocumentTypeDecoder),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "url": obj.attributes["url"],
      "type": obj.attributes["type"],
    }
  })
)

export interface ResumeTrainingSchedule {
  readonly "id": null | IDString
  readonly "startHour": null | string
  readonly "endHour": null | string
}

export const ResumeTrainingScheduleDecoder: decoders.Decoder<ResumeTrainingSchedule> = (
  decoders.object({
    "id": decoders.nullable(IDStringDecoder),
    attributes: decoders.object({
      "startHour": decoders.nullable(decoders.string),
      "endHour": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "startHour": obj.attributes["startHour"],
      "endHour": obj.attributes["endHour"],
    }
  })
)

export interface ResumeTraining {
  readonly "id": IDString
  readonly "name": string
  readonly "companyName": string
  readonly "isCurrent": boolean
  readonly "startDate": string
  readonly "endDate": null | string
  readonly "skills": string
  readonly "countryId": IDString
  readonly "cityId": IDString
  readonly "document": ResumeDocument
  readonly "schedule": readonly ResumeTrainingSchedule[]
  readonly "trainingFile"?: MediaFile
}

export const ResumeTrainingDecoder: decoders.Decoder<ResumeTraining> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "companyName": decoders.string,
      "isCurrent": decoders.boolean,
      "startDate": decoders.string,
      "endDate": decoders.nullable(decoders.string),
      "skills": decoders.string,
      "countryId": IDStringDecoder,
      "cityId": IDStringDecoder,
    }),
    relationships: decoders.object({
      "document": decoders.object({
        data: ResumeDocumentDecoder
      }),
      "schedule": decoders.object({
        data: ArrayObjectDecoder(ResumeTrainingScheduleDecoder)
      }),
      "trainingFile": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(MediaFileDecoder)
      })),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "companyName": obj.attributes["companyName"],
      "isCurrent": obj.attributes["isCurrent"],
      "startDate": obj.attributes["startDate"],
      "endDate": obj.attributes["endDate"],
      "skills": obj.attributes["skills"],
      "countryId": obj.attributes["countryId"],
      "cityId": obj.attributes["cityId"],
      "document": obj.relationships["document"].data,
      "schedule": obj.relationships["schedule"].data,
      "trainingFile": obj?.relationships?.["trainingFile"]?.data,
    }
  })
)

export interface ResumeSkillCommunication {
  readonly "id": IDString
  readonly "value": Stringable
}

export const ResumeSkillCommunicationDecoder: decoders.Decoder<ResumeSkillCommunication> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "value": StringableDecoder,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "value": obj.attributes["value"],
    }
  })
)

export interface ResumeSkillComputer {
  readonly "id": IDString
  readonly "value": Stringable
}

export const ResumeSkillComputerDecoder: decoders.Decoder<ResumeSkillComputer> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "value": StringableDecoder,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "value": obj.attributes["value"],
    }
  })
)

export interface ResumeSkillLang {
  readonly "id": IDString
  readonly "name": null | string
  readonly "hasCertificate": boolean
  readonly "isNative": boolean
  readonly "understandingLevel": null | ResumeLanguageLevel
  readonly "speakingLevel": null | ResumeLanguageLevel
  readonly "readingLevel": null | ResumeLanguageLevel
}

export const ResumeSkillLangDecoder: decoders.Decoder<ResumeSkillLang> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.nullable(decoders.string),
      "hasCertificate": decoders.boolean,
      "isNative": decoders.boolean,
      "understandingLevel": decoders.nullable(ResumeLanguageLevelDecoder),
      "speakingLevel": decoders.nullable(ResumeLanguageLevelDecoder),
      "readingLevel": decoders.nullable(ResumeLanguageLevelDecoder),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "hasCertificate": obj.attributes["hasCertificate"],
      "isNative": obj.attributes["isNative"],
      "understandingLevel": obj.attributes["understandingLevel"],
      "speakingLevel": obj.attributes["speakingLevel"],
      "readingLevel": obj.attributes["readingLevel"],
    }
  })
)

export interface ResumeSkillOrganisational {
  readonly "id": IDString
  readonly "value": Stringable
}

export const ResumeSkillOrganisationalDecoder: decoders.Decoder<ResumeSkillOrganisational> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "value": StringableDecoder,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "value": obj.attributes["value"],
    }
  })
)

export interface ResumeSkillOther {
  readonly "id": IDString
  readonly "value": Stringable
}

export const ResumeSkillOtherDecoder: decoders.Decoder<ResumeSkillOther> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "value": StringableDecoder,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "value": obj.attributes["value"],
    }
  })
)

export interface ResumeSkill {
  readonly "id": IDString
  readonly "hasDriverLicence": boolean
  readonly "communicationSkills": readonly ResumeSkillCommunication[]
  readonly "computerSkills": readonly ResumeSkillComputer[]
  readonly "languageSkills": readonly ResumeSkillLang[]
  readonly "organisationalSkills": readonly ResumeSkillOrganisational[]
  readonly "otherSkills": readonly ResumeSkillOther[]
}

export const ResumeSkillDecoder: decoders.Decoder<ResumeSkill> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "hasDriverLicence": decoders.boolean,
    }),
    relationships: decoders.object({
      "communicationSkills": decoders.object({
        data: ArrayObjectDecoder(ResumeSkillCommunicationDecoder)
      }),
      "computerSkills": decoders.object({
        data: ArrayObjectDecoder(ResumeSkillComputerDecoder)
      }),
      "languageSkills": decoders.object({
        data: ArrayObjectDecoder(ResumeSkillLangDecoder)
      }),
      "organisationalSkills": decoders.object({
        data: ArrayObjectDecoder(ResumeSkillOrganisationalDecoder)
      }),
      "otherSkills": decoders.object({
        data: ArrayObjectDecoder(ResumeSkillOtherDecoder)
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "hasDriverLicence": obj.attributes["hasDriverLicence"],
      "communicationSkills": obj.relationships["communicationSkills"].data,
      "computerSkills": obj.relationships["computerSkills"].data,
      "languageSkills": obj.relationships["languageSkills"].data,
      "organisationalSkills": obj.relationships["organisationalSkills"].data,
      "otherSkills": obj.relationships["otherSkills"].data,
    }
  })
)

export interface ResumeEducation {
  readonly "id": IDString
  readonly "isCurrent": boolean
  readonly "startDate": string
  readonly "endDate": null | string
  readonly "qualification": string
  readonly "universityId": IDString
  readonly "countryId": IDString
  readonly "cityId": IDString
  readonly "document": ResumeDocument
  readonly "educationFile"?: MediaFile
}

export const ResumeEducationDecoder: decoders.Decoder<ResumeEducation> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "isCurrent": decoders.boolean,
      "startDate": decoders.string,
      "endDate": decoders.nullable(decoders.string),
      "qualification": decoders.string,
      "universityId": IDStringDecoder,
      "countryId": IDStringDecoder,
      "cityId": IDStringDecoder,
    }),
    relationships: decoders.object({
      "document": decoders.object({
        data: ResumeDocumentDecoder
      }),
      "educationFile": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(MediaFileDecoder)
      })),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "isCurrent": obj.attributes["isCurrent"],
      "startDate": obj.attributes["startDate"],
      "endDate": obj.attributes["endDate"],
      "qualification": obj.attributes["qualification"],
      "universityId": obj.attributes["universityId"],
      "countryId": obj.attributes["countryId"],
      "cityId": obj.attributes["cityId"],
      "document": obj.relationships["document"].data,
      "educationFile": obj?.relationships?.["educationFile"]?.data,
    }
  })
)

export interface ResumeAdditionalFellowship {
  readonly "id": IDString
  readonly "type": Stringable
  readonly "organisationName": Stringable
  readonly "cofinansist": Stringable
  readonly "startDate": Stringable
  readonly "endDate": Stringable
}

export const ResumeAdditionalFellowshipDecoder: decoders.Decoder<ResumeAdditionalFellowship> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "type": StringableDecoder,
      "organisationName": StringableDecoder,
      "cofinansist": StringableDecoder,
      "startDate": StringableDecoder,
      "endDate": StringableDecoder,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "type": obj.attributes["type"],
      "organisationName": obj.attributes["organisationName"],
      "cofinansist": obj.attributes["cofinansist"],
      "startDate": obj.attributes["startDate"],
      "endDate": obj.attributes["endDate"],
    }
  })
)

export interface ResumeAdditionalPublication {
  readonly "id": IDString
  readonly "type": Stringable
  readonly "name": Stringable
  readonly "publisherName": Stringable
  readonly "date": Stringable
  readonly "url": Stringable
}

export const ResumeAdditionalPublicationDecoder: decoders.Decoder<ResumeAdditionalPublication> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "type": StringableDecoder,
      "name": StringableDecoder,
      "publisherName": StringableDecoder,
      "date": StringableDecoder,
      "url": StringableDecoder,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "type": obj.attributes["type"],
      "name": obj.attributes["name"],
      "publisherName": obj.attributes["publisherName"],
      "date": obj.attributes["date"],
      "url": obj.attributes["url"],
    }
  })
)

export interface ResumeAdditionalSubject {
  readonly "id": IDString
  readonly "course": Stringable
}

export const ResumeAdditionalSubjectDecoder: decoders.Decoder<ResumeAdditionalSubject> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "course": StringableDecoder,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "course": obj.attributes["course"],
    }
  })
)

export interface ResumeAdditionalVideolection {
  readonly "id": IDString
  readonly "name": Stringable
  readonly "url": Stringable
}

export const ResumeAdditionalVideolectionDecoder: decoders.Decoder<ResumeAdditionalVideolection> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": StringableDecoder,
      "url": StringableDecoder,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "url": obj.attributes["url"],
    }
  })
)

export interface ResumeAdditional {
  readonly "id": IDString
  readonly "info": null | string
  readonly "fellowships": readonly ResumeAdditionalFellowship[]
  readonly "publications": readonly ResumeAdditionalPublication[]
  readonly "subjects": readonly ResumeAdditionalSubject[]
  readonly "videoLectures": readonly ResumeAdditionalVideolection[]
}

export const ResumeAdditionalDecoder: decoders.Decoder<ResumeAdditional> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "info": decoders.nullable(decoders.string),
    }),
    relationships: decoders.object({
      "fellowships": decoders.object({
        data: ArrayObjectDecoder(ResumeAdditionalFellowshipDecoder)
      }),
      "publications": decoders.object({
        data: ArrayObjectDecoder(ResumeAdditionalPublicationDecoder)
      }),
      "subjects": decoders.object({
        data: ArrayObjectDecoder(ResumeAdditionalSubjectDecoder)
      }),
      "videoLectures": decoders.object({
        data: ArrayObjectDecoder(ResumeAdditionalVideolectionDecoder)
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "info": obj.attributes["info"],
      "fellowships": obj.relationships["fellowships"].data,
      "publications": obj.relationships["publications"].data,
      "subjects": obj.relationships["subjects"].data,
      "videoLectures": obj.relationships["videoLectures"].data,
    }
  })
)

export interface University {
  readonly "id": IDString
  readonly "name": string
}

export const UniversityDecoder: decoders.Decoder<University> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
    }
  })
)

export interface TestType {
  readonly "id": IDString
  readonly "name": string
}

export const TestTypeDecoder: decoders.Decoder<TestType> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
    }
  })
)

export interface ResumeLanguage {
  readonly "id": IDString
  readonly "name": string
}

export const ResumeLanguageDecoder: decoders.Decoder<ResumeLanguage> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
    }
  })
)

export interface ResumePublicationType {
  readonly "id": IDString
  readonly "name": null | string
}

export const ResumePublicationTypeDecoder: decoders.Decoder<ResumePublicationType> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
    }
  })
)

export interface ResumeGrantType {
  readonly "id": IDString
  readonly "name": string
}

export const ResumeGrantTypeDecoder: decoders.Decoder<ResumeGrantType> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
    }
  })
)

export interface ResumeCity {
  readonly "id": IDString
  readonly "name": string
}

export const ResumeCityDecoder: decoders.Decoder<ResumeCity> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
    }
  })
)

export interface RegistrationStatus {
  readonly "id": null | IDString
  readonly "enabled": boolean
  readonly "startDate": null | string
  readonly "dateEnd": null | string
}

export const RegistrationStatusDecoder: decoders.Decoder<RegistrationStatus> = (
  decoders.object({
    "id": decoders.nullable(IDStringDecoder),
    attributes: decoders.object({
      "enabled": decoders.boolean,
      "startDate": decoders.nullable(decoders.string),
      "dateEnd": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "enabled": obj.attributes["enabled"],
      "startDate": obj.attributes["startDate"],
      "dateEnd": obj.attributes["dateEnd"],
    }
  })
)

export interface MasterRegistrationStep1 {
  readonly "pers_num": string
  readonly "birth_date": null | string
  readonly "firstname": string
  readonly "lastname": string
  readonly "firstname_en": string
  readonly "lastname_en": string
  readonly "personal_email": string
  readonly "persdoc_exp_date": null | string
  readonly "persdoc_uid": string
  readonly "gender": string
  readonly "citizenship": string
  readonly "photo_uid": string
  readonly "army_status_doc_uid": null | string
  readonly "legal_address": string
  readonly "actual_address": string
  readonly "mobile_phone1": string
  readonly "mobile_phone2": null | string
  readonly "home_phone": null | string
  readonly "high_school": string
  readonly "high_school_doc_type": string
  readonly "high_school_finish_date": null | string
  readonly "high_school_doc_num": string
  readonly "high_school_doc_date": null | string
  readonly "high_school_doc_uid": string
  readonly "major_degree": string
  readonly "minor_degree": string
  readonly "gpa": null | string
  readonly "exam_identity_code": string
  readonly "exam_card_uid": string
  readonly "has_limited_abilities": string
  readonly "limited_abilities_text": null | string
}

export const MasterRegistrationStep1Decoder: decoders.Decoder<MasterRegistrationStep1> = (
  decoders.object({
    attributes: decoders.object({
      "pers_num": decoders.string,
      "birth_date": decoders.nullable(decoders.string),
      "firstname": decoders.string,
      "lastname": decoders.string,
      "firstname_en": decoders.string,
      "lastname_en": decoders.string,
      "personal_email": decoders.string,
      "persdoc_exp_date": decoders.nullable(decoders.string),
      "persdoc_uid": decoders.string,
      "gender": decoders.string,
      "citizenship": decoders.string,
      "photo_uid": decoders.string,
      "army_status_doc_uid": decoders.nullable(decoders.string),
      "legal_address": decoders.string,
      "actual_address": decoders.string,
      "mobile_phone1": decoders.string,
      "mobile_phone2": decoders.nullable(decoders.string),
      "home_phone": decoders.nullable(decoders.string),
      "high_school": decoders.string,
      "high_school_doc_type": decoders.string,
      "high_school_finish_date": decoders.nullable(decoders.string),
      "high_school_doc_num": decoders.string,
      "high_school_doc_date": decoders.nullable(decoders.string),
      "high_school_doc_uid": decoders.string,
      "major_degree": decoders.string,
      "minor_degree": decoders.string,
      "gpa": decoders.nullable(decoders.string),
      "exam_identity_code": decoders.string,
      "exam_card_uid": decoders.string,
      "has_limited_abilities": decoders.string,
      "limited_abilities_text": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "pers_num": obj.attributes["pers_num"],
      "birth_date": obj.attributes["birth_date"],
      "firstname": obj.attributes["firstname"],
      "lastname": obj.attributes["lastname"],
      "firstname_en": obj.attributes["firstname_en"],
      "lastname_en": obj.attributes["lastname_en"],
      "personal_email": obj.attributes["personal_email"],
      "persdoc_exp_date": obj.attributes["persdoc_exp_date"],
      "persdoc_uid": obj.attributes["persdoc_uid"],
      "gender": obj.attributes["gender"],
      "citizenship": obj.attributes["citizenship"],
      "photo_uid": obj.attributes["photo_uid"],
      "army_status_doc_uid": obj.attributes["army_status_doc_uid"],
      "legal_address": obj.attributes["legal_address"],
      "actual_address": obj.attributes["actual_address"],
      "mobile_phone1": obj.attributes["mobile_phone1"],
      "mobile_phone2": obj.attributes["mobile_phone2"],
      "home_phone": obj.attributes["home_phone"],
      "high_school": obj.attributes["high_school"],
      "high_school_doc_type": obj.attributes["high_school_doc_type"],
      "high_school_finish_date": obj.attributes["high_school_finish_date"],
      "high_school_doc_num": obj.attributes["high_school_doc_num"],
      "high_school_doc_date": obj.attributes["high_school_doc_date"],
      "high_school_doc_uid": obj.attributes["high_school_doc_uid"],
      "major_degree": obj.attributes["major_degree"],
      "minor_degree": obj.attributes["minor_degree"],
      "gpa": obj.attributes["gpa"],
      "exam_identity_code": obj.attributes["exam_identity_code"],
      "exam_card_uid": obj.attributes["exam_card_uid"],
      "has_limited_abilities": obj.attributes["has_limited_abilities"],
      "limited_abilities_text": obj.attributes["limited_abilities_text"],
    }
  })
)

export interface MasterRegistrationStep2Item {
  readonly "faculty": string
  readonly "program": string
  readonly "captions": null | readonly string[]
  readonly "files_uid": null | readonly string[]
}

export const MasterRegistrationStep2ItemDecoder: decoders.Decoder<MasterRegistrationStep2Item> = (
  decoders.object({
    attributes: decoders.object({
      "faculty": decoders.string,
      "program": decoders.string,
      "captions": decoders.nullable(ArrayObjectDecoder(decoders.string)),
      "files_uid": decoders.nullable(ArrayObjectDecoder(decoders.string)),
    }),
  })
  .transform(obj => {
    return {
      "faculty": obj.attributes["faculty"],
      "program": obj.attributes["program"],
      "captions": obj.attributes["captions"],
      "files_uid": obj.attributes["files_uid"],
    }
  })
)

export interface MasterRegistrationStep2 {
  readonly "testtype": string
  readonly "items": readonly MasterRegistrationStep2Item[]
}

export const MasterRegistrationStep2Decoder: decoders.Decoder<MasterRegistrationStep2> = (
  decoders.object({
    attributes: decoders.object({
      "testtype": decoders.string,
      "items": ArrayObjectDecoder(MasterRegistrationStep2ItemDecoder),
    }),
  })
  .transform(obj => {
    return {
      "testtype": obj.attributes["testtype"],
      "items": obj.attributes["items"],
    }
  })
)

export interface RegistrationStep3 {
  readonly "agreement": boolean
}

export const RegistrationStep3Decoder: decoders.Decoder<RegistrationStep3> = (
  decoders.object({
    attributes: decoders.object({
      "agreement": decoders.boolean,
    }),
  })
  .transform(obj => {
    return {
      "agreement": obj.attributes["agreement"],
    }
  })
)

export interface LecturerRegistrationStep1 {
  readonly "pers_num": string
  readonly "birth_date": null | string
  readonly "firstname": string
  readonly "lastname": string
  readonly "firstname_en": string
  readonly "lastname_en": string
  readonly "personal_email": string
  readonly "persdoc_exp_date": null | string
  readonly "persdoc_uid": string
  readonly "gender": string
  readonly "citizenship": string
  readonly "photo_uid": string
  readonly "army_status_doc_uid": null | string
  readonly "legal_address": string
  readonly "actual_address": string
  readonly "mobile_phone1": string
  readonly "mobile_phone2": null | string
  readonly "home_phone": null | string
  readonly "high_school": string
  readonly "high_school_doc_type": string
  readonly "high_school_finish_date": null | string
  readonly "high_school_doc_num": string
  readonly "high_school_doc_date": null | string
  readonly "high_school_doc_uid": string
  readonly "has_limited_abilities": string
  readonly "limited_abilities_text": null | string
}

export const LecturerRegistrationStep1Decoder: decoders.Decoder<LecturerRegistrationStep1> = (
  decoders.object({
    attributes: decoders.object({
      "pers_num": decoders.string,
      "birth_date": decoders.nullable(decoders.string),
      "firstname": decoders.string,
      "lastname": decoders.string,
      "firstname_en": decoders.string,
      "lastname_en": decoders.string,
      "personal_email": decoders.string,
      "persdoc_exp_date": decoders.nullable(decoders.string),
      "persdoc_uid": decoders.string,
      "gender": decoders.string,
      "citizenship": decoders.string,
      "photo_uid": decoders.string,
      "army_status_doc_uid": decoders.nullable(decoders.string),
      "legal_address": decoders.string,
      "actual_address": decoders.string,
      "mobile_phone1": decoders.string,
      "mobile_phone2": decoders.nullable(decoders.string),
      "home_phone": decoders.nullable(decoders.string),
      "high_school": decoders.string,
      "high_school_doc_type": decoders.string,
      "high_school_finish_date": decoders.nullable(decoders.string),
      "high_school_doc_num": decoders.string,
      "high_school_doc_date": decoders.nullable(decoders.string),
      "high_school_doc_uid": decoders.string,
      "has_limited_abilities": decoders.string,
      "limited_abilities_text": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "pers_num": obj.attributes["pers_num"],
      "birth_date": obj.attributes["birth_date"],
      "firstname": obj.attributes["firstname"],
      "lastname": obj.attributes["lastname"],
      "firstname_en": obj.attributes["firstname_en"],
      "lastname_en": obj.attributes["lastname_en"],
      "personal_email": obj.attributes["personal_email"],
      "persdoc_exp_date": obj.attributes["persdoc_exp_date"],
      "persdoc_uid": obj.attributes["persdoc_uid"],
      "gender": obj.attributes["gender"],
      "citizenship": obj.attributes["citizenship"],
      "photo_uid": obj.attributes["photo_uid"],
      "army_status_doc_uid": obj.attributes["army_status_doc_uid"],
      "legal_address": obj.attributes["legal_address"],
      "actual_address": obj.attributes["actual_address"],
      "mobile_phone1": obj.attributes["mobile_phone1"],
      "mobile_phone2": obj.attributes["mobile_phone2"],
      "home_phone": obj.attributes["home_phone"],
      "high_school": obj.attributes["high_school"],
      "high_school_doc_type": obj.attributes["high_school_doc_type"],
      "high_school_finish_date": obj.attributes["high_school_finish_date"],
      "high_school_doc_num": obj.attributes["high_school_doc_num"],
      "high_school_doc_date": obj.attributes["high_school_doc_date"],
      "high_school_doc_uid": obj.attributes["high_school_doc_uid"],
      "has_limited_abilities": obj.attributes["has_limited_abilities"],
      "limited_abilities_text": obj.attributes["limited_abilities_text"],
    }
  })
)

export interface LecturerRegistrationStep2 {
  readonly "cv_uid": string
  readonly "work_exp_uid": string
  readonly "exam_course": string
}

export const LecturerRegistrationStep2Decoder: decoders.Decoder<LecturerRegistrationStep2> = (
  decoders.object({
    attributes: decoders.object({
      "cv_uid": decoders.string,
      "work_exp_uid": decoders.string,
      "exam_course": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "cv_uid": obj.attributes["cv_uid"],
      "work_exp_uid": obj.attributes["work_exp_uid"],
      "exam_course": obj.attributes["exam_course"],
    }
  })
)

export interface ExamCourse {
  readonly "id": IDString
  readonly "name": string
  readonly "program": Program
}

export const ExamCourseDecoder: decoders.Decoder<ExamCourse> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
    }),
    relationships: decoders.object({
      "program": decoders.object({
        data: ProgramDecoder
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "program": obj.relationships["program"].data,
    }
  })
)

export interface UpdateResumeWorkRequest {
  readonly "startDate": string
  readonly "endDate": null | string
  readonly "isCurrent": boolean
  readonly "position": string
  readonly "commitment": string
  readonly "companyName": string
  readonly "companyAddress": string
  readonly "companySector": string
}

export const UpdateResumeWorkRequestDecoder: decoders.Decoder<UpdateResumeWorkRequest> = (
  decoders.object({
    attributes: decoders.object({
      "startDate": decoders.string,
      "endDate": decoders.nullable(decoders.string),
      "isCurrent": decoders.boolean,
      "position": decoders.string,
      "commitment": decoders.string,
      "companyName": decoders.string,
      "companyAddress": decoders.string,
      "companySector": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "startDate": obj.attributes["startDate"],
      "endDate": obj.attributes["endDate"],
      "isCurrent": obj.attributes["isCurrent"],
      "position": obj.attributes["position"],
      "commitment": obj.attributes["commitment"],
      "companyName": obj.attributes["companyName"],
      "companyAddress": obj.attributes["companyAddress"],
      "companySector": obj.attributes["companySector"],
    }
  })
)

export interface ResumeTrainingScheduleRequest {
  readonly "startHour": string
  readonly "endHour": string
}

export const ResumeTrainingScheduleRequestDecoder: decoders.Decoder<ResumeTrainingScheduleRequest> = decoders.object({
  "startHour": decoders.string,
  "endHour": decoders.string,
})

export interface ResumeDocumentRequest {
  readonly "type": null | EnumValue
  readonly "fileUid": null | string
}

export const ResumeDocumentRequestDecoder: decoders.Decoder<ResumeDocumentRequest> = (
  decoders.object({
    "type": decoders.nullable(EnumValueDecoder),
    attributes: decoders.object({
      "fileUid": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "type": obj["type"],
      "fileUid": obj.attributes["fileUid"],
    }
  })
)

export interface UpdateResumeTrainingRequest {
  readonly "startDate": string
  readonly "endDate": null | string
  readonly "isCurrent": boolean
  readonly "name": string
  readonly "companyName": string
  readonly "skills": string
  readonly "countryId": IDString
  readonly "cityId": IDString
  readonly "document"?: ResumeDocumentRequest
  readonly "schedule"?: readonly ResumeTrainingScheduleRequest[]
}

export const UpdateResumeTrainingRequestDecoder: decoders.Decoder<UpdateResumeTrainingRequest> = decoders.object({
  "startDate": decoders.string,
  "endDate": decoders.nullable(decoders.string),
  "isCurrent": decoders.boolean,
  "name": decoders.string,
  "companyName": decoders.string,
  "skills": decoders.string,
  "countryId": IDStringDecoder,
  "cityId": IDStringDecoder,
  "document": optionalNullableDecoder(ResumeDocumentRequestDecoder),
  "schedule": optionalNullableDecoder(ArrayObjectDecoder(ResumeTrainingScheduleRequestDecoder)),
})

export interface UpdateResumeSkillLanguageRequest {
  readonly "name": null | string
  readonly "hasCertificate": boolean
  readonly "isNative": boolean
  readonly "understandingLevel": null | EnumValue
  readonly "speakingLevel": null | EnumValue
  readonly "readingLevel": null | EnumValue
}

export const UpdateResumeSkillLanguageRequestDecoder: decoders.Decoder<UpdateResumeSkillLanguageRequest> = decoders.object({
  "name": decoders.nullable(decoders.string),
  "hasCertificate": decoders.boolean,
  "isNative": decoders.boolean,
  "understandingLevel": decoders.nullable(EnumValueDecoder),
  "speakingLevel": decoders.nullable(EnumValueDecoder),
  "readingLevel": decoders.nullable(EnumValueDecoder),
})

export interface UpdateResumeSkillCommunicationRequest {
  readonly "value": null | string
}

export const UpdateResumeSkillCommunicationRequestDecoder: decoders.Decoder<UpdateResumeSkillCommunicationRequest> = decoders.object({
  "value": decoders.nullable(decoders.string),
})

export interface UpdateResumeSkillComputerRequest {
  readonly "value": null | string
}

export const UpdateResumeSkillComputerRequestDecoder: decoders.Decoder<UpdateResumeSkillComputerRequest> = decoders.object({
  "value": decoders.nullable(decoders.string),
})

export interface UpdateResumeSkillOrganisationalRequest {
  readonly "value": null | string
}

export const UpdateResumeSkillOrganisationalRequestDecoder: decoders.Decoder<UpdateResumeSkillOrganisationalRequest> = decoders.object({
  "value": decoders.nullable(decoders.string),
})

export interface UpdateResumeSkillOtherRequest {
  readonly "value": null | string
}

export const UpdateResumeSkillOtherRequestDecoder: decoders.Decoder<UpdateResumeSkillOtherRequest> = decoders.object({
  "value": decoders.nullable(decoders.string),
})

export interface UpdateResumeEducationRequest {
  readonly "startDate": string
  readonly "endDate": null | string
  readonly "isCurrent": boolean
  readonly "countryId": IDString
  readonly "cityId": IDString
  readonly "universityId": IDString
  readonly "qualification": string
  readonly "document"?: ResumeDocumentRequest
}

export const UpdateResumeEducationRequestDecoder: decoders.Decoder<UpdateResumeEducationRequest> = (
  decoders.object({
    "startDate": decoders.string,
    "endDate": decoders.nullable(decoders.string),
    "isCurrent": decoders.boolean,
    "countryId": IDStringDecoder,
    "cityId": IDStringDecoder,
    "universityId": IDStringDecoder,
    "qualification": decoders.string,
    relationships: optionalNullableDecoder(decoders.object({
      "document": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ResumeDocumentRequestDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "startDate": obj["startDate"],
      "endDate": obj["endDate"],
      "isCurrent": obj["isCurrent"],
      "countryId": obj["countryId"],
      "cityId": obj["cityId"],
      "universityId": obj["universityId"],
      "qualification": obj["qualification"],
      "document": obj?.relationships?.["document"]?.data,
    }
  })
)

export interface UpdateResumeAdditionalPublicationRequest {
  readonly "name": string
  readonly "publisherName": string
  readonly "type": string
  readonly "date": string
  readonly "url": string
}

export const UpdateResumeAdditionalPublicationRequestDecoder: decoders.Decoder<UpdateResumeAdditionalPublicationRequest> = decoders.object({
  "name": decoders.string,
  "publisherName": decoders.string,
  "type": decoders.string,
  "date": decoders.string,
  "url": decoders.string,
})

export interface UpdateResumeAdditionalFellowshipRequest {
  readonly "type": string
  readonly "organisationName": string
  readonly "startDate": string
  readonly "endDate": string
  readonly "cofinansist": string
}

export const UpdateResumeAdditionalFellowshipRequestDecoder: decoders.Decoder<UpdateResumeAdditionalFellowshipRequest> = decoders.object({
  "type": decoders.string,
  "organisationName": decoders.string,
  "startDate": decoders.string,
  "endDate": decoders.string,
  "cofinansist": decoders.string,
})

export interface UpdateResumeAdditionalSubjectRequest {
  readonly "course": string
}

export const UpdateResumeAdditionalSubjectRequestDecoder: decoders.Decoder<UpdateResumeAdditionalSubjectRequest> = decoders.object({
  "course": decoders.string,
})

export interface UpdateResumeAdditionalVideoLectureRequest {
  readonly "name": string
  readonly "url": string
}

export const UpdateResumeAdditionalVideoLectureRequestDecoder: decoders.Decoder<UpdateResumeAdditionalVideoLectureRequest> = decoders.object({
  "name": decoders.string,
  "url": decoders.string,
})

export interface ChoiceType {
  readonly "credits": number
  readonly "type": ChoiceTypeEnum
}

export const ChoiceTypeDecoder: decoders.Decoder<ChoiceType> = (
  decoders.object({
    attributes: decoders.object({
      "credits": decoders.number,
      "type": ChoiceTypeEnumDecoder,
    }),
  })
  .transform(obj => {
    return {
      "credits": obj.attributes["credits"],
      "type": obj.attributes["type"],
    }
  })
)

export interface AvailableChoiceSummary {
  readonly "creditsAll": number
  readonly "creditsCurrent": number
  readonly "creditsGeneral": number
  readonly "choices": readonly Choice[]
  readonly "choiceTypes"?: readonly ChoiceType[]
}

export const AvailableChoiceSummaryDecoder: decoders.Decoder<AvailableChoiceSummary> = (
  decoders.object({
    attributes: decoders.object({
      "creditsAll": decoders.number,
      "creditsCurrent": decoders.number,
      "creditsGeneral": decoders.number,
    }),
    relationships: decoders.object({
      "choices": decoders.object({
        data: ArrayObjectDecoder(ChoiceDecoder)
      }),
      "choiceTypes": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(ChoiceTypeDecoder))
      })),
    }),
  })
  .transform(obj => {
    return {
      "creditsAll": obj.attributes["creditsAll"],
      "creditsCurrent": obj.attributes["creditsCurrent"],
      "creditsGeneral": obj.attributes["creditsGeneral"],
      "choices": obj.relationships["choices"].data,
      "choiceTypes": obj?.relationships?.["choiceTypes"]?.data,
    }
  })
)

export interface AvailableCourseTab {
  readonly "title": string
  readonly "programId": null | IDString
  readonly "tooltip": string
  readonly "type": AvailableCourseTabType
}

export const AvailableCourseTabDecoder: decoders.Decoder<AvailableCourseTab> = (
  decoders.object({
    attributes: decoders.object({
      "title": decoders.string,
      "programId": decoders.nullable(IDStringDecoder),
      "tooltip": decoders.string,
      "type": AvailableCourseTabTypeDecoder,
    }),
  })
  .transform(obj => {
    return {
      "title": obj.attributes["title"],
      "programId": obj.attributes["programId"],
      "tooltip": obj.attributes["tooltip"],
      "type": obj.attributes["type"],
    }
  })
)

export interface AvailableCourseSummary {
  readonly "courses": readonly Course[]
  readonly "choiceTypes"?: readonly ChoiceType[]
}

export const AvailableCourseSummaryDecoder: decoders.Decoder<AvailableCourseSummary> = (
  decoders.object({
    relationships: decoders.object({
      "courses": decoders.object({
        data: ArrayObjectDecoder(CourseDecoder)
      }),
      "choiceTypes": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(ChoiceTypeDecoder))
      })),
    }),
  })
  .transform(obj => {
    return {
      "courses": obj.relationships["courses"].data,
      "choiceTypes": obj?.relationships?.["choiceTypes"]?.data,
    }
  })
)

export interface MetaData {
  readonly "environment": string
  readonly "revision": string
  readonly "updatedAt": string
}

export const MetaDataDecoder: decoders.Decoder<MetaData> = decoders.object({
  "environment": decoders.string,
  "revision": decoders.string,
  "updatedAt": decoders.string,
})

export interface Country {
  readonly "id": IDString
  readonly "name": string
}

export const CountryDecoder: decoders.Decoder<Country> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
    }
  })
)

export interface Address {
  readonly "id": null | IDString
  readonly "result": string
}

export const AddressDecoder: decoders.Decoder<Address> = (
  decoders.object({
    "id": decoders.nullable(IDStringDecoder),
    attributes: decoders.object({
      "result": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "result": obj.attributes["result"],
    }
  })
)

export interface FeedbackSubject {
  readonly "id": IDString
  readonly "name": string
}

export const FeedbackSubjectDecoder: decoders.Decoder<FeedbackSubject> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
    }
  })
)

export interface UserAnswerCriteria {
  readonly "criteriaId": IDString
  readonly "value"?: null | string | number
}

export const UserAnswerCriteriaDecoder: decoders.Decoder<UserAnswerCriteria> = decoders.object({
  "criteriaId": IDStringDecoder,
  "value": optionalNullableDecoder(decoders.nullable(decoders.either(
    decoders.string,
    decoders.number
  ))),
})

export interface UserAnswerOption {
  readonly "optionId": IDString
  readonly "value"?: null | string
  readonly "criterias"?: readonly UserAnswerCriteria[]
}

export const UserAnswerOptionDecoder: decoders.Decoder<UserAnswerOption> = decoders.object({
  "optionId": IDStringDecoder,
  "value": optionalNullableDecoder(decoders.nullable(decoders.string)),
  "criterias": optionalNullableDecoder(ArrayObjectDecoder(UserAnswerCriteriaDecoder)),
})

export interface UserAnswer {
  readonly "answer": readonly UserAnswerOption[]
}

export const UserAnswerDecoder: decoders.Decoder<UserAnswer> = (
  decoders.object({
    attributes: decoders.object({
      "answer": ArrayObjectDecoder(UserAnswerOptionDecoder),
    }),
  })
  .transform(obj => {
    return {
      "answer": obj.attributes["answer"],
    }
  })
)

export type SurveyQuestionType =
  | "TEXT"
  | "CHECKBOXES"
  | "CHECKBOXES_OTHER"
  | "RADIOS"
  | "RADIOS_OTHER"
  | "MULTI_CHECKBOXES"
  | "MULTI_RADIOS"
  | "COURSES_CHECKBOXES"
  | "COURSES_RADIOS"
  | "COURSES_TEXTS"
  | "COURSES_DROPDOWNS"

export const SurveyQuestionTypeDecoder: decoders.Decoder<SurveyQuestionType> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "TEXT"
      case 2: return "CHECKBOXES"
      case 3: return "CHECKBOXES_OTHER"
      case 4: return "RADIOS"
      case 5: return "RADIOS_OTHER"
      case 6: return "MULTI_CHECKBOXES"
      case 7: return "MULTI_RADIOS"
      case 11: return "COURSES_CHECKBOXES"
      case 12: return "COURSES_RADIOS"
      case 13: return "COURSES_TEXTS"
      case 14: return "COURSES_DROPDOWNS"
    }

    throw new Error(`Could not decode SurveyQuestionType from value: ${key}`)
  })
)

export function SurveyQuestionTypeEncoder (label: SurveyQuestionType): string | number {
  switch (label) {
    case "TEXT": return 1
    case "CHECKBOXES": return 2
    case "CHECKBOXES_OTHER": return 3
    case "RADIOS": return 4
    case "RADIOS_OTHER": return 5
    case "MULTI_CHECKBOXES": return 6
    case "MULTI_RADIOS": return 7
    case "COURSES_CHECKBOXES": return 11
    case "COURSES_RADIOS": return 12
    case "COURSES_TEXTS": return 13
    case "COURSES_DROPDOWNS": return 14
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const SurveyQuestionTypeValues = [
  "TEXT",
  "CHECKBOXES",
  "CHECKBOXES_OTHER",
  "RADIOS",
  "RADIOS_OTHER",
  "MULTI_CHECKBOXES",
  "MULTI_RADIOS",
  "COURSES_CHECKBOXES",
  "COURSES_RADIOS",
  "COURSES_TEXTS",
  "COURSES_DROPDOWNS",
] as const

export interface SurveyProgress {
  readonly "questionsAnswered": number
  readonly "progress": number
}

export const SurveyProgressDecoder: decoders.Decoder<SurveyProgress> = (
  decoders.object({
    attributes: decoders.object({
      "questionsAnswered": decoders.number,
      "progress": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "questionsAnswered": obj.attributes["questionsAnswered"],
      "progress": obj.attributes["progress"],
    }
  })
)

export interface Survey {
  readonly "id": IDString
  readonly "title": string
  readonly "text": string
  readonly "finishText": string
  readonly "perPage": number
  readonly "intensity": boolean
  readonly "intensityNum": number
  readonly "questionsCount": number
  readonly "SurveyProgress": SurveyProgress
}

export const SurveyDecoder: decoders.Decoder<Survey> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "title": decoders.string,
      "text": decoders.string,
      "finishText": decoders.string,
      "perPage": decoders.number,
      "intensity": decoders.boolean,
      "intensityNum": decoders.number,
      "questionsCount": decoders.number,
    }),
    relationships: decoders.object({
      "SurveyProgress": decoders.object({
        data: SurveyProgressDecoder
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "title": obj.attributes["title"],
      "text": obj.attributes["text"],
      "finishText": obj.attributes["finishText"],
      "perPage": obj.attributes["perPage"],
      "intensity": obj.attributes["intensity"],
      "intensityNum": obj.attributes["intensityNum"],
      "questionsCount": obj.attributes["questionsCount"],
      "SurveyProgress": obj.relationships["SurveyProgress"].data,
    }
  })
)

export interface SurveyQuestionOption {
  readonly "id": null | IDString
  readonly "type": string
  readonly "title": string
  readonly "customAllowed": boolean
  readonly "bcolor": null | string
  readonly "fcolor": null | string
}

export const SurveyQuestionOptionDecoder: decoders.Decoder<SurveyQuestionOption> = (
  decoders.object({
    "id": decoders.nullable(IDStringDecoder),
    "type": decoders.string,
    attributes: decoders.object({
      "title": decoders.string,
      "customAllowed": decoders.boolean,
      "bcolor": decoders.nullable(decoders.string),
      "fcolor": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "type": obj["type"],
      "title": obj.attributes["title"],
      "customAllowed": obj.attributes["customAllowed"],
      "bcolor": obj.attributes["bcolor"],
      "fcolor": obj.attributes["fcolor"],
    }
  })
)

export interface SurveyQuestionCriteria {
  readonly "id": IDString
  readonly "title": string
}

export const SurveyQuestionCriteriaDecoder: decoders.Decoder<SurveyQuestionCriteria> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "title": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "title": obj.attributes["title"],
    }
  })
)

export interface LecturerSurveyList {
  readonly "id": IDString
  readonly "title": string
}

export const LecturerSurveyListDecoder: decoders.Decoder<LecturerSurveyList> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "title": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "title": obj.attributes["title"],
    }
  })
)

export interface SurveyQuestion {
  readonly "id": IDString
  readonly "type": SurveyQuestionType
  readonly "bcolor": null | string
  readonly "fcolor": null | string
  readonly "title": string
  readonly "required": boolean
  readonly "options": readonly SurveyQuestionOption[]
  readonly "criterias"?: readonly SurveyQuestionCriteria[]
  readonly "userAnswer"?: UserAnswer
}

export const SurveyQuestionDecoder: decoders.Decoder<SurveyQuestion> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "type": SurveyQuestionTypeDecoder,
      "bcolor": decoders.nullable(decoders.string),
      "fcolor": decoders.nullable(decoders.string),
      "title": decoders.string,
      "required": decoders.boolean,
    }),
    relationships: decoders.object({
      "options": decoders.object({
        data: ArrayObjectDecoder(SurveyQuestionOptionDecoder)
      }),
      "criterias": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(SurveyQuestionCriteriaDecoder))
      })),
      "userAnswer": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(UserAnswerDecoder)
      })),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "type": obj.attributes["type"],
      "bcolor": obj.attributes["bcolor"],
      "fcolor": obj.attributes["fcolor"],
      "title": obj.attributes["title"],
      "required": obj.attributes["required"],
      "options": obj.relationships["options"].data,
      "criterias": obj?.relationships?.["criterias"]?.data,
      "userAnswer": obj?.relationships?.["userAnswer"]?.data,
    }
  })
)

export interface QuestionAnswerRequest {
  readonly "questionId": number
  readonly "answers": null | readonly UserAnswerOption[]
}

export const QuestionAnswerRequestDecoder: decoders.Decoder<QuestionAnswerRequest> = decoders.object({
  "questionId": decoders.number,
  "answers": decoders.nullable(ArrayObjectDecoder(UserAnswerOptionDecoder)),
})

export interface Feedback {
  readonly "id": IDString
  readonly "text": string
  readonly "number": string
  readonly "status": number
  readonly "date": string
  readonly "subjectId": number
  readonly "comment": string
  readonly "commentDate": null | string
  readonly "subject": FeedbackSubject
  readonly "mediaFiles"?: readonly MediaFile[]
}

export const FeedbackDecoder: decoders.Decoder<Feedback> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "text": decoders.string,
      "number": decoders.string,
      "status": decoders.number,
      "date": decoders.string,
      "subjectId": decoders.number,
      "comment": decoders.string,
      "commentDate": decoders.nullable(decoders.string),
    }),
    relationships: decoders.object({
      "subject": decoders.object({
        data: FeedbackSubjectDecoder
      }),
      "mediaFiles": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(MediaFileDecoder))
      })),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "text": obj.attributes["text"],
      "number": obj.attributes["number"],
      "status": obj.attributes["status"],
      "date": obj.attributes["date"],
      "subjectId": obj.attributes["subjectId"],
      "comment": obj.attributes["comment"],
      "commentDate": obj.attributes["commentDate"],
      "subject": obj.relationships["subject"].data,
      "mediaFiles": obj?.relationships?.["mediaFiles"]?.data,
    }
  })
)

export interface Registration {
  readonly "id": IDString
  readonly "firstname": string
  readonly "lastname": string
  readonly "mail": string
  readonly "regProgs": readonly RegProg[]
  readonly "testType"?: TestType
  readonly "examCourse"?: ExamCourse
}

export const RegistrationDecoder: decoders.Decoder<Registration> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "firstname": decoders.string,
      "lastname": decoders.string,
      "mail": decoders.string,
    }),
    relationships: decoders.object({
      "regProgs": decoders.object({
        data: ArrayObjectDecoder(RegProgDecoder)
      }),
      "testType": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(TestTypeDecoder)
      })),
      "examCourse": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ExamCourseDecoder)
      })),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "firstname": obj.attributes["firstname"],
      "lastname": obj.attributes["lastname"],
      "mail": obj.attributes["mail"],
      "regProgs": obj.relationships["regProgs"].data,
      "testType": obj?.relationships?.["testType"]?.data,
      "examCourse": obj?.relationships?.["examCourse"]?.data,
    }
  })
)

export type CountTypeEnum =
  | "COUNT"
  | "PERCENT"
  | "AVERAGE"

export const CountTypeEnumDecoder: decoders.Decoder<CountTypeEnum> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "COUNT"
      case 2: return "PERCENT"
      case 3: return "AVERAGE"
    }

    throw new Error(`Could not decode CountTypeEnum from value: ${key}`)
  })
)

export function CountTypeEnumEncoder (label: CountTypeEnum): string | number {
  switch (label) {
    case "COUNT": return 1
    case "PERCENT": return 2
    case "AVERAGE": return 3
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const CountTypeEnumValues = [
  "COUNT",
  "PERCENT",
  "AVERAGE",
] as const

export type ChartTypeEnum =
  | "COLUMN"
  | "PIE"
  | "BAR"

export const ChartTypeEnumDecoder: decoders.Decoder<ChartTypeEnum> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 1: return "COLUMN"
      case 2: return "PIE"
      case 3: return "BAR"
    }

    throw new Error(`Could not decode ChartTypeEnum from value: ${key}`)
  })
)

export function ChartTypeEnumEncoder (label: ChartTypeEnum): string | number {
  switch (label) {
    case "COLUMN": return 1
    case "PIE": return 2
    case "BAR": return 3
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const ChartTypeEnumValues = [
  "COLUMN",
  "PIE",
  "BAR",
] as const

export interface SurveyChartPieData {
  readonly "name": string
  readonly "visible"?: boolean
  readonly "y"?: number
}

export const SurveyChartPieDataDecoder: decoders.Decoder<SurveyChartPieData> = decoders.object({
  "name": decoders.string,
  "visible": optionalNullableDecoder(decoders.boolean),
  "y": optionalNullableDecoder(decoders.number),
})

export type SurveyChartDataUnionType = number | SurveyChartPieData

export const SurveyChartDataUnionTypeDecoder: decoders.Decoder<SurveyChartDataUnionType> = decoders.either(
  decoders.number,
  SurveyChartPieDataDecoder
)

export interface SurveyChartData {
  readonly "name"?: string
  readonly "visible"?: boolean
  readonly "data": readonly SurveyChartDataUnionType[]
  readonly "center"?: readonly number[]
  readonly "size"?: number
}

export const SurveyChartDataDecoder: decoders.Decoder<SurveyChartData> = decoders.object({
  "name": optionalNullableDecoder(decoders.string),
  "visible": optionalNullableDecoder(decoders.boolean),
  "data": ArrayObjectDecoder(SurveyChartDataUnionTypeDecoder),
  "center": optionalNullableDecoder(ArrayObjectDecoder(decoders.number)),
  "size": optionalNullableDecoder(decoders.number),
})

export interface SurveyChart {
  readonly "id"?: null | IDString
  readonly "countType": CountTypeEnum
  readonly "chartType": ChartTypeEnum
  readonly "chartAxisTitle": string
  readonly "title": string
  readonly "categories": readonly string[]
  readonly "groups": readonly SurveyChartData[]
}

export const SurveyChartDecoder: decoders.Decoder<SurveyChart> = (
  decoders.object({
    "id": decoders.nullable(IDStringDecoder),
    attributes: decoders.object({
      "countType": CountTypeEnumDecoder,
      "chartType": ChartTypeEnumDecoder,
      "chartAxisTitle": decoders.string,
      "title": decoders.string,
      "categories": ArrayObjectDecoder(decoders.string),
      "groups": ArrayObjectDecoder(SurveyChartDataDecoder),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "countType": obj.attributes["countType"],
      "chartType": obj.attributes["chartType"],
      "chartAxisTitle": obj.attributes["chartAxisTitle"],
      "title": obj.attributes["title"],
      "categories": obj.attributes["categories"],
      "groups": obj.attributes["groups"],
    }
  })
)

export type MailStatusEnum =
  | "PROCESSING"
  | "SENT"
  | "FAILED"

export const MailStatusEnumDecoder: decoders.Decoder<MailStatusEnum> = (
  decoders.either(decoders.number, decoders.string)
  .transform(key => {
    switch (key) {
      case 0: return "PROCESSING"
      case 1: return "SENT"
      case 2: return "FAILED"
    }

    throw new Error(`Could not decode MailStatusEnum from value: ${key}`)
  })
)

export function MailStatusEnumEncoder (label: MailStatusEnum): string | number {
  switch (label) {
    case "PROCESSING": return 0
    case "SENT": return 1
    case "FAILED": return 2
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Could not decode __UNNAMED_TYPE__ from value: ${label}`)
  }
}

export const MailStatusEnumValues = [
  "PROCESSING",
  "SENT",
  "FAILED",
] as const

export interface MailStatus {
  readonly "id": null | IDString
  readonly "label": string
}

export const MailStatusDecoder: decoders.Decoder<MailStatus> = decoders.object({
  "id": decoders.nullable(IDStringDecoder),
  "label": decoders.string,
})

export interface Mail {
  readonly "id"?: null | IDString
  readonly "address": string
  readonly "subject": string
  readonly "statusMsg"?: string
  readonly "status": MailStatusEnum
  readonly "date": string
}

export const MailDecoder: decoders.Decoder<Mail> = (
  decoders.object({
    "id": decoders.nullable(IDStringDecoder),
    attributes: decoders.object({
      "address": decoders.string,
      "subject": decoders.string,
      "statusMsg": optionalNullableDecoder(decoders.string),
      "status": MailStatusEnumDecoder,
      "date": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "address": obj.attributes["address"],
      "subject": obj.attributes["subject"],
      "statusMsg": obj.attributes["statusMsg"],
      "status": obj.attributes["status"],
      "date": obj.attributes["date"],
    }
  })
)

export interface AdministratorBulkMessageUnmatchedRow {
  readonly "row": number
  readonly "value": IDString
  readonly "reasonCode": string
  readonly "reason": string
}

export const AdministratorBulkMessageUnmatchedRowDecoder: decoders.Decoder<AdministratorBulkMessageUnmatchedRow> = decoders.object({
  "row": decoders.number,
  "value": IDStringDecoder,
  "reasonCode": decoders.string,
  "reason": decoders.string,
})

export interface AdministratorBulkMessage {
  readonly "batchId": IDString
  readonly "totalRows": number
  readonly "dispatchedCount": number
  readonly "unmatched": readonly AdministratorBulkMessageUnmatchedRow[]
}

export const AdministratorBulkMessageDecoder: decoders.Decoder<AdministratorBulkMessage> = decoders.object({
  "batchId": IDStringDecoder,
  "totalRows": decoders.number,
  "dispatchedCount": decoders.number,
  "unmatched": ArrayObjectDecoder(AdministratorBulkMessageUnmatchedRowDecoder),
})

export interface AdministratorBulkMessageRejected {
  readonly "type": "AdministratorBulkMessageRejected"
  readonly "message": string
  readonly "data": {
    readonly "totalRows": number
    readonly "unmatched": readonly AdministratorBulkMessageUnmatchedRow[]
  }
}

export const AdministratorBulkMessageRejectedDecoder: decoders.Decoder<AdministratorBulkMessageRejected> = decoders.object({
  "type": decoders.hardcoded("AdministratorBulkMessageRejected" as const),
  "message": decoders.string,
  "data": decoders.object({
    "totalRows": decoders.number,
    "unmatched": ArrayObjectDecoder(AdministratorBulkMessageUnmatchedRowDecoder),
  }),
})

export interface AdministratorBulkMessageProgress {
  readonly "total": number
  readonly "processed": number
}

export const AdministratorBulkMessageProgressDecoder: decoders.Decoder<AdministratorBulkMessageProgress> = decoders.object({
  "total": decoders.number,
  "processed": decoders.number,
})

export interface ScoreDistribution {
  readonly "categories": {
    readonly "id"?: null | IDString
    readonly "attributes"?: readonly string[]
  }
  readonly "groups": {
    readonly "id"?: null | IDString
    readonly "attributes": ReadonlyArray<{
      readonly "name": string
      readonly "data": readonly number[]
      readonly "visible"?: boolean
    }>
  }
}

export const ScoreDistributionDecoder: decoders.Decoder<ScoreDistribution> = decoders.object({
  "categories": decoders.object({
    "id": optionalNullableDecoder(decoders.nullable(IDStringDecoder)),
    "attributes": optionalNullableDecoder(ArrayObjectDecoder(decoders.string)),
  }),
  "groups": decoders.object({
    "id": optionalNullableDecoder(decoders.nullable(IDStringDecoder)),
    "attributes": ArrayObjectDecoder(decoders.object({
      "name": decoders.string,
      "data": ArrayObjectDecoder(decoders.number),
      "visible": optionalNullableDecoder(decoders.boolean),
    })),
  }),
})

export interface AdministratorStatisticsData {
  readonly "name": string
  readonly "visible"?: boolean
  readonly "y"?: number
}

export const AdministratorStatisticsDataDecoder: decoders.Decoder<AdministratorStatisticsData> = decoders.object({
  "name": decoders.string,
  "visible": optionalNullableDecoder(decoders.boolean),
  "y": optionalNullableDecoder(decoders.number),
})

export type AdministratorGraduatesStatisticsType = "willQualifyCourses" | "willQualifyList" | "qualifiedCourses" | "qualifiedList"

export const AdministratorGraduatesStatisticsTypeDecoder: decoders.Decoder<AdministratorGraduatesStatisticsType> = decoders.either(
  decoders.constant("willQualifyCourses" as const),
  decoders.constant("willQualifyList" as const),
  decoders.constant("qualifiedCourses" as const),
  decoders.constant("qualifiedList" as const)
)

export interface AdministratorGraduatesStatisticsMeta {
  readonly "currentPage": number
  readonly "lastPage": number
  readonly "perPage": number
  readonly "total": number
  readonly "rowsCount": number
  readonly "headers": readonly string[]
}

export const AdministratorGraduatesStatisticsMetaDecoder: decoders.Decoder<AdministratorGraduatesStatisticsMeta> = decoders.object({
  "currentPage": decoders.number,
  "lastPage": decoders.number,
  "perPage": decoders.number,
  "total": decoders.number,
  "rowsCount": decoders.number,
  "headers": ArrayObjectDecoder(decoders.string),
})

export type AdministratorGraduatesJobStatus = "pending" | "done" | "failed"

export const AdministratorGraduatesJobStatusDecoder: decoders.Decoder<AdministratorGraduatesJobStatus> = decoders.either(
  decoders.constant("pending" as const),
  decoders.constant("done" as const),
  decoders.constant("failed" as const)
)

export interface AdministratorGraduatesExport {
  readonly "exportId": IDString
  readonly "status": AdministratorGraduatesJobStatus
  readonly "downloadUrl"?: null | string
  readonly "expiresAt"?: null | string
  readonly "message"?: null | string
}

export const AdministratorGraduatesExportDecoder: decoders.Decoder<AdministratorGraduatesExport> = decoders.object({
  "exportId": IDStringDecoder,
  "status": AdministratorGraduatesJobStatusDecoder,
  "downloadUrl": optionalNullableDecoder(decoders.nullable(decoders.string)),
  "expiresAt": optionalNullableDecoder(decoders.nullable(decoders.string)),
  "message": optionalNullableDecoder(decoders.nullable(decoders.string)),
})

export interface AdministratorGraduatesSearch {
  readonly "searchId": IDString
  readonly "status": AdministratorGraduatesJobStatus
  readonly "progress"?: number
  readonly "message"?: null | string
}

export const AdministratorGraduatesSearchDecoder: decoders.Decoder<AdministratorGraduatesSearch> = decoders.object({
  "searchId": IDStringDecoder,
  "status": AdministratorGraduatesJobStatusDecoder,
  "progress": optionalNullableDecoder(decoders.number),
  "message": optionalNullableDecoder(decoders.nullable(decoders.string)),
})

export type AdministratorListsOption = { readonly id: string; readonly name: string }

export const AdministratorListsOptionDecoder: decoders.Decoder<AdministratorListsOption> = decoders.object({ id: decoders.optional(decoders.either(decoders.number, decoders.string)), value: decoders.optional(decoders.either(decoders.number, decoders.string)), name: decoders.string }).transform(o => ({ id: String(o.id ?? o.value ?? ''), name: o.name }))

export interface AdministratorStatistics {
  readonly "id"?: null | IDString
  readonly "total": string
  readonly "series": readonly number[]
  readonly "categories": readonly string[]
  readonly "data": readonly AdministratorStatisticsData[]
}

export const AdministratorStatisticsDecoder: decoders.Decoder<AdministratorStatistics> = (
  decoders.object({
    "id": decoders.nullable(IDStringDecoder),
    attributes: decoders.object({
      "total": decoders.string,
      "series": ArrayObjectDecoder(decoders.number),
      "categories": ArrayObjectDecoder(decoders.string),
      "data": ArrayObjectDecoder(AdministratorStatisticsDataDecoder),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "total": obj.attributes["total"],
      "series": obj.attributes["series"],
      "categories": obj.attributes["categories"],
      "data": obj.attributes["data"],
    }
  })
)

export interface Degree {
  readonly "id": IDString
  readonly "name": string
  readonly "formalName": string
  readonly "type": number
}

export const DegreeDecoder: decoders.Decoder<Degree> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "formalName": decoders.string,
      "type": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "formalName": obj.attributes["formalName"],
      "type": obj.attributes["type"],
    }
  })
)

export interface Definitions {
  readonly "value": IDString
  readonly "label": IDString
}

export const DefinitionsDecoder: decoders.Decoder<Definitions> = decoders.object({
  "value": IDStringDecoder,
  "label": IDStringDecoder,
})

export interface RegimeDefinitions {
  readonly "types": readonly Definitions[]
  readonly "statuses": readonly Definitions[]
  readonly "allowLogin": readonly Definitions[]
  readonly "allowChoose": readonly Definitions[]
  readonly "schedules": readonly Definitions[]
  readonly "surveys": readonly Definitions[]
  readonly "surveysLector": readonly Definitions[]
  readonly "scoresLector": readonly Definitions[]
}

export const RegimeDefinitionsDecoder: decoders.Decoder<RegimeDefinitions> = decoders.object({
  "types": ArrayObjectDecoder(DefinitionsDecoder),
  "statuses": ArrayObjectDecoder(DefinitionsDecoder),
  "allowLogin": ArrayObjectDecoder(DefinitionsDecoder),
  "allowChoose": ArrayObjectDecoder(DefinitionsDecoder),
  "schedules": ArrayObjectDecoder(DefinitionsDecoder),
  "surveys": ArrayObjectDecoder(DefinitionsDecoder),
  "surveysLector": ArrayObjectDecoder(DefinitionsDecoder),
  "scoresLector": ArrayObjectDecoder(DefinitionsDecoder),
})

export interface FileDefinitions {
  readonly "statuses": readonly Definitions[]
  readonly "storages": readonly Definitions[]
}

export const FileDefinitionsDecoder: decoders.Decoder<FileDefinitions> = decoders.object({
  "statuses": ArrayObjectDecoder(DefinitionsDecoder),
  "storages": ArrayObjectDecoder(DefinitionsDecoder),
})

export interface PortfolioDefinitions {
  readonly "statuses": readonly Definitions[]
  readonly "workTypes": readonly Definitions[]
}

export const PortfolioDefinitionsDecoder: decoders.Decoder<PortfolioDefinitions> = decoders.object({
  "statuses": ArrayObjectDecoder(DefinitionsDecoder),
  "workTypes": ArrayObjectDecoder(DefinitionsDecoder),
})

export interface PortfolioListsCompetency {
  readonly "id": IDString
  readonly "name": string
  readonly "nameEn": string
}

export const PortfolioListsCompetencyDecoder: decoders.Decoder<PortfolioListsCompetency> = decoders.object({
  "id": IDStringDecoder,
  "name": decoders.string,
  "nameEn": decoders.string,
})

export interface PortfolioListsCriteria {
  readonly "id": IDString
  readonly "name": string
  readonly "nameEn": string
}

export const PortfolioListsCriteriaDecoder: decoders.Decoder<PortfolioListsCriteria> = decoders.object({
  "id": IDStringDecoder,
  "name": decoders.string,
  "nameEn": decoders.string,
})

export interface PortfolioListsSection {
  readonly "id": IDString
  readonly "name": string
  readonly "nameEn": string
}

export const PortfolioListsSectionDecoder: decoders.Decoder<PortfolioListsSection> = decoders.object({
  "id": IDStringDecoder,
  "name": decoders.string,
  "nameEn": decoders.string,
})

export interface PortfolioListsMentor {
  readonly "id": IDString
  readonly "userId": IDString
  readonly "name": string
  readonly "persNum": string
  readonly "email": string
}

export const PortfolioListsMentorDecoder: decoders.Decoder<PortfolioListsMentor> = decoders.object({
  "id": IDStringDecoder,
  "userId": IDStringDecoder,
  "name": decoders.string,
  "persNum": decoders.string,
  "email": decoders.string,
})

export interface PortfolioListsSemester {
  readonly "id": IDString
  readonly "name": string
}

export const PortfolioListsSemesterDecoder: decoders.Decoder<PortfolioListsSemester> = decoders.object({
  "id": IDStringDecoder,
  "name": decoders.string,
})

export interface PortfolioListsStudent {
  readonly "id": IDString
  readonly "userId": IDString
  readonly "name": string
  readonly "persNum": string
  readonly "semester": number
}

export const PortfolioListsStudentDecoder: decoders.Decoder<PortfolioListsStudent> = decoders.object({
  "id": IDStringDecoder,
  "userId": IDStringDecoder,
  "name": decoders.string,
  "persNum": decoders.string,
  "semester": decoders.number,
})

export interface PortfolioSection {
  readonly "id": IDString
  readonly "name": string
  readonly "nameEn": string
  readonly "workTitle": string
  readonly "workTitleEn": string
}

export const PortfolioSectionDecoder: decoders.Decoder<PortfolioSection> = decoders.object({
  "id": IDStringDecoder,
  "name": decoders.string,
  "nameEn": decoders.string,
  "workTitle": decoders.string,
  "workTitleEn": decoders.string,
})

export interface AdministratorPortfolioStatus {
  readonly "value": IDString
  readonly "name": string
}

export const AdministratorPortfolioStatusDecoder: decoders.Decoder<AdministratorPortfolioStatus> = decoders.object({
  "value": IDStringDecoder,
  "name": decoders.string,
})

export interface AdministratorPortfolioScore {
  readonly "id": IDString
  readonly "competencyId": number
  readonly "competency": {
    readonly "name": string
    readonly "nameEn": string
  }
  readonly "text": null | string
}

export const AdministratorPortfolioScoreDecoder: decoders.Decoder<AdministratorPortfolioScore> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "competencyId": decoders.number,
      "competency": decoders.object({
        "name": decoders.string,
        "nameEn": decoders.string,
      }),
      "text": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "competencyId": obj.attributes["competencyId"],
      "competency": obj.attributes["competency"],
      "text": obj.attributes["text"],
    }
  })
)

export interface UserWorkScore {
  readonly "id": IDString
  readonly "competencyId": number
  readonly "criteriaId": number
  readonly "score": number
  readonly "feedback": null | string
}

export const UserWorkScoreDecoder: decoders.Decoder<UserWorkScore> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "competencyId": decoders.number,
      "criteriaId": decoders.number,
      "score": decoders.number,
      "feedback": decoders.nullable(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "competencyId": obj.attributes["competencyId"],
      "criteriaId": obj.attributes["criteriaId"],
      "score": obj.attributes["score"],
      "feedback": obj.attributes["feedback"],
    }
  })
)

export interface SectionCompetencies {
  readonly "id": IDString
  readonly "name": string
  readonly "nameEn": string
  readonly "criterions": ReadonlyArray<{
    readonly "id": IDString
    readonly "name": string
    readonly "nameEn": string
    readonly "min": number
    readonly "max": number
  }>
}

export const SectionCompetenciesDecoder: decoders.Decoder<SectionCompetencies> = decoders.object({
  "id": IDStringDecoder,
  "name": decoders.string,
  "nameEn": decoders.string,
  "criterions": ArrayObjectDecoder(decoders.object({
    "id": IDStringDecoder,
    "name": decoders.string,
    "nameEn": decoders.string,
    "min": decoders.number,
    "max": decoders.number,
  })),
})

export interface AdministratorPortfolioWork {
  readonly "id": IDString
  readonly "userId": number
  readonly "profileId": number
  readonly "mentorId": null | number
  readonly "portfolioSectionId": number
  readonly "student": null | {
    readonly "id": IDString
    readonly "name": string
    readonly "persNum": string
    readonly "email": string
  }
  readonly "mentor": null | {
    readonly "id": IDString
    readonly "name": string
    readonly "persNum": string
    readonly "email": string
  }
  readonly "section": null | {
    readonly "id": IDString
    readonly "name": string
    readonly "nameEn": string
    readonly "workType": IDString
  }
  readonly "semId": number
  readonly "comment"?: null | string
  readonly "text"?: null | string
  readonly "semester": number
  readonly "status": AdministratorPortfolioStatus
  readonly "isEditable": boolean
  readonly "createdAt": string
  readonly "updatedAt": string
  readonly "sectionCompetencies"?: readonly SectionCompetencies[]
  readonly "workCompetencies"?: readonly AdministratorPortfolioScore[]
  readonly "scores"?: readonly UserWorkScore[]
}

export const AdministratorPortfolioWorkDecoder: decoders.Decoder<AdministratorPortfolioWork> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "userId": decoders.number,
      "profileId": decoders.number,
      "mentorId": decoders.nullable(decoders.number),
      "portfolioSectionId": decoders.number,
      "student": decoders.nullable(decoders.object({
        "id": IDStringDecoder,
        "name": decoders.string,
        "persNum": decoders.string,
        "email": decoders.string,
      })),
      "mentor": decoders.nullable(decoders.object({
        "id": IDStringDecoder,
        "name": decoders.string,
        "persNum": decoders.string,
        "email": decoders.string,
      })),
      "section": decoders.nullable(decoders.object({
        "id": IDStringDecoder,
        "name": decoders.string,
        "nameEn": decoders.string,
        "workType": IDStringDecoder,
      })),
      "semId": decoders.number,
      "comment": optionalNullableDecoder(decoders.nullable(decoders.string)),
      "text": optionalNullableDecoder(decoders.nullable(decoders.string)),
      "semester": decoders.number,
      "status": AdministratorPortfolioStatusDecoder,
      "isEditable": decoders.boolean,
      "createdAt": decoders.string,
      "updatedAt": decoders.string,
      "sectionCompetencies": optionalNullableDecoder(ArrayObjectDecoder(SectionCompetenciesDecoder)),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "workCompetencies": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(AdministratorPortfolioScoreDecoder))
      })),
      "scores": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(UserWorkScoreDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "userId": obj.attributes["userId"],
      "profileId": obj.attributes["profileId"],
      "mentorId": obj.attributes["mentorId"],
      "portfolioSectionId": obj.attributes["portfolioSectionId"],
      "student": obj.attributes["student"],
      "mentor": obj.attributes["mentor"],
      "section": obj.attributes["section"],
      "semId": obj.attributes["semId"],
      "comment": obj.attributes["comment"],
      "text": obj.attributes["text"],
      "semester": obj.attributes["semester"],
      "status": obj.attributes["status"],
      "isEditable": obj.attributes["isEditable"],
      "createdAt": obj.attributes["createdAt"],
      "updatedAt": obj.attributes["updatedAt"],
      "sectionCompetencies": obj.attributes["sectionCompetencies"],
      "workCompetencies": obj?.relationships?.["workCompetencies"]?.data,
      "scores": obj?.relationships?.["scores"]?.data,
    }
  })
)

export interface AdministratorPortfolioLimitSection {
  readonly "id": IDString
  readonly "name": string
}

export const AdministratorPortfolioLimitSectionDecoder: decoders.Decoder<AdministratorPortfolioLimitSection> = decoders.object({
  "id": IDStringDecoder,
  "name": decoders.string,
})

export interface AdministratorPortfolioLimit {
  readonly "id": IDString
  readonly "sectionId": number
  readonly "semId": number
  readonly "userId": number
  readonly "profileId": number
  readonly "semester": number
  readonly "allowed": number
  readonly "student": {
    readonly "id": IDString
    readonly "name": string
    readonly "persNum": string
    readonly "email": string
  }
  readonly "section": {
    readonly "id": IDString
    readonly "name": string
    readonly "nameEn": string
    readonly "workType": number
  }
  readonly "createdAt": string
  readonly "updatedAt": string
}

export const AdministratorPortfolioLimitDecoder: decoders.Decoder<AdministratorPortfolioLimit> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "sectionId": decoders.number,
      "semId": decoders.number,
      "userId": decoders.number,
      "profileId": decoders.number,
      "semester": decoders.number,
      "allowed": decoders.number,
      "student": decoders.object({
        "id": IDStringDecoder,
        "name": decoders.string,
        "persNum": decoders.string,
        "email": decoders.string,
      }),
      "section": decoders.object({
        "id": IDStringDecoder,
        "name": decoders.string,
        "nameEn": decoders.string,
        "workType": decoders.number,
      }),
      "createdAt": decoders.string,
      "updatedAt": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "sectionId": obj.attributes["sectionId"],
      "semId": obj.attributes["semId"],
      "userId": obj.attributes["userId"],
      "profileId": obj.attributes["profileId"],
      "semester": obj.attributes["semester"],
      "allowed": obj.attributes["allowed"],
      "student": obj.attributes["student"],
      "section": obj.attributes["section"],
      "createdAt": obj.attributes["createdAt"],
      "updatedAt": obj.attributes["updatedAt"],
    }
  })
)

export interface CacheKey {
  readonly "key"?: string
  readonly "ttl"?: number
  readonly "server"?: string
  readonly "expires_at"?: string
  readonly "expires_in"?: string
}

export const CacheKeyDecoder: decoders.Decoder<CacheKey> = (
  decoders.object({
    attributes: decoders.object({
      "key": optionalNullableDecoder(decoders.string),
      "ttl": optionalNullableDecoder(decoders.number),
      "server": optionalNullableDecoder(decoders.string),
      "expires_at": optionalNullableDecoder(decoders.string),
      "expires_in": optionalNullableDecoder(decoders.string),
    }),
  })
  .transform(obj => {
    return {
      "key": obj.attributes["key"],
      "ttl": obj.attributes["ttl"],
      "server": obj.attributes["server"],
      "expires_at": obj.attributes["expires_at"],
      "expires_in": obj.attributes["expires_in"],
    }
  })
)

export interface AdministratorPortfolioDegree {
  readonly "value": StudentDegree
  readonly "name": string
}

export const AdministratorPortfolioDegreeDecoder: decoders.Decoder<AdministratorPortfolioDegree> = decoders.object({
  "value": StudentDegreeDecoder,
  "name": decoders.string,
})

export interface AdministratorPortfolioWorkTypes {
  readonly "value": IDString
  readonly "name": string
}

export const AdministratorPortfolioWorkTypesDecoder: decoders.Decoder<AdministratorPortfolioWorkTypes> = decoders.object({
  "value": IDStringDecoder,
  "name": decoders.string,
})

export interface AdministratorPortfolioCriteria {
  readonly "id": IDString
  readonly "name": string
  readonly "nameEn": string
  readonly "description": string
  readonly "descriptionEn": string
  readonly "pivot"?: {
    readonly "min": number
    readonly "max": number
  }
  readonly "status": AdministratorPortfolioStatus
  readonly "semId": number
  readonly "createdAt": string
  readonly "updatedAt": string
}

export const AdministratorPortfolioCriteriaDecoder: decoders.Decoder<AdministratorPortfolioCriteria> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "nameEn": decoders.string,
      "description": decoders.string,
      "descriptionEn": decoders.string,
      "pivot": optionalNullableDecoder(decoders.object({
        "min": decoders.number,
        "max": decoders.number,
      })),
      "status": AdministratorPortfolioStatusDecoder,
      "semId": decoders.number,
      "createdAt": decoders.string,
      "updatedAt": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "nameEn": obj.attributes["nameEn"],
      "description": obj.attributes["description"],
      "descriptionEn": obj.attributes["descriptionEn"],
      "pivot": obj.attributes["pivot"],
      "status": obj.attributes["status"],
      "semId": obj.attributes["semId"],
      "createdAt": obj.attributes["createdAt"],
      "updatedAt": obj.attributes["updatedAt"],
    }
  })
)

export interface AdministratorPortfolioCompetency {
  readonly "id": IDString
  readonly "name": string
  readonly "nameEn": string
  readonly "description": string
  readonly "descriptionEn": string
  readonly "minScore": null | number
  readonly "maxScore": null | number
  readonly "semId": number
  readonly "status": AdministratorPortfolioStatus
  readonly "createdAt": string
  readonly "updatedAt": string
  readonly "criterias"?: readonly AdministratorPortfolioCriteria[]
}

export const AdministratorPortfolioCompetencyDecoder: decoders.Decoder<AdministratorPortfolioCompetency> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "nameEn": decoders.string,
      "description": decoders.string,
      "descriptionEn": decoders.string,
      "minScore": decoders.nullable(decoders.number),
      "maxScore": decoders.nullable(decoders.number),
      "semId": decoders.number,
      "status": AdministratorPortfolioStatusDecoder,
      "createdAt": decoders.string,
      "updatedAt": decoders.string,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "criterias": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(AdministratorPortfolioCriteriaDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "nameEn": obj.attributes["nameEn"],
      "description": obj.attributes["description"],
      "descriptionEn": obj.attributes["descriptionEn"],
      "minScore": obj.attributes["minScore"],
      "maxScore": obj.attributes["maxScore"],
      "semId": obj.attributes["semId"],
      "status": obj.attributes["status"],
      "createdAt": obj.attributes["createdAt"],
      "updatedAt": obj.attributes["updatedAt"],
      "criterias": obj?.relationships?.["criterias"]?.data,
    }
  })
)

export interface PortfolioSemester {
  readonly "items": ReadonlyArray<{
    readonly "id": IDString
    readonly "text": string
  }>
}

export const PortfolioSemesterDecoder: decoders.Decoder<PortfolioSemester> = decoders.object({
  "items": ArrayObjectDecoder(decoders.object({
    "id": IDStringDecoder,
    "text": decoders.string,
  })),
})

export interface AdministratorPortfolioMentor {
  readonly "id": IDString
  readonly "firstName": string
  readonly "firstNameEn": string
  readonly "lastName": string
  readonly "lastNameEn": string
  readonly "pivot": {
    readonly "quota": number
    readonly "semester": number
    readonly "semId": number
  }
  readonly "profileId": number
  readonly "userId": number
}

export const AdministratorPortfolioMentorDecoder: decoders.Decoder<AdministratorPortfolioMentor> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "firstName": decoders.string,
      "firstNameEn": decoders.string,
      "lastName": decoders.string,
      "lastNameEn": decoders.string,
      "pivot": decoders.object({
        "quota": decoders.number,
        "semester": decoders.number,
        "semId": decoders.number,
      }),
      "profileId": decoders.number,
      "userId": decoders.number,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "firstName": obj.attributes["firstName"],
      "firstNameEn": obj.attributes["firstNameEn"],
      "lastName": obj.attributes["lastName"],
      "lastNameEn": obj.attributes["lastNameEn"],
      "pivot": obj.attributes["pivot"],
      "profileId": obj.attributes["profileId"],
      "userId": obj.attributes["userId"],
    }
  })
)

export interface AdministratorPortfolioSemester {
  readonly "id": IDString
  readonly "sectionId": number
  readonly "semester": number
  readonly "workCount": number
  readonly "createdAt": string
  readonly "updatedAt": string
}

export const AdministratorPortfolioSemesterDecoder: decoders.Decoder<AdministratorPortfolioSemester> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "sectionId": decoders.number,
      "semester": decoders.number,
      "workCount": decoders.number,
      "createdAt": decoders.string,
      "updatedAt": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "sectionId": obj.attributes["sectionId"],
      "semester": obj.attributes["semester"],
      "workCount": obj.attributes["workCount"],
      "createdAt": obj.attributes["createdAt"],
      "updatedAt": obj.attributes["updatedAt"],
    }
  })
)

export interface AdministratorPortfolioSection {
  readonly "id": IDString
  readonly "name": string
  readonly "nameEn": string
  readonly "workTitle": string
  readonly "workTitleEn": string
  readonly "competenciesCount": number
  readonly "min": number
  readonly "max": number
  readonly "status": AdministratorPortfolioStatus
  readonly "degree": AdministratorPortfolioDegree
  readonly "workType": AdministratorPortfolioWorkTypes
  readonly "competencyCount"?: number
  readonly "createdAt": string
  readonly "updatedAt": string
}

export const AdministratorPortfolioSectionDecoder: decoders.Decoder<AdministratorPortfolioSection> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "nameEn": decoders.string,
      "workTitle": decoders.string,
      "workTitleEn": decoders.string,
      "competenciesCount": decoders.number,
      "min": decoders.number,
      "max": decoders.number,
      "status": AdministratorPortfolioStatusDecoder,
      "degree": AdministratorPortfolioDegreeDecoder,
      "workType": AdministratorPortfolioWorkTypesDecoder,
      "competencyCount": optionalNullableDecoder(decoders.number),
      "createdAt": decoders.string,
      "updatedAt": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "nameEn": obj.attributes["nameEn"],
      "workTitle": obj.attributes["workTitle"],
      "workTitleEn": obj.attributes["workTitleEn"],
      "competenciesCount": obj.attributes["competenciesCount"],
      "min": obj.attributes["min"],
      "max": obj.attributes["max"],
      "status": obj.attributes["status"],
      "degree": obj.attributes["degree"],
      "workType": obj.attributes["workType"],
      "competencyCount": obj.attributes["competencyCount"],
      "createdAt": obj.attributes["createdAt"],
      "updatedAt": obj.attributes["updatedAt"],
    }
  })
)

export interface AdministratorPortfolioSectionDetails {
  readonly "id": IDString
  readonly "name": string
  readonly "nameEn": string
  readonly "workTitle": string
  readonly "workTitleEn": string
  readonly "semId": IDString
  readonly "min": number
  readonly "max": number
  readonly "status": AdministratorPortfolioStatus
  readonly "degree": {
    readonly "value": IDString
    readonly "name": string
  }
  readonly "workType": AdministratorPortfolioWorkTypes
  readonly "competencyCount"?: number
  readonly "createdAt": string
  readonly "updatedAt": string
  readonly "competencies": readonly AdministratorPortfolioCompetency[]
  readonly "mentors": readonly AdministratorPortfolioMentor[]
  readonly "semesters": readonly AdministratorPortfolioSemester[]
}

export const AdministratorPortfolioSectionDetailsDecoder: decoders.Decoder<AdministratorPortfolioSectionDetails> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "nameEn": decoders.string,
      "workTitle": decoders.string,
      "workTitleEn": decoders.string,
      "semId": IDStringDecoder,
      "min": decoders.number,
      "max": decoders.number,
      "status": AdministratorPortfolioStatusDecoder,
      "degree": decoders.object({
        "value": IDStringDecoder,
        "name": decoders.string,
      }),
      "workType": AdministratorPortfolioWorkTypesDecoder,
      "competencyCount": optionalNullableDecoder(decoders.number),
      "createdAt": decoders.string,
      "updatedAt": decoders.string,
    }),
    relationships: decoders.object({
      "competencies": decoders.object({
        data: ArrayObjectDecoder(AdministratorPortfolioCompetencyDecoder)
      }),
      "mentors": decoders.object({
        data: ArrayObjectDecoder(AdministratorPortfolioMentorDecoder)
      }),
      "semesters": decoders.object({
        data: ArrayObjectDecoder(AdministratorPortfolioSemesterDecoder)
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "nameEn": obj.attributes["nameEn"],
      "workTitle": obj.attributes["workTitle"],
      "workTitleEn": obj.attributes["workTitleEn"],
      "semId": obj.attributes["semId"],
      "min": obj.attributes["min"],
      "max": obj.attributes["max"],
      "status": obj.attributes["status"],
      "degree": obj.attributes["degree"],
      "workType": obj.attributes["workType"],
      "competencyCount": obj.attributes["competencyCount"],
      "createdAt": obj.attributes["createdAt"],
      "updatedAt": obj.attributes["updatedAt"],
      "competencies": obj.relationships["competencies"].data,
      "mentors": obj.relationships["mentors"].data,
      "semesters": obj.relationships["semesters"].data,
    }
  })
)

export interface AdministratorPortfolioSectionRequest {
  readonly "name": string
  readonly "nameEn": string
  readonly "workTitle": string
  readonly "workTitleEn": string
  readonly "min": number
  readonly "max": number
  readonly "status": number
  readonly "degree": number
  readonly "workType": number
}

export const AdministratorPortfolioSectionRequestDecoder: decoders.Decoder<AdministratorPortfolioSectionRequest> = decoders.object({
  "name": decoders.string,
  "nameEn": decoders.string,
  "workTitle": decoders.string,
  "workTitleEn": decoders.string,
  "min": decoders.number,
  "max": decoders.number,
  "status": decoders.number,
  "degree": decoders.number,
  "workType": decoders.number,
})

export interface AdministratorPortfolioCompetencyRequest {
  readonly "id": readonly IDString[]
  readonly "min": readonly number[]
  readonly "max": readonly number[]
  readonly "criterias"?: readonly AdministratorPortfolioCompetencyRequest[]
}

export const AdministratorPortfolioCompetencyRequestDecoder: decoders.Decoder<AdministratorPortfolioCompetencyRequest> = decoders.object({
  "id": ArrayObjectDecoder(IDStringDecoder),
  "min": ArrayObjectDecoder(decoders.number),
  "max": ArrayObjectDecoder(decoders.number),
  "criterias": optionalNullableDecoder(ArrayObjectDecoder(decoders.lazy(() => AdministratorPortfolioCompetencyRequestDecoder))),
})

export interface AdministratorPortfolioSemesterRequest {
  readonly "id": IDString
  readonly "amount": number
}

export const AdministratorPortfolioSemesterRequestDecoder: decoders.Decoder<AdministratorPortfolioSemesterRequest> = decoders.object({
  "id": IDStringDecoder,
  "amount": decoders.number,
})

export interface AdministratorPortfolioMentorRequest {
  readonly "profileId": IDString
  readonly "quota": number
}

export const AdministratorPortfolioMentorRequestDecoder: decoders.Decoder<AdministratorPortfolioMentorRequest> = decoders.object({
  "profileId": IDStringDecoder,
  "quota": decoders.number,
})

export interface AdministratorPortfolioStudent {
  readonly "id": IDString
  readonly "userId": IDString
  readonly "profileId": IDString
  readonly "mentorId": IDString
  readonly "student": null | {
    readonly "id": IDString
    readonly "name": string
    readonly "persNum": string
    readonly "email": string
  }
  readonly "mentor": null | {
    readonly "id": IDString
    readonly "name": string
    readonly "persNum": string
    readonly "email": string
  }
  readonly "section": null | {
    readonly "id": IDString
    readonly "name": string
    readonly "nameEn": string
    readonly "workType": number
  }
  readonly "portfolioSectionId": IDString
  readonly "semId": IDString
  readonly "status": AdministratorPortfolioStatus
  readonly "semester": number
  readonly "comment": null | string
  readonly "createdAt": string
  readonly "updatedAt": string
}

export const AdministratorPortfolioStudentDecoder: decoders.Decoder<AdministratorPortfolioStudent> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "userId": IDStringDecoder,
      "profileId": IDStringDecoder,
      "mentorId": IDStringDecoder,
      "student": decoders.nullable(decoders.object({
        "id": IDStringDecoder,
        "name": decoders.string,
        "persNum": decoders.string,
        "email": decoders.string,
      })),
      "mentor": decoders.nullable(decoders.object({
        "id": IDStringDecoder,
        "name": decoders.string,
        "persNum": decoders.string,
        "email": decoders.string,
      })),
      "section": decoders.nullable(decoders.object({
        "id": IDStringDecoder,
        "name": decoders.string,
        "nameEn": decoders.string,
        "workType": decoders.number,
      })),
      "portfolioSectionId": IDStringDecoder,
      "semId": IDStringDecoder,
      "status": AdministratorPortfolioStatusDecoder,
      "semester": decoders.number,
      "comment": decoders.nullable(decoders.string),
      "createdAt": decoders.string,
      "updatedAt": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "userId": obj.attributes["userId"],
      "profileId": obj.attributes["profileId"],
      "mentorId": obj.attributes["mentorId"],
      "student": obj.attributes["student"],
      "mentor": obj.attributes["mentor"],
      "section": obj.attributes["section"],
      "portfolioSectionId": obj.attributes["portfolioSectionId"],
      "semId": obj.attributes["semId"],
      "status": obj.attributes["status"],
      "semester": obj.attributes["semester"],
      "comment": obj.attributes["comment"],
      "createdAt": obj.attributes["createdAt"],
      "updatedAt": obj.attributes["updatedAt"],
    }
  })
)

export interface AdministratorFacultyDegree {
  readonly "attributes": ReadonlyArray<{
    readonly "key": string
    readonly "label": string
  }>
}

export const AdministratorFacultyDegreeDecoder: decoders.Decoder<AdministratorFacultyDegree> = decoders.object({
  "attributes": ArrayObjectDecoder(decoders.object({
    "key": decoders.string,
    "label": decoders.string,
  })),
})

export interface AdministratorFacultyDegreeSemester {
  readonly "value": number
  readonly "semesters": readonly number[]
}

export const AdministratorFacultyDegreeSemesterDecoder: decoders.Decoder<AdministratorFacultyDegreeSemester> = decoders.object({
  "value": decoders.number,
  "semesters": ArrayObjectDecoder(decoders.number),
})

export interface AdministratorFaculty {
  readonly "id": IDString
  readonly "name": string
  readonly "nameEn": string
  readonly "code": string
  readonly "status": {
    readonly "value": number
    readonly "name": string
  }
  readonly "mail": string
  readonly "feedbackMail": string
  readonly "consultationMail": string
  readonly "allowInRegistration": boolean
  readonly "allowInMinorRegistration": boolean
  readonly "hasMajorMinor": {
    readonly "value": number
    readonly "name": string
  }
  readonly "bachelorMajor": AdministratorFacultyDegreeSemester
  readonly "bachelorMinor": AdministratorFacultyDegreeSemester
  readonly "masterMajor": AdministratorFacultyDegreeSemester
  readonly "masterMinor": AdministratorFacultyDegreeSemester
  readonly "doctoralMajor": AdministratorFacultyDegreeSemester
  readonly "doctoralMinor": AdministratorFacultyDegreeSemester
  readonly "professionalMajor": AdministratorFacultyDegreeSemester
  readonly "professionalMinor": AdministratorFacultyDegreeSemester
  readonly "bachelorMasterMinor": AdministratorFacultyDegreeSemester
  readonly "bachelorMasterMajor": AdministratorFacultyDegreeSemester
  readonly "deanUser"?: User
}

export const AdministratorFacultyDecoder: decoders.Decoder<AdministratorFaculty> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "nameEn": decoders.string,
      "code": decoders.string,
      "status": decoders.object({
        "value": decoders.number,
        "name": decoders.string,
      }),
      "mail": decoders.string,
      "feedbackMail": decoders.string,
      "consultationMail": decoders.string,
      "allowInRegistration": decoders.boolean,
      "allowInMinorRegistration": decoders.boolean,
      "hasMajorMinor": decoders.object({
        "value": decoders.number,
        "name": decoders.string,
      }),
      "bachelorMajor": AdministratorFacultyDegreeSemesterDecoder,
      "bachelorMinor": AdministratorFacultyDegreeSemesterDecoder,
      "masterMajor": AdministratorFacultyDegreeSemesterDecoder,
      "masterMinor": AdministratorFacultyDegreeSemesterDecoder,
      "doctoralMajor": AdministratorFacultyDegreeSemesterDecoder,
      "doctoralMinor": AdministratorFacultyDegreeSemesterDecoder,
      "professionalMajor": AdministratorFacultyDegreeSemesterDecoder,
      "professionalMinor": AdministratorFacultyDegreeSemesterDecoder,
      "bachelorMasterMinor": AdministratorFacultyDegreeSemesterDecoder,
      "bachelorMasterMajor": AdministratorFacultyDegreeSemesterDecoder,
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "deanUser": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(UserDecoder)
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "nameEn": obj.attributes["nameEn"],
      "code": obj.attributes["code"],
      "status": obj.attributes["status"],
      "mail": obj.attributes["mail"],
      "feedbackMail": obj.attributes["feedbackMail"],
      "consultationMail": obj.attributes["consultationMail"],
      "allowInRegistration": obj.attributes["allowInRegistration"],
      "allowInMinorRegistration": obj.attributes["allowInMinorRegistration"],
      "hasMajorMinor": obj.attributes["hasMajorMinor"],
      "bachelorMajor": obj.attributes["bachelorMajor"],
      "bachelorMinor": obj.attributes["bachelorMinor"],
      "masterMajor": obj.attributes["masterMajor"],
      "masterMinor": obj.attributes["masterMinor"],
      "doctoralMajor": obj.attributes["doctoralMajor"],
      "doctoralMinor": obj.attributes["doctoralMinor"],
      "professionalMajor": obj.attributes["professionalMajor"],
      "professionalMinor": obj.attributes["professionalMinor"],
      "bachelorMasterMinor": obj.attributes["bachelorMasterMinor"],
      "bachelorMasterMajor": obj.attributes["bachelorMasterMajor"],
      "deanUser": obj?.relationships?.["deanUser"]?.data,
    }
  })
)

export interface AdministratorDefinitionsDegree {
  readonly "keys": ReadonlyArray<{
    readonly "value": number
    readonly "label": string
  }>
}

export const AdministratorDefinitionsDegreeDecoder: decoders.Decoder<AdministratorDefinitionsDegree> = decoders.object({
  "keys": ArrayObjectDecoder(decoders.object({
    "value": decoders.number,
    "label": decoders.string,
  })),
})

export interface AdministratorDefinitionUser {
  readonly "types": readonly Definitions[]
  readonly "lecturerTypes": readonly Definitions[]
  readonly "administratorTypes": readonly Definitions[]
}

export const AdministratorDefinitionUserDecoder: decoders.Decoder<AdministratorDefinitionUser> = decoders.object({
  "types": ArrayObjectDecoder(DefinitionsDecoder),
  "lecturerTypes": ArrayObjectDecoder(DefinitionsDecoder),
  "administratorTypes": ArrayObjectDecoder(DefinitionsDecoder),
})

export interface AdministratorDefinitionStudent {
  readonly "statuses": readonly Definitions[]
  readonly "semesters": readonly Definitions[]
}

export const AdministratorDefinitionStudentDecoder: decoders.Decoder<AdministratorDefinitionStudent> = decoders.object({
  "statuses": ArrayObjectDecoder(DefinitionsDecoder),
  "semesters": ArrayObjectDecoder(DefinitionsDecoder),
})

export interface ClinicalInternshipReferenceState {
  readonly "eligible": boolean
  readonly "semId": number
}

export const ClinicalInternshipReferenceStateDecoder: decoders.Decoder<ClinicalInternshipReferenceState> = decoders.object({
  "eligible": decoders.boolean,
  "semId": decoders.number,
})

export interface ClinicalInternshipReference {
  readonly "html": null | string
  readonly "data": ClinicalInternshipReferenceState
}

export const ClinicalInternshipReferenceDecoder: decoders.Decoder<ClinicalInternshipReference> = (
  decoders.object({
    attributes: decoders.object({
      "html": decoders.nullable(decoders.string),
      "data": ClinicalInternshipReferenceStateDecoder,
    }),
  })
  .transform(obj => {
    return {
      "html": obj.attributes["html"],
      "data": obj.attributes["data"],
    }
  })
)

export interface AdministratorProgramsListResponse {
  readonly "message": string
  readonly "data": ReadonlyArray<{
    readonly "code": string
    readonly "name": string
  }>
}

export const AdministratorProgramsListResponseDecoder: decoders.Decoder<AdministratorProgramsListResponse> = decoders.object({
  "message": decoders.string,
  "data": ArrayObjectDecoder(decoders.object({
    "code": decoders.string,
    "name": decoders.string,
  })),
})

export interface AdministratorProgram {
  readonly "id": IDString
  readonly "prefix": string
  readonly "code": string
  readonly "name": string
  readonly "nameEn": string
  readonly "fullname": string
  readonly "fullnameEn": string
  readonly "minorFullname": string
  readonly "minorFullnameEn": string
  readonly "direction": string
  readonly "directionEn": string
  readonly "specialty": string
  readonly "specialtyEn": string
  readonly "degree": AdministratorPortfolioDegree
  readonly "facultyId": number
  readonly "facultySchoolId": null | number
  readonly "testtypeId": null | number
  readonly "failsForExpel": null | number
  readonly "credits": null | number
  readonly "hasMajorMinor": number
  readonly "status": number
  readonly "genCredits": number
  readonly "baseCredits": number
  readonly "otherCredits": number
  readonly "allowInRegistration": BooleanEnum
  readonly "allowInMobility": BooleanEnum
  readonly "hasFreeCredits": boolean
  readonly "registrationRequirements": null | string
  readonly "description": null | string
  readonly "descriptionEn": null | string
  readonly "requirementsMajor": null | string
  readonly "requirementsMajorEn": null | string
  readonly "requirementsMinor": null | string
  readonly "requirementsMinorEn": null | string
  readonly "qualificationMajor": null | string
  readonly "qualificationMajorEn": null | string
  readonly "qualificationFields": null | string
  readonly "qualificationFieldsEn": null | string
  readonly "price": null | number
  readonly "creditYears": null | number
  readonly "learningLang": null | string
  readonly "minorDescription": null | string
  readonly "minorDescriptionEn": null | string
  readonly "qualificationCredits": null | number
  readonly "minorGenCredits": null | number
  readonly "minorBaseCredits": null | number
  readonly "minorOtherCredits": null | number
  readonly "languageRestrictionEnabled": boolean
  readonly "showFreeCreditCourses": boolean
  readonly "faculty"?: {
    readonly "data": AdministratorFaculty
  }
  readonly "testTypes"?: readonly TestType[]
}

export const AdministratorProgramDecoder: decoders.Decoder<AdministratorProgram> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "prefix": decoders.string,
      "code": decoders.string,
      "name": decoders.string,
      "nameEn": decoders.string,
      "fullname": decoders.string,
      "fullnameEn": decoders.string,
      "minorFullname": decoders.string,
      "minorFullnameEn": decoders.string,
      "direction": decoders.string,
      "directionEn": decoders.string,
      "specialty": decoders.string,
      "specialtyEn": decoders.string,
      "degree": AdministratorPortfolioDegreeDecoder,
      "facultyId": decoders.number,
      "facultySchoolId": decoders.nullable(decoders.number),
      "testtypeId": decoders.nullable(decoders.number),
      "failsForExpel": decoders.nullable(decoders.number),
      "credits": decoders.nullable(decoders.number),
      "hasMajorMinor": decoders.number,
      "status": decoders.number,
      "genCredits": decoders.number,
      "baseCredits": decoders.number,
      "otherCredits": decoders.number,
      "allowInRegistration": BooleanEnumDecoder,
      "allowInMobility": BooleanEnumDecoder,
      "hasFreeCredits": decoders.boolean,
      "registrationRequirements": decoders.nullable(decoders.string),
      "description": decoders.nullable(decoders.string),
      "descriptionEn": decoders.nullable(decoders.string),
      "requirementsMajor": decoders.nullable(decoders.string),
      "requirementsMajorEn": decoders.nullable(decoders.string),
      "requirementsMinor": decoders.nullable(decoders.string),
      "requirementsMinorEn": decoders.nullable(decoders.string),
      "qualificationMajor": decoders.nullable(decoders.string),
      "qualificationMajorEn": decoders.nullable(decoders.string),
      "qualificationFields": decoders.nullable(decoders.string),
      "qualificationFieldsEn": decoders.nullable(decoders.string),
      "price": decoders.nullable(decoders.number),
      "creditYears": decoders.nullable(decoders.number),
      "learningLang": decoders.nullable(decoders.string),
      "minorDescription": decoders.nullable(decoders.string),
      "minorDescriptionEn": decoders.nullable(decoders.string),
      "qualificationCredits": decoders.nullable(decoders.number),
      "minorGenCredits": decoders.nullable(decoders.number),
      "minorBaseCredits": decoders.nullable(decoders.number),
      "minorOtherCredits": decoders.nullable(decoders.number),
      "languageRestrictionEnabled": decoders.boolean,
      "showFreeCreditCourses": decoders.boolean,
      "faculty": optionalNullableDecoder(decoders.object({
        "data": AdministratorFacultyDecoder,
      })),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "testTypes": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(TestTypeDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "prefix": obj.attributes["prefix"],
      "code": obj.attributes["code"],
      "name": obj.attributes["name"],
      "nameEn": obj.attributes["nameEn"],
      "fullname": obj.attributes["fullname"],
      "fullnameEn": obj.attributes["fullnameEn"],
      "minorFullname": obj.attributes["minorFullname"],
      "minorFullnameEn": obj.attributes["minorFullnameEn"],
      "direction": obj.attributes["direction"],
      "directionEn": obj.attributes["directionEn"],
      "specialty": obj.attributes["specialty"],
      "specialtyEn": obj.attributes["specialtyEn"],
      "degree": obj.attributes["degree"],
      "facultyId": obj.attributes["facultyId"],
      "facultySchoolId": obj.attributes["facultySchoolId"],
      "testtypeId": obj.attributes["testtypeId"],
      "failsForExpel": obj.attributes["failsForExpel"],
      "credits": obj.attributes["credits"],
      "hasMajorMinor": obj.attributes["hasMajorMinor"],
      "status": obj.attributes["status"],
      "genCredits": obj.attributes["genCredits"],
      "baseCredits": obj.attributes["baseCredits"],
      "otherCredits": obj.attributes["otherCredits"],
      "allowInRegistration": obj.attributes["allowInRegistration"],
      "allowInMobility": obj.attributes["allowInMobility"],
      "hasFreeCredits": obj.attributes["hasFreeCredits"],
      "registrationRequirements": obj.attributes["registrationRequirements"],
      "description": obj.attributes["description"],
      "descriptionEn": obj.attributes["descriptionEn"],
      "requirementsMajor": obj.attributes["requirementsMajor"],
      "requirementsMajorEn": obj.attributes["requirementsMajorEn"],
      "requirementsMinor": obj.attributes["requirementsMinor"],
      "requirementsMinorEn": obj.attributes["requirementsMinorEn"],
      "qualificationMajor": obj.attributes["qualificationMajor"],
      "qualificationMajorEn": obj.attributes["qualificationMajorEn"],
      "qualificationFields": obj.attributes["qualificationFields"],
      "qualificationFieldsEn": obj.attributes["qualificationFieldsEn"],
      "price": obj.attributes["price"],
      "creditYears": obj.attributes["creditYears"],
      "learningLang": obj.attributes["learningLang"],
      "minorDescription": obj.attributes["minorDescription"],
      "minorDescriptionEn": obj.attributes["minorDescriptionEn"],
      "qualificationCredits": obj.attributes["qualificationCredits"],
      "minorGenCredits": obj.attributes["minorGenCredits"],
      "minorBaseCredits": obj.attributes["minorBaseCredits"],
      "minorOtherCredits": obj.attributes["minorOtherCredits"],
      "languageRestrictionEnabled": obj.attributes["languageRestrictionEnabled"],
      "showFreeCreditCourses": obj.attributes["showFreeCreditCourses"],
      "faculty": obj.attributes["faculty"],
      "testTypes": obj?.relationships?.["testTypes"]?.data,
    }
  })
)

export interface AdministratorCourseRequirementsResponse {
  readonly "attributes": readonly AdministratorCourseRequirementOrGroup[]
}

export const AdministratorCourseRequirementsResponseDecoder: decoders.Decoder<AdministratorCourseRequirementsResponse> = decoders.object({
  "attributes": ArrayObjectDecoder(decoders.lazy(() => AdministratorCourseRequirementOrGroupDecoder)),
})

export interface AdministratorCourseFacultyRelationshipData {
  readonly "id"?: null | number
  readonly "type"?: string
  readonly "attributes": {
    readonly "id": number
    readonly "name": string
  }
}

export const AdministratorCourseFacultyRelationshipDataDecoder: decoders.Decoder<AdministratorCourseFacultyRelationshipData> = decoders.object({
  "id": optionalNullableDecoder(decoders.nullable(decoders.number)),
  "type": optionalNullableDecoder(decoders.string),
  "attributes": decoders.object({
    "id": decoders.number,
    "name": decoders.string,
  }),
})

export interface AdministratorCourseRequirementCourseRef {
  readonly "id": number
  readonly "code": string
  readonly "name": string
}

export const AdministratorCourseRequirementCourseRefDecoder: decoders.Decoder<AdministratorCourseRequirementCourseRef> = decoders.object({
  "id": decoders.number,
  "code": decoders.string,
  "name": decoders.string,
})

export interface AdministratorCourseRequirementOrGroup {
  readonly "orGroup": number
  readonly "courses": readonly AdministratorCourseRequirementCourseRef[]
}

export const AdministratorCourseRequirementOrGroupDecoder: decoders.Decoder<AdministratorCourseRequirementOrGroup> = decoders.object({
  "orGroup": decoders.number,
  "courses": ArrayObjectDecoder(AdministratorCourseRequirementCourseRefDecoder),
})

export interface AdministratorCourse {
  readonly "id": IDString
  readonly "name": string
  readonly "nameEn": string
  readonly "code": null | string
  readonly "programCode": string
  readonly "status": {
    readonly "value": number
    readonly "name": string
  }
  readonly "degree": {
    readonly "value": number
    readonly "name": string
  }
  readonly "typeId": number
  readonly "type"?: null | number
  readonly "credits": number
  readonly "chooseRegime": boolean
  readonly "userSem": readonly number[]
  readonly "general": number
  readonly "studySem": null | number
  readonly "group_name": string
  readonly "exam_credit_limit": number
  readonly "scoreThresholdMin": number
  readonly "scoreThresholdMax": number
  readonly "failsForExpel": null | number
  readonly "syllabusFileUid"?: null | string
  readonly "primaryLecturerId"?: null | number
  readonly "locale"?: null | string
  readonly "showInFreeCredits"?: null | number
  readonly "facsPrograms"?: ReadonlyArray<{
    readonly "facId": number
    readonly "programs": ReadonlyArray<{
      readonly "id": number
      readonly "name": string
    }>
  }>
  readonly "facs"?: readonly number[]
  readonly "faculty"?: AdministratorCourseFacultyRelationshipData
  readonly "lecturer"?: AdministratorUser
  readonly "primaryLecturer"?: AdministratorCourseGroupLecturer
  readonly "lecturers"?: readonly AdministratorUser[] | AdministratorUser
  readonly "genCodes"?: {
    readonly "attributes": ReadonlyArray<{
      readonly "code": string
      readonly "semesters": null | readonly number[]
    }>
  }
  readonly "baseCodes"?: {
    readonly "attributes": ReadonlyArray<{
      readonly "code": string
      readonly "semesters"?: readonly number[]
    }>
  }
  readonly "otherCodes"?: {
    readonly "attributes": ReadonlyArray<{
      readonly "code": string
      readonly "semesters"?: readonly number[]
    }>
  }
  readonly "requirements"?: {
    readonly "attributes": readonly AdministratorCourseRequirementOrGroup[]
  }
  readonly "corequisites"?: {
    readonly "attributes": readonly AdministratorCourseRequirementOrGroup[]
  }
}

export const AdministratorCourseDecoder: decoders.Decoder<AdministratorCourse> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "nameEn": decoders.string,
      "code": decoders.nullable(decoders.string),
      "programCode": decoders.string,
      "status": decoders.object({
        "value": decoders.number,
        "name": decoders.string,
      }),
      "degree": decoders.object({
        "value": decoders.number,
        "name": decoders.string,
      }),
      "typeId": decoders.number,
      "type": optionalNullableDecoder(decoders.nullable(decoders.number)),
      "credits": decoders.number,
      "chooseRegime": decoders.boolean,
      "userSem": ArrayObjectDecoder(decoders.number),
      "general": decoders.number,
      "studySem": decoders.nullable(decoders.number),
      "group_name": decoders.string,
      "exam_credit_limit": decoders.number,
      "scoreThresholdMin": decoders.number,
      "scoreThresholdMax": decoders.number,
      "failsForExpel": decoders.nullable(decoders.number),
      "syllabusFileUid": optionalNullableDecoder(decoders.nullable(decoders.string)),
      "primaryLecturerId": optionalNullableDecoder(decoders.nullable(decoders.number)),
      "locale": optionalNullableDecoder(decoders.nullable(decoders.string)),
      "showInFreeCredits": optionalNullableDecoder(decoders.nullable(decoders.number)),
      "facsPrograms": optionalNullableDecoder(ArrayObjectDecoder(decoders.object({
        "facId": decoders.number,
        "programs": ArrayObjectDecoder(decoders.object({
          "id": decoders.number,
          "name": decoders.string,
        })),
      }))),
      "facs": optionalNullableDecoder(ArrayObjectDecoder(decoders.number)),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "faculty": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(AdministratorCourseFacultyRelationshipDataDecoder)
      })),
      "lecturer": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(AdministratorUserDecoder)
      })),
      "primaryLecturer": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.lazy(() => AdministratorCourseGroupLecturerDecoder))
      })),
      "lecturers": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.either(
          ArrayObjectDecoder(AdministratorUserDecoder),
          AdministratorUserDecoder
        ))
      })),
      "genCodes": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.object({
          "attributes": ArrayObjectDecoder(decoders.object({
            "code": decoders.string,
            "semesters": decoders.nullable(ArrayObjectDecoder(decoders.number)),
          })),
        }))
      })),
      "baseCodes": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.object({
          "attributes": ArrayObjectDecoder(decoders.object({
            "code": decoders.string,
            "semesters": optionalNullableDecoder(ArrayObjectDecoder(decoders.number)),
          })),
        }))
      })),
      "otherCodes": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.object({
          "attributes": ArrayObjectDecoder(decoders.object({
            "code": decoders.string,
            "semesters": optionalNullableDecoder(ArrayObjectDecoder(decoders.number)),
          })),
        }))
      })),
      "requirements": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.object({
          "attributes": ArrayObjectDecoder(AdministratorCourseRequirementOrGroupDecoder),
        }))
      })),
      "corequisites": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.object({
          "attributes": ArrayObjectDecoder(AdministratorCourseRequirementOrGroupDecoder),
        }))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "nameEn": obj.attributes["nameEn"],
      "code": obj.attributes["code"],
      "programCode": obj.attributes["programCode"],
      "status": obj.attributes["status"],
      "degree": obj.attributes["degree"],
      "typeId": obj.attributes["typeId"],
      "type": obj.attributes["type"],
      "credits": obj.attributes["credits"],
      "chooseRegime": obj.attributes["chooseRegime"],
      "userSem": obj.attributes["userSem"],
      "general": obj.attributes["general"],
      "studySem": obj.attributes["studySem"],
      "group_name": obj.attributes["group_name"],
      "exam_credit_limit": obj.attributes["exam_credit_limit"],
      "scoreThresholdMin": obj.attributes["scoreThresholdMin"],
      "scoreThresholdMax": obj.attributes["scoreThresholdMax"],
      "failsForExpel": obj.attributes["failsForExpel"],
      "syllabusFileUid": obj.attributes["syllabusFileUid"],
      "primaryLecturerId": obj.attributes["primaryLecturerId"],
      "locale": obj.attributes["locale"],
      "showInFreeCredits": obj.attributes["showInFreeCredits"],
      "facsPrograms": obj.attributes["facsPrograms"],
      "facs": obj.attributes["facs"],
      "faculty": obj?.relationships?.["faculty"]?.data,
      "lecturer": obj?.relationships?.["lecturer"]?.data,
      "primaryLecturer": obj?.relationships?.["primaryLecturer"]?.data,
      "lecturers": obj?.relationships?.["lecturers"]?.data,
      "genCodes": obj?.relationships?.["genCodes"]?.data,
      "baseCodes": obj?.relationships?.["baseCodes"]?.data,
      "otherCodes": obj?.relationships?.["otherCodes"]?.data,
      "requirements": obj?.relationships?.["requirements"]?.data,
      "corequisites": obj?.relationships?.["corequisites"]?.data,
    }
  })
)

export interface AdministratorListsType {
  readonly "id": number
  readonly "name": string
}

export const AdministratorListsTypeDecoder: decoders.Decoder<AdministratorListsType> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
})

export interface AdministratorCourseDefinition {
  readonly "degrees": readonly Definitions[]
  readonly "statuses": readonly Definitions[]
}

export const AdministratorCourseDefinitionDecoder: decoders.Decoder<AdministratorCourseDefinition> = decoders.object({
  "degrees": ArrayObjectDecoder(DefinitionsDecoder),
  "statuses": ArrayObjectDecoder(DefinitionsDecoder),
})

export interface AdministratorCourseDefaults {
  readonly "examCreditLimit": number
  readonly "scoreThresholdMin": number
  readonly "scoreThresholdMax": number
}

export const AdministratorCourseDefaultsDecoder: decoders.Decoder<AdministratorCourseDefaults> = decoders.object({
  "examCreditLimit": decoders.number,
  "scoreThresholdMin": decoders.number,
  "scoreThresholdMax": decoders.number,
})

export interface AdministratorCourseDefaultsResponse {
  readonly "data": AdministratorCourseDefaults
}

export const AdministratorCourseDefaultsResponseDecoder: decoders.Decoder<AdministratorCourseDefaultsResponse> = decoders.object({
  "data": AdministratorCourseDefaultsDecoder,
})

export interface AdministratorCreditTypesListResponse {
  readonly "data": readonly AdministratorListsType[]
}

export const AdministratorCreditTypesListResponseDecoder: decoders.Decoder<AdministratorCreditTypesListResponse> = decoders.object({
  "data": ArrayObjectDecoder(AdministratorListsTypeDecoder),
})

export interface AdministratorListsScoreOptionsResponse {
  readonly "data": {
    readonly "doctoral": readonly AdministratorListsType[]
    readonly "passFail": readonly AdministratorListsType[]
  }
}

export const AdministratorListsScoreOptionsResponseDecoder: decoders.Decoder<AdministratorListsScoreOptionsResponse> = decoders.object({
  "data": decoders.object({
    "doctoral": ArrayObjectDecoder(AdministratorListsTypeDecoder),
    "passFail": ArrayObjectDecoder(AdministratorListsTypeDecoder),
  }),
})

export interface AdministratorListsHoursResponse {
  readonly "data": readonly AdministratorCourseGroupScheduleHour[]
}

export const AdministratorListsHoursResponseDecoder: decoders.Decoder<AdministratorListsHoursResponse> = decoders.object({
  "data": ArrayObjectDecoder(decoders.lazy(() => AdministratorCourseGroupScheduleHourDecoder)),
})

export interface AdministratorListsLectureTypesResponse {
  readonly "data": readonly AdministratorListsType[]
}

export const AdministratorListsLectureTypesResponseDecoder: decoders.Decoder<AdministratorListsLectureTypesResponse> = decoders.object({
  "data": ArrayObjectDecoder(AdministratorListsTypeDecoder),
})

export interface AdministratorListsFacultiesResponse {
  readonly "data": readonly AdministratorListsType[]
}

export const AdministratorListsFacultiesResponseDecoder: decoders.Decoder<AdministratorListsFacultiesResponse> = decoders.object({
  "data": ArrayObjectDecoder(AdministratorListsTypeDecoder),
})

export interface AdministratorListsCoursesResponse {
  readonly "data": readonly AdministratorListsType[]
}

export const AdministratorListsCoursesResponseDecoder: decoders.Decoder<AdministratorListsCoursesResponse> = decoders.object({
  "data": ArrayObjectDecoder(AdministratorListsTypeDecoder),
})

export interface AdministratorListsGroupNamesResponse {
  readonly "data": readonly string[]
}

export const AdministratorListsGroupNamesResponseDecoder: decoders.Decoder<AdministratorListsGroupNamesResponse> = decoders.object({
  "data": ArrayObjectDecoder(decoders.string),
})

export interface AdministratorListsBuildingsResponse {
  readonly "data": readonly AdministratorListsType[]
}

export const AdministratorListsBuildingsResponseDecoder: decoders.Decoder<AdministratorListsBuildingsResponse> = decoders.object({
  "data": ArrayObjectDecoder(AdministratorListsTypeDecoder),
})

export interface AdministratorListsRoomsResponse {
  readonly "data": readonly AdministratorListsType[]
}

export const AdministratorListsRoomsResponseDecoder: decoders.Decoder<AdministratorListsRoomsResponse> = decoders.object({
  "data": ArrayObjectDecoder(AdministratorListsTypeDecoder),
})

export interface AdministratorListsLectureFormatsResponse {
  readonly "data": readonly AdministratorListsType[]
}

export const AdministratorListsLectureFormatsResponseDecoder: decoders.Decoder<AdministratorListsLectureFormatsResponse> = decoders.object({
  "data": ArrayObjectDecoder(AdministratorListsTypeDecoder),
})

export interface AdministratorListsScheduleLocationsResponse {
  readonly "data": ReadonlyArray<{
    readonly "id": number
    readonly "title": string
  }>
}

export const AdministratorListsScheduleLocationsResponseDecoder: decoders.Decoder<AdministratorListsScheduleLocationsResponse> = decoders.object({
  "data": ArrayObjectDecoder(decoders.object({
    "id": decoders.number,
    "title": decoders.string,
  })),
})

export type AdministratorListsLearningWeek = {
  readonly "date": string
  readonly "label": string
  readonly "isExam": boolean
  readonly "kind": "learning" | "exam"
  readonly "weekNumber": number
  readonly "weekLabel": string
}

export const AdministratorListsLearningWeekDecoder: decoders.Decoder<AdministratorListsLearningWeek> = (
  decoders.object({
    date: decoders.string,
    label: optionalNullableDecoder(decoders.string),
    weekLabel: optionalNullableDecoder(decoders.string),
    isExam: optionalNullableDecoder(decoders.boolean),
    kind: optionalNullableDecoder(
      decoders.either(
        decoders.constant("learning" as const),
        decoders.constant("exam" as const),
        decoders.string,
        decoders.number
      )
    ),
    weekNumber: optionalNullableDecoder(decoders.number),
  }).transform(obj => {
    const weekLabel = (obj.weekLabel ?? obj.label ?? obj.date).trim()
    const label = (obj.label ?? weekLabel).trim()
    const kindValue = obj.kind
    const kind =
      kindValue === "exam" || kindValue === 2 || kindValue === "2" ? ("exam" as const) : ("learning" as const)
    return {
      date: obj.date,
      label,
      weekLabel,
      isExam: obj.isExam ?? false,
      kind,
      weekNumber: obj.weekNumber ?? 0,
    }
  })
)

export interface AdministratorListsScoreCriteriasResponse {
  readonly "data": readonly AdministratorListsType[]
}

export const AdministratorListsScoreCriteriasResponseDecoder: decoders.Decoder<AdministratorListsScoreCriteriasResponse> = decoders.object({
  "data": ArrayObjectDecoder(AdministratorListsTypeDecoder),
})

export interface AdministratorListsLecturerItem {
  readonly "id": number
  readonly "name": string
  readonly "email"?: null | string
  readonly "persNum"?: null | string
}

export const AdministratorListsLecturerItemDecoder: decoders.Decoder<AdministratorListsLecturerItem> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
  "email": optionalNullableDecoder(decoders.nullable(decoders.string)),
  "persNum": optionalNullableDecoder(decoders.nullable(decoders.string)),
})

export interface AdministratorListsLecturer {
  readonly "message"?: string
  readonly "data": readonly AdministratorListsLecturerItem[]
}

export const AdministratorListsLecturerDecoder: decoders.Decoder<AdministratorListsLecturer> = decoders.object({
  "message": optionalNullableDecoder(decoders.string),
  "data": ArrayObjectDecoder(AdministratorListsLecturerItemDecoder),
})

export interface AdministratorListsGroupDurations {
  readonly "learningDurations": readonly number[]
  readonly "examDurations": readonly number[]
}

export const AdministratorListsGroupDurationsDecoder: decoders.Decoder<AdministratorListsGroupDurations> = decoders.object({
  "learningDurations": ArrayObjectDecoder(decoders.number),
  "examDurations": ArrayObjectDecoder(decoders.number),
})

export interface AdministratorCourseGroupLecturer {
  readonly "id": IDString
  readonly "firstName": string
  readonly "lastName": string
  readonly "fullName": string
  readonly "userId"?: IDString
  readonly "profileId"?: IDString
  readonly "email"?: null | string
  readonly "photoUrl"?: null | string
  readonly "avatar"?: string
  readonly "degree"?: null | string
  readonly "personalNumber"?: null | string
}

export const AdministratorCourseGroupLecturerDecoder: decoders.Decoder<AdministratorCourseGroupLecturer> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "firstName": decoders.string,
      "lastName": decoders.string,
      "fullName": decoders.string,
      "userId": optionalNullableDecoder(IDStringDecoder),
      "profileId": optionalNullableDecoder(IDStringDecoder),
      "email": optionalNullableDecoder(decoders.nullable(decoders.string)),
      "photoUrl": optionalNullableDecoder(decoders.nullable(decoders.string)),
      "avatar": optionalNullableDecoder(decoders.string),
      "degree": optionalNullableDecoder(decoders.nullable(decoders.string)),
      "personalNumber": optionalNullableDecoder(decoders.nullable(decoders.string)),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "firstName": obj.attributes["firstName"],
      "lastName": obj.attributes["lastName"],
      "fullName": obj.attributes["fullName"],
      "userId": obj.attributes["userId"],
      "profileId": obj.attributes["profileId"],
      "email": obj.attributes["email"],
      "photoUrl": obj.attributes["photoUrl"],
      "avatar": obj.attributes["avatar"],
      "degree": obj.attributes["degree"],
      "personalNumber": obj.attributes["personalNumber"],
    }
  })
)

export interface AdministratorCourseGroupItem {
  readonly "id": IDString
  readonly "name": string
  readonly "quotaMin": number
  readonly "quotaMax": number
  readonly "learningDuration": number
  readonly "examDuration": number
  readonly "allowInSems"?: readonly number[]
  readonly "studentCount"?: null | number
  readonly "passedCount"?: null | number
  readonly "failedCount"?: null | number
  readonly "lecturers"?: readonly AdministratorCourseGroupLecturer[]
}

export const AdministratorCourseGroupItemDecoder: decoders.Decoder<AdministratorCourseGroupItem> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "name": decoders.string,
      "quotaMin": decoders.number,
      "quotaMax": decoders.number,
      "learningDuration": decoders.number,
      "examDuration": decoders.number,
      "allowInSems": optionalNullableDecoder(ArrayObjectDecoder(decoders.number)),
      "studentCount": optionalNullableDecoder(decoders.nullable(decoders.number)),
      "passedCount": optionalNullableDecoder(decoders.nullable(decoders.number)),
      "failedCount": optionalNullableDecoder(decoders.nullable(decoders.number)),
    }),
    relationships: optionalNullableDecoder(decoders.object({
      "lecturers": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(ArrayObjectDecoder(AdministratorCourseGroupLecturerDecoder))
      })),
    })),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "name": obj.attributes["name"],
      "quotaMin": obj.attributes["quotaMin"],
      "quotaMax": obj.attributes["quotaMax"],
      "learningDuration": obj.attributes["learningDuration"],
      "examDuration": obj.attributes["examDuration"],
      "allowInSems": obj.attributes["allowInSems"],
      "studentCount": obj.attributes["studentCount"],
      "passedCount": obj.attributes["passedCount"],
      "failedCount": obj.attributes["failedCount"],
      "lecturers": obj?.relationships?.["lecturers"]?.data,
    }
  })
)

export type PaperScoresByCriteria = Readonly<Record<string, number>>

export const PaperScoresByCriteriaDecoder: decoders.Decoder<PaperScoresByCriteria> = decoders.either(decoders.record(decoders.number), decoders.array(decoders.unknown).transform(() => ({})))

export interface AdministratorCoursePaperLecturer {
  readonly "id": number
  readonly "name": string
}

export const AdministratorCoursePaperLecturerDecoder: decoders.Decoder<AdministratorCoursePaperLecturer> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
})

export interface AdministratorCoursePaperSummary {
  readonly "id": number
  readonly "status": number
  readonly "isActive": boolean
  readonly "intermediateScoreLimit": number
}

export const AdministratorCoursePaperSummaryDecoder: decoders.Decoder<AdministratorCoursePaperSummary> = decoders.object({
  "id": decoders.number,
  "status": decoders.number,
  "isActive": decoders.boolean,
  "intermediateScoreLimit": decoders.number,
})

export interface AdministratorCourseScoresGroup {
  readonly "id": number
  readonly "name": string
  readonly "studentCount": number
  readonly "lecturers": readonly AdministratorCoursePaperLecturer[]
  readonly "paper": null | AdministratorCoursePaperSummary
}

export const AdministratorCourseScoresGroupDecoder: decoders.Decoder<AdministratorCourseScoresGroup> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
  "studentCount": decoders.number,
  "lecturers": ArrayObjectDecoder(AdministratorCoursePaperLecturerDecoder),
  "paper": decoders.nullable(AdministratorCoursePaperSummaryDecoder),
})

export interface AdministratorPaperCriteria {
  readonly "id": number
  readonly "name": string
  readonly "acr": string
  readonly "type": number
  readonly "min": number
  readonly "max": number
  readonly "deadline": null | string
}

export const AdministratorPaperCriteriaDecoder: decoders.Decoder<AdministratorPaperCriteria> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
  "acr": decoders.string,
  "type": decoders.number,
  "min": decoders.number,
  "max": decoders.number,
  "deadline": decoders.nullable(decoders.string),
})

export interface AdministratorPaperWithCriterias {
  readonly "id": number
  readonly "status": number
  readonly "isActive": boolean
  readonly "intermediateScoreLimit": number
  readonly "criterias": readonly AdministratorPaperCriteria[]
}

export const AdministratorPaperWithCriteriasDecoder: decoders.Decoder<AdministratorPaperWithCriterias> = decoders.object({
  "id": decoders.number,
  "status": decoders.number,
  "isActive": decoders.boolean,
  "intermediateScoreLimit": decoders.number,
  "criterias": ArrayObjectDecoder(AdministratorPaperCriteriaDecoder),
})

export interface AdministratorPaperScoreStudent {
  readonly "studId": number
  readonly "userId": number
  readonly "name": string
  readonly "persNum": string
  readonly "finalScore": number
  readonly "credits": number
  readonly "scores": PaperScoresByCriteria
}

export const AdministratorPaperScoreStudentDecoder: decoders.Decoder<AdministratorPaperScoreStudent> = decoders.object({
  "studId": decoders.number,
  "userId": decoders.number,
  "name": decoders.string,
  "persNum": decoders.string,
  "finalScore": decoders.number,
  "credits": decoders.number,
  "scores": PaperScoresByCriteriaDecoder,
})

export interface AdministratorCourseGroupScores {
  readonly "paper": null | AdministratorPaperWithCriterias
  readonly "students": readonly AdministratorPaperScoreStudent[]
}

export const AdministratorCourseGroupScoresDecoder: decoders.Decoder<AdministratorCourseGroupScores> = decoders.object({
  "paper": decoders.nullable(AdministratorPaperWithCriteriasDecoder),
  "students": ArrayObjectDecoder(AdministratorPaperScoreStudentDecoder),
})

export interface AdministratorPaperAvailableCriteria {
  readonly "id": number
  readonly "name": string
  readonly "acr": string
  readonly "type": number
  readonly "maxPossible": number
}

export const AdministratorPaperAvailableCriteriaDecoder: decoders.Decoder<AdministratorPaperAvailableCriteria> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
  "acr": decoders.string,
  "type": decoders.number,
  "maxPossible": decoders.number,
})

export interface AdministratorCourseGroupCriterias {
  readonly "paper": null | AdministratorPaperWithCriterias
  readonly "availableCriterias": readonly AdministratorPaperAvailableCriteria[]
}

export const AdministratorCourseGroupCriteriasDecoder: decoders.Decoder<AdministratorCourseGroupCriterias> = decoders.object({
  "paper": decoders.nullable(AdministratorPaperWithCriteriasDecoder),
  "availableCriterias": ArrayObjectDecoder(AdministratorPaperAvailableCriteriaDecoder),
})

export interface AdministratorPaperStatus {
  readonly "status": number
  readonly "isActive": boolean
}

export const AdministratorPaperStatusDecoder: decoders.Decoder<AdministratorPaperStatus> = decoders.object({
  "status": decoders.number,
  "isActive": decoders.boolean,
})

export interface AdministratorPaperCard {
  readonly "id": number
  readonly "title": null | string
  readonly "text": null | string
  readonly "date": null | string
  readonly "userId": null | number
}

export const AdministratorPaperCardDecoder: decoders.Decoder<AdministratorPaperCard> = decoders.object({
  "id": decoders.number,
  "title": decoders.nullable(decoders.string),
  "text": decoders.nullable(decoders.string),
  "date": decoders.nullable(decoders.string),
  "userId": decoders.nullable(decoders.number),
})

export interface AdministratorCourseStudentUserRef {
  readonly "id": number
  readonly "fullName": string
  readonly "persNum": string
}

export const AdministratorCourseStudentUserRefDecoder: decoders.Decoder<AdministratorCourseStudentUserRef> = (
  decoders.object({
    attributes: decoders.object({
      "id": decoders.number,
      "fullName": decoders.string,
      "persNum": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj.attributes["id"],
      "fullName": obj.attributes["fullName"],
      "persNum": obj.attributes["persNum"],
    }
  })
)

export interface AdministratorCourseStudentChoice {
  readonly "id": IDString
  readonly "uid": string
  readonly "userId": number
  readonly "studId": number
  readonly "groupId": null | number
  readonly "score": null | number
  readonly "status": ChoiceStatusEnum
  readonly "couNameEn": string
  readonly "createdAt": string
  readonly "chooserUserId": number
  readonly "chooserFullName": null | string
  readonly "user": AdministratorCourseStudentUserRef
}

export const AdministratorCourseStudentChoiceDecoder: decoders.Decoder<AdministratorCourseStudentChoice> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "uid": decoders.string,
      "userId": decoders.number,
      "studId": decoders.number,
      "groupId": decoders.nullable(decoders.number),
      "score": decoders.nullable(decoders.number),
      "status": ChoiceStatusEnumDecoder,
      "couNameEn": decoders.string,
      "createdAt": decoders.string,
      "chooserUserId": decoders.number,
      "chooserFullName": decoders.nullable(decoders.string),
    }),
    relationships: decoders.object({
      "user": decoders.object({
        data: AdministratorCourseStudentUserRefDecoder
      }),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "uid": obj.attributes["uid"],
      "userId": obj.attributes["userId"],
      "studId": obj.attributes["studId"],
      "groupId": obj.attributes["groupId"],
      "score": obj.attributes["score"],
      "status": obj.attributes["status"],
      "couNameEn": obj.attributes["couNameEn"],
      "createdAt": obj.attributes["createdAt"],
      "chooserUserId": obj.attributes["chooserUserId"],
      "chooserFullName": obj.attributes["chooserFullName"],
      "user": obj.relationships["user"].data,
    }
  })
)

export interface AdministratorCourseGroupScheduleLecturer {
  readonly "userId": IDString
  readonly "profileId": IDString
  readonly "isPaid"?: boolean
}

export const AdministratorCourseGroupScheduleLecturerDecoder: decoders.Decoder<AdministratorCourseGroupScheduleLecturer> = decoders.object({
  "userId": IDStringDecoder,
  "profileId": IDStringDecoder,
  "isPaid": optionalNullableDecoder(decoders.boolean),
})

export interface AdministratorCourseGroupScheduleHour {
  readonly "id": number
  readonly "name": string
  readonly "day": number
  readonly "startTime": string
  readonly "endTime": string
}

export const AdministratorCourseGroupScheduleHourDecoder: decoders.Decoder<AdministratorCourseGroupScheduleHour> = (
  decoders.object({
    attributes: decoders.object({
      "id": decoders.number,
      "name": decoders.string,
      "day": decoders.number,
      "startTime": decoders.string,
      "endTime": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj.attributes["id"],
      "name": obj.attributes["name"],
      "day": obj.attributes["day"],
      "startTime": obj.attributes["startTime"],
      "endTime": obj.attributes["endTime"],
    }
  })
)

export interface AdministratorCourseGroupScheduleLectureType {
  readonly "id": number
  readonly "name": string
}

export const AdministratorCourseGroupScheduleLectureTypeDecoder: decoders.Decoder<AdministratorCourseGroupScheduleLectureType> = (
  decoders.object({
    attributes: decoders.object({
      "id": decoders.number,
      "name": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj.attributes["id"],
      "name": obj.attributes["name"],
    }
  })
)

export interface AdministratorCourseGroupScheduleLectureFormat {
  readonly "id": number
  readonly "name": string
}

export const AdministratorCourseGroupScheduleLectureFormatDecoder: decoders.Decoder<AdministratorCourseGroupScheduleLectureFormat> = (
  decoders.object({
    attributes: decoders.object({
      "id": decoders.number,
      "name": decoders.string,
    }),
  })
  .transform(obj => {
    return {
      "id": obj.attributes["id"],
      "name": obj.attributes["name"],
    }
  })
)

export type AdministratorCourseGroupScheduleBuilding = {
  readonly "id": number
  readonly "name": string
} | null

export const AdministratorCourseGroupScheduleBuildingDecoder: decoders.Decoder<AdministratorCourseGroupScheduleBuilding> = (
  decoders.object({
    attributes: optionalNullableDecoder(decoders.either(
      decoders.object({
        "id": decoders.number,
        "name": decoders.string,
      }),
      decoders.array(decoders.unknown),
    )),
    id: optionalNullableDecoder(decoders.either(decoders.number, decoders.string)),
    type: optionalNullableDecoder(decoders.string),
  }).transform(obj => {
    if (obj.attributes != null && !Array.isArray(obj.attributes)) {
      return {
        id: obj.attributes.id,
        name: obj.attributes.name,
      }
    }
    if (obj.id != null && obj.id !== '') {
      return {
        id: Number(obj.id),
        name: '',
      }
    }
    return null
  })
)

export type AdministratorCourseGroupScheduleRoom = {
  readonly "id": number
  readonly "name": string
} | null

export const AdministratorCourseGroupScheduleRoomDecoder: decoders.Decoder<AdministratorCourseGroupScheduleRoom> = (
  decoders.object({
    attributes: optionalNullableDecoder(decoders.either(
      decoders.object({
        "id": decoders.number,
        "name": decoders.string,
      }),
      decoders.array(decoders.unknown),
    )),
    id: optionalNullableDecoder(decoders.either(decoders.number, decoders.string)),
    type: optionalNullableDecoder(decoders.string),
  }).transform(obj => {
    if (obj.attributes != null && !Array.isArray(obj.attributes)) {
      return {
        id: obj.attributes.id,
        name: obj.attributes.name,
      }
    }
    if (obj.id != null && obj.id !== '') {
      return {
        id: Number(obj.id),
        name: '',
      }
    }
    return null
  })
)

export type AdministratorCourseGroupScheduleLocation = { readonly "id": null | IDString; readonly "title": null | string }

export const AdministratorCourseGroupScheduleLocationDecoder: decoders.Decoder<AdministratorCourseGroupScheduleLocation> = (
  decoders.object({
    id: optionalNullableDecoder(decoders.either(decoders.number, decoders.string)),
    type: optionalNullableDecoder(decoders.string),
    attributes: optionalNullableDecoder(decoders.either(
      decoders.object({
        "id": optionalNullableDecoder(decoders.either(decoders.number, decoders.string)),
        "title": optionalNullableDecoder(decoders.string),
      }),
      decoders.array(decoders.unknown),
    )),
  }).transform(obj => {
    if (obj.attributes != null && !Array.isArray(obj.attributes) && obj.attributes.id != null) {
      return { id: obj.attributes.id.toString(), title: (obj.attributes as { title?: string | null }).title ?? null }
    }
    if (obj.id != null && obj.id !== '') {
      return { id: obj.id.toString(), title: null }
    }
    return { id: null, title: null }
  })
)

export interface AdministratorCourseGroupScheduleLecturerItem {
  readonly "userId": IDString
  readonly "profileId": IDString
  readonly "name": string
  readonly "isPaid"?: boolean
}

export const AdministratorCourseGroupScheduleLecturerItemDecoder: decoders.Decoder<AdministratorCourseGroupScheduleLecturerItem> = decoders.object({
  "userId": IDStringDecoder,
  "profileId": IDStringDecoder,
  "name": decoders.string,
  "isPaid": optionalNullableDecoder(decoders.boolean),
})

export type AdministratorCourseGroupScheduleLecturersArray = ReadonlyArray<AdministratorCourseGroupScheduleLecturerItem>

export const AdministratorCourseGroupScheduleLecturersArrayDecoder: decoders.Decoder<AdministratorCourseGroupScheduleLecturersArray> = (
  decoders.object({
    id: optionalNullableDecoder(decoders.either(decoders.number, decoders.string)),
    type: optionalNullableDecoder(decoders.string),
    attributes: decoders.array(AdministratorCourseGroupScheduleLecturerItemDecoder),
  }).transform(obj => obj.attributes)
)

export interface AdministratorCourseGroupScheduleDuplicateItem {
  readonly "date": string
  readonly "courseName": Stringable
  readonly "groupName": Stringable
}

export const AdministratorCourseGroupScheduleDuplicateItemDecoder: decoders.Decoder<AdministratorCourseGroupScheduleDuplicateItem> = decoders.object({
  "date": decoders.string,
  "courseName": StringableDecoder,
  "groupName": StringableDecoder,
})

export type AdministratorCourseGroupScheduleDuplicatesArray = ReadonlyArray<AdministratorCourseGroupScheduleDuplicateItem>

export const AdministratorCourseGroupScheduleDuplicatesArrayDecoder: decoders.Decoder<AdministratorCourseGroupScheduleDuplicatesArray> = (
  decoders.object({
    id: optionalNullableDecoder(decoders.either(decoders.number, decoders.string)),
    type: optionalNullableDecoder(decoders.string),
    attributes: decoders.array(AdministratorCourseGroupScheduleDuplicateItemDecoder),
  }).transform(obj => obj.attributes)
)

export interface AdministratorCourseGroupSchedule {
  readonly "id": IDString
  readonly "date": string
  readonly "locationType"?: null | number
  readonly "info"?: null | string
  readonly "isHalfHour"?: boolean
  readonly "isSplitLecture"?: boolean
  readonly "hour": AdministratorCourseGroupScheduleHour
  readonly "lectureType": AdministratorCourseGroupScheduleLectureType
  readonly "lectureFormat": AdministratorCourseGroupScheduleLectureFormat
  readonly "building"?: null | AdministratorCourseGroupScheduleBuilding
  readonly "room"?: null | AdministratorCourseGroupScheduleRoom
  readonly "location"?: null | AdministratorCourseGroupScheduleLocation
  readonly "lecturers"?: AdministratorCourseGroupScheduleLecturersArray
  readonly "duplicates"?: AdministratorCourseGroupScheduleDuplicatesArray
}

export const AdministratorCourseGroupScheduleDecoder: decoders.Decoder<AdministratorCourseGroupSchedule> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "date": decoders.string,
      "locationType": optionalNullableDecoder(decoders.nullable(decoders.number)),
      "info": optionalNullableDecoder(decoders.nullable(decoders.string)),
      "isHalfHour": optionalNullableDecoder(decoders.boolean),
      "isSplitLecture": optionalNullableDecoder(decoders.boolean),
    }),
    relationships: decoders.object({
      "hour": decoders.object({
        data: decoders.lazy(() => AdministratorCourseGroupScheduleHourDecoder)
      }),
      "lectureType": decoders.object({
        data: AdministratorCourseGroupScheduleLectureTypeDecoder
      }),
      "lectureFormat": decoders.object({
        data: AdministratorCourseGroupScheduleLectureFormatDecoder
      }),
      "building": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.nullable(AdministratorCourseGroupScheduleBuildingDecoder))
      })),
      "room": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.nullable(AdministratorCourseGroupScheduleRoomDecoder))
      })),
      "location": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(decoders.nullable(AdministratorCourseGroupScheduleLocationDecoder))
      })),
      "lecturers": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(AdministratorCourseGroupScheduleLecturersArrayDecoder)
      })),
      "duplicates": optionalNullableDecoder(decoders.object({
        data: optionalNullableDecoder(AdministratorCourseGroupScheduleDuplicatesArrayDecoder)
      })),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "date": obj.attributes["date"],
      "locationType": obj.attributes["locationType"],
      "info": obj.attributes["info"],
      "isHalfHour": obj.attributes["isHalfHour"],
      "isSplitLecture": obj.attributes["isSplitLecture"],
      "hour": obj.relationships["hour"].data,
      "lectureType": obj.relationships["lectureType"].data,
      "lectureFormat": obj.relationships["lectureFormat"].data,
      "building": obj?.relationships?.["building"]?.data,
      "room": obj?.relationships?.["room"]?.data,
      "location": obj?.relationships?.["location"]?.data,
      "lecturers": obj?.relationships?.["lecturers"]?.data,
      "duplicates": obj?.relationships?.["duplicates"]?.data,
    }
  })
)

export type AdministratorCourseGroupScheduleConflictNotice = {
  readonly "type": string
  readonly "message": string
  readonly "messages": readonly string[]
}

export const AdministratorCourseGroupScheduleConflictNoticeDecoder: decoders.Decoder<AdministratorCourseGroupScheduleConflictNotice> = decoders.object({
      "type": decoders.string,
      "message": decoders.string,
      "messages": decoders.array(decoders.string),
    })

export type AdministratorCourseGroupScheduleConflictsDetected = {
  readonly "type": "ScheduleConflictsDetected"
  readonly "message": string
  readonly "conflicts": readonly AdministratorCourseGroupScheduleConflictNotice[]
}

export const AdministratorCourseGroupScheduleConflictsDetectedDecoder: decoders.Decoder<AdministratorCourseGroupScheduleConflictsDetected> = decoders.either(
      decoders.object({
        "message": decoders.string,
        "conflicts": decoders.array(AdministratorCourseGroupScheduleConflictNoticeDecoder),
      }).transform(obj => ({
        type: "ScheduleConflictsDetected" as const,
        message: obj.message,
        conflicts: obj.conflicts,
      })),
      decoders.array(AdministratorCourseGroupScheduleConflictNoticeDecoder).transform(arr => ({
        type: "ScheduleConflictsDetected" as const,
        message: "conflicts_detected",
        conflicts: arr,
      }))
    )

export interface AdministratorCourseGroupScheduleConflict {
  readonly "id": IDString
  readonly "date": string
  readonly "info"?: null | string
}

export const AdministratorCourseGroupScheduleConflictDecoder: decoders.Decoder<AdministratorCourseGroupScheduleConflict> = (
  decoders.object({
    "id": IDStringDecoder,
    attributes: decoders.object({
      "date": decoders.string,
      "info": optionalNullableDecoder(decoders.nullable(decoders.string)),
    }),
  })
  .transform(obj => {
    return {
      "id": obj["id"],
      "date": obj.attributes["date"],
      "info": obj.attributes["info"],
    }
  })
)

export type AdministratorCourseGroupScheduleConflictResult = {
  readonly "hasConflicts": boolean
  readonly "results": Readonly<Record<string, Readonly<Record<string, { readonly "hasConflicts": boolean; readonly "conflicts": readonly AdministratorCourseGroupScheduleConflictNotice[] }>>>>
}

export const AdministratorCourseGroupScheduleConflictResultDecoder: decoders.Decoder<AdministratorCourseGroupScheduleConflictResult> = decoders.object({
    "hasConflicts": decoders.boolean,
    "results": decoders.unknown.transform(data => data as Record<string, Record<string, { hasConflicts: boolean; conflicts: AdministratorCourseGroupScheduleConflictNotice[] }>>),
  })

export interface AdministratorCourseGroupScheduleMassUpdateResult {
  readonly "updatedCount": number
}

export const AdministratorCourseGroupScheduleMassUpdateResultDecoder: decoders.Decoder<AdministratorCourseGroupScheduleMassUpdateResult> = decoders.object({
  "updatedCount": decoders.number,
})

export interface AdministratorCourseGroupScheduleMassDeleteResult {
  readonly "deletedCount": number
}

export const AdministratorCourseGroupScheduleMassDeleteResultDecoder: decoders.Decoder<AdministratorCourseGroupScheduleMassDeleteResult> = decoders.object({
  "deletedCount": decoders.number,
})

export type AdministratorCourseGroupAvailableLecturer = {
  readonly "userId": IDString
  readonly "profileId": IDString
  readonly "name": string
  readonly "personalNumber": string
  readonly "degree"?: number | string | null
}

export const AdministratorCourseGroupAvailableLecturerDecoder: decoders.Decoder<AdministratorCourseGroupAvailableLecturer> = decoders.object({
    "userId": IDStringDecoder,
    "profileId": IDStringDecoder,
    "name": decoders.string,
    "persNum": decoders.string,
    "degree": optionalNullableDecoder(decoders.number),
  }).transform((obj) => ({
    userId: obj.userId,
    profileId: obj.profileId,
    name: obj.name,
    personalNumber: obj.persNum,
    degree: obj.degree,
  }))

export interface AdministratorSchedulesGridDate {
  readonly "date": string
  readonly "dayOfWeek": number
  readonly "weekNumber": number
  readonly "isExam": boolean
}

export const AdministratorSchedulesGridDateDecoder: decoders.Decoder<AdministratorSchedulesGridDate> = decoders.object({
  "date": decoders.string,
  "dayOfWeek": decoders.number,
  "weekNumber": decoders.number,
  "isExam": decoders.boolean,
})

export interface AdministratorSchedulesGridHour {
  readonly "id": number
  readonly "name": string
  readonly "day": number
  readonly "startTime": string
  readonly "endTime": string
}

export const AdministratorSchedulesGridHourDecoder: decoders.Decoder<AdministratorSchedulesGridHour> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
  "day": decoders.number,
  "startTime": decoders.string,
  "endTime": decoders.string,
})

export interface AdministratorSchedulesGridRoom {
  readonly "id": number
  readonly "name": string
  readonly "places": number
  readonly "facId"?: null | number
  readonly "hasComputer": boolean
  readonly "hasProjector": boolean
  readonly "hasCamera": boolean
}

export const AdministratorSchedulesGridRoomDecoder: decoders.Decoder<AdministratorSchedulesGridRoom> = decoders.object({
  "id": decoders.number,
  "name": decoders.string,
  "places": decoders.number,
  "facId": optionalNullableDecoder(decoders.nullable(decoders.number)),
  "hasComputer": decoders.boolean,
  "hasProjector": decoders.boolean,
  "hasCamera": decoders.boolean,
})

export interface AdministratorSchedulesGridLecturer {
  readonly "userId": number
  readonly "profileId": number
  readonly "name": string
  readonly "isPaid": boolean
}

export const AdministratorSchedulesGridLecturerDecoder: decoders.Decoder<AdministratorSchedulesGridLecturer> = decoders.object({
  "userId": decoders.number,
  "profileId": decoders.number,
  "name": decoders.string,
  "isPaid": decoders.boolean,
})

export interface AdministratorSchedulesGridEntry {
  readonly "scheduleId": number
  readonly "courseId": number
  readonly "courseCode": string
  readonly "courseName": string
  readonly "groupId": number
  readonly "groupName": string
  readonly "lectureType": string
  readonly "lectureFormat": string
  readonly "lecturers": readonly AdministratorSchedulesGridLecturer[]
}

export const AdministratorSchedulesGridEntryDecoder: decoders.Decoder<AdministratorSchedulesGridEntry> = decoders.object({
  "scheduleId": decoders.number,
  "courseId": decoders.number,
  "courseCode": decoders.string,
  "courseName": decoders.string,
  "groupId": decoders.number,
  "groupName": decoders.string,
  "lectureType": decoders.string,
  "lectureFormat": decoders.string,
  "lecturers": ArrayObjectDecoder(AdministratorSchedulesGridLecturerDecoder),
})

export interface AdministratorSchedulesGridConflictCell {
  readonly "date": string
  readonly "hourId": number
  readonly "roomId": number
}

export const AdministratorSchedulesGridConflictCellDecoder: decoders.Decoder<AdministratorSchedulesGridConflictCell> = decoders.object({
  "date": decoders.string,
  "hourId": decoders.number,
  "roomId": decoders.number,
})

export type AdministratorSchedulesGridResponse = {
  readonly "dates": readonly AdministratorSchedulesGridDate[]
  readonly "hours": readonly AdministratorSchedulesGridHour[]
  readonly "rooms": readonly AdministratorSchedulesGridRoom[]
  readonly "cells": Record<string, Record<string, Record<string, readonly AdministratorSchedulesGridEntry[]>>>
  readonly "conflictCells": readonly AdministratorSchedulesGridConflictCell[]
}

export const AdministratorSchedulesGridResponseDecoder: decoders.Decoder<AdministratorSchedulesGridResponse> = decoders.object({
    "dates": decoders.array(AdministratorSchedulesGridDateDecoder),
    "hours": decoders.array(AdministratorSchedulesGridHourDecoder),
    "rooms": decoders.array(AdministratorSchedulesGridRoomDecoder),
    "cells": decoders.unknown.transform(v => v as Record<string, Record<string, Record<string, readonly AdministratorSchedulesGridEntry[]>>>),
    "conflictCells": decoders.array(AdministratorSchedulesGridConflictCellDecoder),
  })

export interface AdministratorListsLearningWeeksScheduleWeek {
  readonly "weekNumber": number
  readonly "date": string
  readonly "isExam": boolean
  readonly "label": string
}

export const AdministratorListsLearningWeeksScheduleWeekDecoder: decoders.Decoder<AdministratorListsLearningWeeksScheduleWeek> = decoders.object({
  "weekNumber": decoders.number,
  "date": decoders.string,
  "isExam": decoders.boolean,
  "label": decoders.string,
})

export interface AdministratorListsLearningWeeksScheduleData {
  readonly "startWeeks": readonly AdministratorListsLearningWeeksScheduleWeek[]
  readonly "endWeeks": readonly AdministratorListsLearningWeeksScheduleWeek[]
}

export const AdministratorListsLearningWeeksScheduleDataDecoder: decoders.Decoder<AdministratorListsLearningWeeksScheduleData> = decoders.object({
  "startWeeks": ArrayObjectDecoder(AdministratorListsLearningWeeksScheduleWeekDecoder),
  "endWeeks": ArrayObjectDecoder(AdministratorListsLearningWeeksScheduleWeekDecoder),
})

export interface AdministratorListsLearningWeeksScheduleResponse {
  readonly "data": AdministratorListsLearningWeeksScheduleData
}

export const AdministratorListsLearningWeeksScheduleResponseDecoder: decoders.Decoder<AdministratorListsLearningWeeksScheduleResponse> = decoders.object({
  "data": AdministratorListsLearningWeeksScheduleDataDecoder,
})
